// @ts-nocheck
/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  BigDecimal: { input: string; output: string; }
  BigInt: { input: string; output: string; }
  Bytes: { input: any; output: any; }
  /**
   * 8 bytes signed integer
   *
   */
  Int8: { input: any; output: any; }
  /**
   * A string representation of microseconds UNIX timestamp (16 digits)
   *
   */
  Timestamp: { input: any; output: any; }
};

export enum Aggregation_Interval {
  Day = 'day',
  Hour = 'hour'
}

export type BlockChangedFilter = {
  number_gte: Scalars['Int']['input'];
};

export type Block_Height = {
  hash?: InputMaybe<Scalars['Bytes']['input']>;
  number?: InputMaybe<Scalars['Int']['input']>;
  number_gte?: InputMaybe<Scalars['Int']['input']>;
};

export type DailyDonation = {
  __typename?: 'DailyDonation';
  donation: Scalars['BigInt']['output'];
  id: Scalars['ID']['output'];
  sqrtPriceX96: Scalars['BigInt']['output'];
  start: Scalars['BigInt']['output'];
  strike: Strike;
};

export type DailyDonation_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<DailyDonation_Filter>>>;
  donation?: InputMaybe<Scalars['BigInt']['input']>;
  donation_gt?: InputMaybe<Scalars['BigInt']['input']>;
  donation_gte?: InputMaybe<Scalars['BigInt']['input']>;
  donation_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  donation_lt?: InputMaybe<Scalars['BigInt']['input']>;
  donation_lte?: InputMaybe<Scalars['BigInt']['input']>;
  donation_not?: InputMaybe<Scalars['BigInt']['input']>;
  donation_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  or?: InputMaybe<Array<InputMaybe<DailyDonation_Filter>>>;
  sqrtPriceX96?: InputMaybe<Scalars['BigInt']['input']>;
  sqrtPriceX96_gt?: InputMaybe<Scalars['BigInt']['input']>;
  sqrtPriceX96_gte?: InputMaybe<Scalars['BigInt']['input']>;
  sqrtPriceX96_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  sqrtPriceX96_lt?: InputMaybe<Scalars['BigInt']['input']>;
  sqrtPriceX96_lte?: InputMaybe<Scalars['BigInt']['input']>;
  sqrtPriceX96_not?: InputMaybe<Scalars['BigInt']['input']>;
  sqrtPriceX96_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  start?: InputMaybe<Scalars['BigInt']['input']>;
  start_gt?: InputMaybe<Scalars['BigInt']['input']>;
  start_gte?: InputMaybe<Scalars['BigInt']['input']>;
  start_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  start_lt?: InputMaybe<Scalars['BigInt']['input']>;
  start_lte?: InputMaybe<Scalars['BigInt']['input']>;
  start_not?: InputMaybe<Scalars['BigInt']['input']>;
  start_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  strike?: InputMaybe<Scalars['String']['input']>;
  strike_?: InputMaybe<Strike_Filter>;
  strike_contains?: InputMaybe<Scalars['String']['input']>;
  strike_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  strike_ends_with?: InputMaybe<Scalars['String']['input']>;
  strike_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  strike_gt?: InputMaybe<Scalars['String']['input']>;
  strike_gte?: InputMaybe<Scalars['String']['input']>;
  strike_in?: InputMaybe<Array<Scalars['String']['input']>>;
  strike_lt?: InputMaybe<Scalars['String']['input']>;
  strike_lte?: InputMaybe<Scalars['String']['input']>;
  strike_not?: InputMaybe<Scalars['String']['input']>;
  strike_not_contains?: InputMaybe<Scalars['String']['input']>;
  strike_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  strike_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  strike_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  strike_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  strike_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  strike_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  strike_starts_with?: InputMaybe<Scalars['String']['input']>;
  strike_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
};

export enum DailyDonation_OrderBy {
  Donation = 'donation',
  Id = 'id',
  SqrtPriceX96 = 'sqrtPriceX96',
  Start = 'start',
  Strike = 'strike',
  StrikeFeeGrowthInside0LastX128 = 'strike__feeGrowthInside0LastX128',
  StrikeFeeGrowthInside1LastX128 = 'strike__feeGrowthInside1LastX128',
  StrikeHandler = 'strike__handler',
  StrikeHook = 'strike__hook',
  StrikeId = 'strike__id',
  StrikePool = 'strike__pool',
  StrikeReservedLiquidity = 'strike__reservedLiquidity',
  StrikeTickLower = 'strike__tickLower',
  StrikeTickUpper = 'strike__tickUpper',
  StrikeTotalLiquidity = 'strike__totalLiquidity',
  StrikeTotalShares = 'strike__totalShares',
  StrikeUsedLiquidity = 'strike__usedLiquidity'
}

export type DailyFeeCompound = {
  __typename?: 'DailyFeeCompound';
  compound: Scalars['BigInt']['output'];
  id: Scalars['ID']['output'];
  sqrtPriceX96: Scalars['BigInt']['output'];
  start: Scalars['BigInt']['output'];
  strike: Strike;
};

export type DailyFeeCompound_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<DailyFeeCompound_Filter>>>;
  compound?: InputMaybe<Scalars['BigInt']['input']>;
  compound_gt?: InputMaybe<Scalars['BigInt']['input']>;
  compound_gte?: InputMaybe<Scalars['BigInt']['input']>;
  compound_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  compound_lt?: InputMaybe<Scalars['BigInt']['input']>;
  compound_lte?: InputMaybe<Scalars['BigInt']['input']>;
  compound_not?: InputMaybe<Scalars['BigInt']['input']>;
  compound_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  or?: InputMaybe<Array<InputMaybe<DailyFeeCompound_Filter>>>;
  sqrtPriceX96?: InputMaybe<Scalars['BigInt']['input']>;
  sqrtPriceX96_gt?: InputMaybe<Scalars['BigInt']['input']>;
  sqrtPriceX96_gte?: InputMaybe<Scalars['BigInt']['input']>;
  sqrtPriceX96_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  sqrtPriceX96_lt?: InputMaybe<Scalars['BigInt']['input']>;
  sqrtPriceX96_lte?: InputMaybe<Scalars['BigInt']['input']>;
  sqrtPriceX96_not?: InputMaybe<Scalars['BigInt']['input']>;
  sqrtPriceX96_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  start?: InputMaybe<Scalars['BigInt']['input']>;
  start_gt?: InputMaybe<Scalars['BigInt']['input']>;
  start_gte?: InputMaybe<Scalars['BigInt']['input']>;
  start_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  start_lt?: InputMaybe<Scalars['BigInt']['input']>;
  start_lte?: InputMaybe<Scalars['BigInt']['input']>;
  start_not?: InputMaybe<Scalars['BigInt']['input']>;
  start_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  strike?: InputMaybe<Scalars['String']['input']>;
  strike_?: InputMaybe<Strike_Filter>;
  strike_contains?: InputMaybe<Scalars['String']['input']>;
  strike_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  strike_ends_with?: InputMaybe<Scalars['String']['input']>;
  strike_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  strike_gt?: InputMaybe<Scalars['String']['input']>;
  strike_gte?: InputMaybe<Scalars['String']['input']>;
  strike_in?: InputMaybe<Array<Scalars['String']['input']>>;
  strike_lt?: InputMaybe<Scalars['String']['input']>;
  strike_lte?: InputMaybe<Scalars['String']['input']>;
  strike_not?: InputMaybe<Scalars['String']['input']>;
  strike_not_contains?: InputMaybe<Scalars['String']['input']>;
  strike_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  strike_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  strike_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  strike_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  strike_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  strike_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  strike_starts_with?: InputMaybe<Scalars['String']['input']>;
  strike_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
};

export enum DailyFeeCompound_OrderBy {
  Compound = 'compound',
  Id = 'id',
  SqrtPriceX96 = 'sqrtPriceX96',
  Start = 'start',
  Strike = 'strike',
  StrikeFeeGrowthInside0LastX128 = 'strike__feeGrowthInside0LastX128',
  StrikeFeeGrowthInside1LastX128 = 'strike__feeGrowthInside1LastX128',
  StrikeHandler = 'strike__handler',
  StrikeHook = 'strike__hook',
  StrikeId = 'strike__id',
  StrikePool = 'strike__pool',
  StrikeReservedLiquidity = 'strike__reservedLiquidity',
  StrikeTickLower = 'strike__tickLower',
  StrikeTickUpper = 'strike__tickUpper',
  StrikeTotalLiquidity = 'strike__totalLiquidity',
  StrikeTotalShares = 'strike__totalShares',
  StrikeUsedLiquidity = 'strike__usedLiquidity'
}

export type Donation = {
  __typename?: 'Donation';
  activeLiquidity: Scalars['BigInt']['output'];
  id: Scalars['ID']['output'];
  liquidity: Scalars['BigInt']['output'];
  sqrtPriceX96: Scalars['BigInt']['output'];
  strike: Strike;
  timestamp: Scalars['BigInt']['output'];
  totalLiquidity: Scalars['BigInt']['output'];
};

export type Donation_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  activeLiquidity?: InputMaybe<Scalars['BigInt']['input']>;
  activeLiquidity_gt?: InputMaybe<Scalars['BigInt']['input']>;
  activeLiquidity_gte?: InputMaybe<Scalars['BigInt']['input']>;
  activeLiquidity_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  activeLiquidity_lt?: InputMaybe<Scalars['BigInt']['input']>;
  activeLiquidity_lte?: InputMaybe<Scalars['BigInt']['input']>;
  activeLiquidity_not?: InputMaybe<Scalars['BigInt']['input']>;
  activeLiquidity_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  and?: InputMaybe<Array<InputMaybe<Donation_Filter>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  liquidity?: InputMaybe<Scalars['BigInt']['input']>;
  liquidity_gt?: InputMaybe<Scalars['BigInt']['input']>;
  liquidity_gte?: InputMaybe<Scalars['BigInt']['input']>;
  liquidity_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  liquidity_lt?: InputMaybe<Scalars['BigInt']['input']>;
  liquidity_lte?: InputMaybe<Scalars['BigInt']['input']>;
  liquidity_not?: InputMaybe<Scalars['BigInt']['input']>;
  liquidity_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  or?: InputMaybe<Array<InputMaybe<Donation_Filter>>>;
  sqrtPriceX96?: InputMaybe<Scalars['BigInt']['input']>;
  sqrtPriceX96_gt?: InputMaybe<Scalars['BigInt']['input']>;
  sqrtPriceX96_gte?: InputMaybe<Scalars['BigInt']['input']>;
  sqrtPriceX96_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  sqrtPriceX96_lt?: InputMaybe<Scalars['BigInt']['input']>;
  sqrtPriceX96_lte?: InputMaybe<Scalars['BigInt']['input']>;
  sqrtPriceX96_not?: InputMaybe<Scalars['BigInt']['input']>;
  sqrtPriceX96_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  strike?: InputMaybe<Scalars['String']['input']>;
  strike_?: InputMaybe<Strike_Filter>;
  strike_contains?: InputMaybe<Scalars['String']['input']>;
  strike_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  strike_ends_with?: InputMaybe<Scalars['String']['input']>;
  strike_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  strike_gt?: InputMaybe<Scalars['String']['input']>;
  strike_gte?: InputMaybe<Scalars['String']['input']>;
  strike_in?: InputMaybe<Array<Scalars['String']['input']>>;
  strike_lt?: InputMaybe<Scalars['String']['input']>;
  strike_lte?: InputMaybe<Scalars['String']['input']>;
  strike_not?: InputMaybe<Scalars['String']['input']>;
  strike_not_contains?: InputMaybe<Scalars['String']['input']>;
  strike_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  strike_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  strike_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  strike_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  strike_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  strike_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  strike_starts_with?: InputMaybe<Scalars['String']['input']>;
  strike_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  timestamp?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_gt?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_gte?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  timestamp_lt?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_lte?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_not?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  totalLiquidity?: InputMaybe<Scalars['BigInt']['input']>;
  totalLiquidity_gt?: InputMaybe<Scalars['BigInt']['input']>;
  totalLiquidity_gte?: InputMaybe<Scalars['BigInt']['input']>;
  totalLiquidity_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  totalLiquidity_lt?: InputMaybe<Scalars['BigInt']['input']>;
  totalLiquidity_lte?: InputMaybe<Scalars['BigInt']['input']>;
  totalLiquidity_not?: InputMaybe<Scalars['BigInt']['input']>;
  totalLiquidity_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
};

export enum Donation_OrderBy {
  ActiveLiquidity = 'activeLiquidity',
  Id = 'id',
  Liquidity = 'liquidity',
  SqrtPriceX96 = 'sqrtPriceX96',
  Strike = 'strike',
  StrikeFeeGrowthInside0LastX128 = 'strike__feeGrowthInside0LastX128',
  StrikeFeeGrowthInside1LastX128 = 'strike__feeGrowthInside1LastX128',
  StrikeHandler = 'strike__handler',
  StrikeHook = 'strike__hook',
  StrikeId = 'strike__id',
  StrikePool = 'strike__pool',
  StrikeReservedLiquidity = 'strike__reservedLiquidity',
  StrikeTickLower = 'strike__tickLower',
  StrikeTickUpper = 'strike__tickUpper',
  StrikeTotalLiquidity = 'strike__totalLiquidity',
  StrikeTotalShares = 'strike__totalShares',
  StrikeUsedLiquidity = 'strike__usedLiquidity',
  Timestamp = 'timestamp',
  TotalLiquidity = 'totalLiquidity'
}

export type FeeCompound = {
  __typename?: 'FeeCompound';
  activeLiquidity: Scalars['BigInt']['output'];
  id: Scalars['ID']['output'];
  liquidity: Scalars['BigInt']['output'];
  sqrtPriceX96: Scalars['BigInt']['output'];
  strike: Strike;
  timestamp: Scalars['BigInt']['output'];
  totalLiquidity: Scalars['BigInt']['output'];
};

export type FeeCompound_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  activeLiquidity?: InputMaybe<Scalars['BigInt']['input']>;
  activeLiquidity_gt?: InputMaybe<Scalars['BigInt']['input']>;
  activeLiquidity_gte?: InputMaybe<Scalars['BigInt']['input']>;
  activeLiquidity_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  activeLiquidity_lt?: InputMaybe<Scalars['BigInt']['input']>;
  activeLiquidity_lte?: InputMaybe<Scalars['BigInt']['input']>;
  activeLiquidity_not?: InputMaybe<Scalars['BigInt']['input']>;
  activeLiquidity_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  and?: InputMaybe<Array<InputMaybe<FeeCompound_Filter>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  liquidity?: InputMaybe<Scalars['BigInt']['input']>;
  liquidity_gt?: InputMaybe<Scalars['BigInt']['input']>;
  liquidity_gte?: InputMaybe<Scalars['BigInt']['input']>;
  liquidity_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  liquidity_lt?: InputMaybe<Scalars['BigInt']['input']>;
  liquidity_lte?: InputMaybe<Scalars['BigInt']['input']>;
  liquidity_not?: InputMaybe<Scalars['BigInt']['input']>;
  liquidity_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  or?: InputMaybe<Array<InputMaybe<FeeCompound_Filter>>>;
  sqrtPriceX96?: InputMaybe<Scalars['BigInt']['input']>;
  sqrtPriceX96_gt?: InputMaybe<Scalars['BigInt']['input']>;
  sqrtPriceX96_gte?: InputMaybe<Scalars['BigInt']['input']>;
  sqrtPriceX96_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  sqrtPriceX96_lt?: InputMaybe<Scalars['BigInt']['input']>;
  sqrtPriceX96_lte?: InputMaybe<Scalars['BigInt']['input']>;
  sqrtPriceX96_not?: InputMaybe<Scalars['BigInt']['input']>;
  sqrtPriceX96_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  strike?: InputMaybe<Scalars['String']['input']>;
  strike_?: InputMaybe<Strike_Filter>;
  strike_contains?: InputMaybe<Scalars['String']['input']>;
  strike_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  strike_ends_with?: InputMaybe<Scalars['String']['input']>;
  strike_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  strike_gt?: InputMaybe<Scalars['String']['input']>;
  strike_gte?: InputMaybe<Scalars['String']['input']>;
  strike_in?: InputMaybe<Array<Scalars['String']['input']>>;
  strike_lt?: InputMaybe<Scalars['String']['input']>;
  strike_lte?: InputMaybe<Scalars['String']['input']>;
  strike_not?: InputMaybe<Scalars['String']['input']>;
  strike_not_contains?: InputMaybe<Scalars['String']['input']>;
  strike_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  strike_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  strike_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  strike_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  strike_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  strike_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  strike_starts_with?: InputMaybe<Scalars['String']['input']>;
  strike_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  timestamp?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_gt?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_gte?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  timestamp_lt?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_lte?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_not?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  totalLiquidity?: InputMaybe<Scalars['BigInt']['input']>;
  totalLiquidity_gt?: InputMaybe<Scalars['BigInt']['input']>;
  totalLiquidity_gte?: InputMaybe<Scalars['BigInt']['input']>;
  totalLiquidity_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  totalLiquidity_lt?: InputMaybe<Scalars['BigInt']['input']>;
  totalLiquidity_lte?: InputMaybe<Scalars['BigInt']['input']>;
  totalLiquidity_not?: InputMaybe<Scalars['BigInt']['input']>;
  totalLiquidity_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
};

export enum FeeCompound_OrderBy {
  ActiveLiquidity = 'activeLiquidity',
  Id = 'id',
  Liquidity = 'liquidity',
  SqrtPriceX96 = 'sqrtPriceX96',
  Strike = 'strike',
  StrikeFeeGrowthInside0LastX128 = 'strike__feeGrowthInside0LastX128',
  StrikeFeeGrowthInside1LastX128 = 'strike__feeGrowthInside1LastX128',
  StrikeHandler = 'strike__handler',
  StrikeHook = 'strike__hook',
  StrikeId = 'strike__id',
  StrikePool = 'strike__pool',
  StrikeReservedLiquidity = 'strike__reservedLiquidity',
  StrikeTickLower = 'strike__tickLower',
  StrikeTickUpper = 'strike__tickUpper',
  StrikeTotalLiquidity = 'strike__totalLiquidity',
  StrikeTotalShares = 'strike__totalShares',
  StrikeUsedLiquidity = 'strike__usedLiquidity',
  Timestamp = 'timestamp',
  TotalLiquidity = 'totalLiquidity'
}

export type LpPosition = {
  __typename?: 'LPPosition';
  handler: Scalars['String']['output'];
  hook: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  initalSqrtPriceX96: Scalars['BigInt']['output'];
  initialLiquidity: Scalars['BigInt']['output'];
  lastReserve: Scalars['BigInt']['output'];
  lpPositionBurns: Array<LpPositionBurn>;
  lpPositionMints: Array<LpPositionMint>;
  mintPosition: Array<MintPosition>;
  pool: Scalars['String']['output'];
  reservedLiquidity: Scalars['BigInt']['output'];
  shares: Scalars['BigInt']['output'];
  strike: Strike;
  timestamp: Scalars['BigInt']['output'];
  user: Scalars['String']['output'];
};


export type LpPositionLpPositionBurnsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<LpPositionBurn_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<LpPositionBurn_Filter>;
};


export type LpPositionLpPositionMintsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<LpPositionMint_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<LpPositionMint_Filter>;
};


export type LpPositionMintPositionArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<MintPosition_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MintPosition_Filter>;
};

export type LpPositionBurn = {
  __typename?: 'LPPositionBurn';
  handler: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  liquidity: Scalars['BigInt']['output'];
  lpPosition: LpPosition;
  pool: Scalars['String']['output'];
  sqrtPriceX96: Scalars['BigInt']['output'];
  strike: Strike;
  timestamp: Scalars['BigInt']['output'];
  user: Scalars['String']['output'];
};

export type LpPositionBurn_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<LpPositionBurn_Filter>>>;
  handler?: InputMaybe<Scalars['String']['input']>;
  handler_contains?: InputMaybe<Scalars['String']['input']>;
  handler_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  handler_ends_with?: InputMaybe<Scalars['String']['input']>;
  handler_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  handler_gt?: InputMaybe<Scalars['String']['input']>;
  handler_gte?: InputMaybe<Scalars['String']['input']>;
  handler_in?: InputMaybe<Array<Scalars['String']['input']>>;
  handler_lt?: InputMaybe<Scalars['String']['input']>;
  handler_lte?: InputMaybe<Scalars['String']['input']>;
  handler_not?: InputMaybe<Scalars['String']['input']>;
  handler_not_contains?: InputMaybe<Scalars['String']['input']>;
  handler_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  handler_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  handler_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  handler_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  handler_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  handler_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  handler_starts_with?: InputMaybe<Scalars['String']['input']>;
  handler_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  liquidity?: InputMaybe<Scalars['BigInt']['input']>;
  liquidity_gt?: InputMaybe<Scalars['BigInt']['input']>;
  liquidity_gte?: InputMaybe<Scalars['BigInt']['input']>;
  liquidity_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  liquidity_lt?: InputMaybe<Scalars['BigInt']['input']>;
  liquidity_lte?: InputMaybe<Scalars['BigInt']['input']>;
  liquidity_not?: InputMaybe<Scalars['BigInt']['input']>;
  liquidity_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  lpPosition?: InputMaybe<Scalars['String']['input']>;
  lpPosition_?: InputMaybe<LpPosition_Filter>;
  lpPosition_contains?: InputMaybe<Scalars['String']['input']>;
  lpPosition_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  lpPosition_ends_with?: InputMaybe<Scalars['String']['input']>;
  lpPosition_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  lpPosition_gt?: InputMaybe<Scalars['String']['input']>;
  lpPosition_gte?: InputMaybe<Scalars['String']['input']>;
  lpPosition_in?: InputMaybe<Array<Scalars['String']['input']>>;
  lpPosition_lt?: InputMaybe<Scalars['String']['input']>;
  lpPosition_lte?: InputMaybe<Scalars['String']['input']>;
  lpPosition_not?: InputMaybe<Scalars['String']['input']>;
  lpPosition_not_contains?: InputMaybe<Scalars['String']['input']>;
  lpPosition_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  lpPosition_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  lpPosition_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  lpPosition_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  lpPosition_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  lpPosition_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  lpPosition_starts_with?: InputMaybe<Scalars['String']['input']>;
  lpPosition_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  or?: InputMaybe<Array<InputMaybe<LpPositionBurn_Filter>>>;
  pool?: InputMaybe<Scalars['String']['input']>;
  pool_contains?: InputMaybe<Scalars['String']['input']>;
  pool_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  pool_ends_with?: InputMaybe<Scalars['String']['input']>;
  pool_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  pool_gt?: InputMaybe<Scalars['String']['input']>;
  pool_gte?: InputMaybe<Scalars['String']['input']>;
  pool_in?: InputMaybe<Array<Scalars['String']['input']>>;
  pool_lt?: InputMaybe<Scalars['String']['input']>;
  pool_lte?: InputMaybe<Scalars['String']['input']>;
  pool_not?: InputMaybe<Scalars['String']['input']>;
  pool_not_contains?: InputMaybe<Scalars['String']['input']>;
  pool_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  pool_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  pool_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  pool_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  pool_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  pool_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  pool_starts_with?: InputMaybe<Scalars['String']['input']>;
  pool_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  sqrtPriceX96?: InputMaybe<Scalars['BigInt']['input']>;
  sqrtPriceX96_gt?: InputMaybe<Scalars['BigInt']['input']>;
  sqrtPriceX96_gte?: InputMaybe<Scalars['BigInt']['input']>;
  sqrtPriceX96_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  sqrtPriceX96_lt?: InputMaybe<Scalars['BigInt']['input']>;
  sqrtPriceX96_lte?: InputMaybe<Scalars['BigInt']['input']>;
  sqrtPriceX96_not?: InputMaybe<Scalars['BigInt']['input']>;
  sqrtPriceX96_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  strike?: InputMaybe<Scalars['String']['input']>;
  strike_?: InputMaybe<Strike_Filter>;
  strike_contains?: InputMaybe<Scalars['String']['input']>;
  strike_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  strike_ends_with?: InputMaybe<Scalars['String']['input']>;
  strike_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  strike_gt?: InputMaybe<Scalars['String']['input']>;
  strike_gte?: InputMaybe<Scalars['String']['input']>;
  strike_in?: InputMaybe<Array<Scalars['String']['input']>>;
  strike_lt?: InputMaybe<Scalars['String']['input']>;
  strike_lte?: InputMaybe<Scalars['String']['input']>;
  strike_not?: InputMaybe<Scalars['String']['input']>;
  strike_not_contains?: InputMaybe<Scalars['String']['input']>;
  strike_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  strike_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  strike_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  strike_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  strike_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  strike_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  strike_starts_with?: InputMaybe<Scalars['String']['input']>;
  strike_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  timestamp?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_gt?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_gte?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  timestamp_lt?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_lte?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_not?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  user?: InputMaybe<Scalars['String']['input']>;
  user_contains?: InputMaybe<Scalars['String']['input']>;
  user_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  user_ends_with?: InputMaybe<Scalars['String']['input']>;
  user_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  user_gt?: InputMaybe<Scalars['String']['input']>;
  user_gte?: InputMaybe<Scalars['String']['input']>;
  user_in?: InputMaybe<Array<Scalars['String']['input']>>;
  user_lt?: InputMaybe<Scalars['String']['input']>;
  user_lte?: InputMaybe<Scalars['String']['input']>;
  user_not?: InputMaybe<Scalars['String']['input']>;
  user_not_contains?: InputMaybe<Scalars['String']['input']>;
  user_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  user_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  user_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  user_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  user_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  user_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  user_starts_with?: InputMaybe<Scalars['String']['input']>;
  user_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
};

export enum LpPositionBurn_OrderBy {
  Handler = 'handler',
  Id = 'id',
  Liquidity = 'liquidity',
  LpPosition = 'lpPosition',
  LpPositionHandler = 'lpPosition__handler',
  LpPositionHook = 'lpPosition__hook',
  LpPositionId = 'lpPosition__id',
  LpPositionInitalSqrtPriceX96 = 'lpPosition__initalSqrtPriceX96',
  LpPositionInitialLiquidity = 'lpPosition__initialLiquidity',
  LpPositionLastReserve = 'lpPosition__lastReserve',
  LpPositionPool = 'lpPosition__pool',
  LpPositionReservedLiquidity = 'lpPosition__reservedLiquidity',
  LpPositionShares = 'lpPosition__shares',
  LpPositionTimestamp = 'lpPosition__timestamp',
  LpPositionUser = 'lpPosition__user',
  Pool = 'pool',
  SqrtPriceX96 = 'sqrtPriceX96',
  Strike = 'strike',
  StrikeFeeGrowthInside0LastX128 = 'strike__feeGrowthInside0LastX128',
  StrikeFeeGrowthInside1LastX128 = 'strike__feeGrowthInside1LastX128',
  StrikeHandler = 'strike__handler',
  StrikeHook = 'strike__hook',
  StrikeId = 'strike__id',
  StrikePool = 'strike__pool',
  StrikeReservedLiquidity = 'strike__reservedLiquidity',
  StrikeTickLower = 'strike__tickLower',
  StrikeTickUpper = 'strike__tickUpper',
  StrikeTotalLiquidity = 'strike__totalLiquidity',
  StrikeTotalShares = 'strike__totalShares',
  StrikeUsedLiquidity = 'strike__usedLiquidity',
  Timestamp = 'timestamp',
  User = 'user'
}

export type LpPositionMint = {
  __typename?: 'LPPositionMint';
  handler: Scalars['String']['output'];
  hook: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  liquidity: Scalars['BigInt']['output'];
  lpPosition: LpPosition;
  pool: Scalars['String']['output'];
  sqrtPriceX96: Scalars['BigInt']['output'];
  strike: Strike;
  timestamp: Scalars['BigInt']['output'];
  user: Scalars['String']['output'];
};

export type LpPositionMint_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<LpPositionMint_Filter>>>;
  handler?: InputMaybe<Scalars['String']['input']>;
  handler_contains?: InputMaybe<Scalars['String']['input']>;
  handler_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  handler_ends_with?: InputMaybe<Scalars['String']['input']>;
  handler_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  handler_gt?: InputMaybe<Scalars['String']['input']>;
  handler_gte?: InputMaybe<Scalars['String']['input']>;
  handler_in?: InputMaybe<Array<Scalars['String']['input']>>;
  handler_lt?: InputMaybe<Scalars['String']['input']>;
  handler_lte?: InputMaybe<Scalars['String']['input']>;
  handler_not?: InputMaybe<Scalars['String']['input']>;
  handler_not_contains?: InputMaybe<Scalars['String']['input']>;
  handler_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  handler_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  handler_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  handler_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  handler_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  handler_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  handler_starts_with?: InputMaybe<Scalars['String']['input']>;
  handler_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  hook?: InputMaybe<Scalars['String']['input']>;
  hook_contains?: InputMaybe<Scalars['String']['input']>;
  hook_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  hook_ends_with?: InputMaybe<Scalars['String']['input']>;
  hook_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  hook_gt?: InputMaybe<Scalars['String']['input']>;
  hook_gte?: InputMaybe<Scalars['String']['input']>;
  hook_in?: InputMaybe<Array<Scalars['String']['input']>>;
  hook_lt?: InputMaybe<Scalars['String']['input']>;
  hook_lte?: InputMaybe<Scalars['String']['input']>;
  hook_not?: InputMaybe<Scalars['String']['input']>;
  hook_not_contains?: InputMaybe<Scalars['String']['input']>;
  hook_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  hook_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  hook_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  hook_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  hook_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  hook_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  hook_starts_with?: InputMaybe<Scalars['String']['input']>;
  hook_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  liquidity?: InputMaybe<Scalars['BigInt']['input']>;
  liquidity_gt?: InputMaybe<Scalars['BigInt']['input']>;
  liquidity_gte?: InputMaybe<Scalars['BigInt']['input']>;
  liquidity_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  liquidity_lt?: InputMaybe<Scalars['BigInt']['input']>;
  liquidity_lte?: InputMaybe<Scalars['BigInt']['input']>;
  liquidity_not?: InputMaybe<Scalars['BigInt']['input']>;
  liquidity_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  lpPosition?: InputMaybe<Scalars['String']['input']>;
  lpPosition_?: InputMaybe<LpPosition_Filter>;
  lpPosition_contains?: InputMaybe<Scalars['String']['input']>;
  lpPosition_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  lpPosition_ends_with?: InputMaybe<Scalars['String']['input']>;
  lpPosition_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  lpPosition_gt?: InputMaybe<Scalars['String']['input']>;
  lpPosition_gte?: InputMaybe<Scalars['String']['input']>;
  lpPosition_in?: InputMaybe<Array<Scalars['String']['input']>>;
  lpPosition_lt?: InputMaybe<Scalars['String']['input']>;
  lpPosition_lte?: InputMaybe<Scalars['String']['input']>;
  lpPosition_not?: InputMaybe<Scalars['String']['input']>;
  lpPosition_not_contains?: InputMaybe<Scalars['String']['input']>;
  lpPosition_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  lpPosition_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  lpPosition_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  lpPosition_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  lpPosition_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  lpPosition_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  lpPosition_starts_with?: InputMaybe<Scalars['String']['input']>;
  lpPosition_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  or?: InputMaybe<Array<InputMaybe<LpPositionMint_Filter>>>;
  pool?: InputMaybe<Scalars['String']['input']>;
  pool_contains?: InputMaybe<Scalars['String']['input']>;
  pool_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  pool_ends_with?: InputMaybe<Scalars['String']['input']>;
  pool_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  pool_gt?: InputMaybe<Scalars['String']['input']>;
  pool_gte?: InputMaybe<Scalars['String']['input']>;
  pool_in?: InputMaybe<Array<Scalars['String']['input']>>;
  pool_lt?: InputMaybe<Scalars['String']['input']>;
  pool_lte?: InputMaybe<Scalars['String']['input']>;
  pool_not?: InputMaybe<Scalars['String']['input']>;
  pool_not_contains?: InputMaybe<Scalars['String']['input']>;
  pool_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  pool_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  pool_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  pool_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  pool_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  pool_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  pool_starts_with?: InputMaybe<Scalars['String']['input']>;
  pool_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  sqrtPriceX96?: InputMaybe<Scalars['BigInt']['input']>;
  sqrtPriceX96_gt?: InputMaybe<Scalars['BigInt']['input']>;
  sqrtPriceX96_gte?: InputMaybe<Scalars['BigInt']['input']>;
  sqrtPriceX96_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  sqrtPriceX96_lt?: InputMaybe<Scalars['BigInt']['input']>;
  sqrtPriceX96_lte?: InputMaybe<Scalars['BigInt']['input']>;
  sqrtPriceX96_not?: InputMaybe<Scalars['BigInt']['input']>;
  sqrtPriceX96_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  strike?: InputMaybe<Scalars['String']['input']>;
  strike_?: InputMaybe<Strike_Filter>;
  strike_contains?: InputMaybe<Scalars['String']['input']>;
  strike_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  strike_ends_with?: InputMaybe<Scalars['String']['input']>;
  strike_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  strike_gt?: InputMaybe<Scalars['String']['input']>;
  strike_gte?: InputMaybe<Scalars['String']['input']>;
  strike_in?: InputMaybe<Array<Scalars['String']['input']>>;
  strike_lt?: InputMaybe<Scalars['String']['input']>;
  strike_lte?: InputMaybe<Scalars['String']['input']>;
  strike_not?: InputMaybe<Scalars['String']['input']>;
  strike_not_contains?: InputMaybe<Scalars['String']['input']>;
  strike_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  strike_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  strike_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  strike_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  strike_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  strike_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  strike_starts_with?: InputMaybe<Scalars['String']['input']>;
  strike_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  timestamp?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_gt?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_gte?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  timestamp_lt?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_lte?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_not?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  user?: InputMaybe<Scalars['String']['input']>;
  user_contains?: InputMaybe<Scalars['String']['input']>;
  user_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  user_ends_with?: InputMaybe<Scalars['String']['input']>;
  user_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  user_gt?: InputMaybe<Scalars['String']['input']>;
  user_gte?: InputMaybe<Scalars['String']['input']>;
  user_in?: InputMaybe<Array<Scalars['String']['input']>>;
  user_lt?: InputMaybe<Scalars['String']['input']>;
  user_lte?: InputMaybe<Scalars['String']['input']>;
  user_not?: InputMaybe<Scalars['String']['input']>;
  user_not_contains?: InputMaybe<Scalars['String']['input']>;
  user_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  user_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  user_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  user_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  user_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  user_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  user_starts_with?: InputMaybe<Scalars['String']['input']>;
  user_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
};

export enum LpPositionMint_OrderBy {
  Handler = 'handler',
  Hook = 'hook',
  Id = 'id',
  Liquidity = 'liquidity',
  LpPosition = 'lpPosition',
  LpPositionHandler = 'lpPosition__handler',
  LpPositionHook = 'lpPosition__hook',
  LpPositionId = 'lpPosition__id',
  LpPositionInitalSqrtPriceX96 = 'lpPosition__initalSqrtPriceX96',
  LpPositionInitialLiquidity = 'lpPosition__initialLiquidity',
  LpPositionLastReserve = 'lpPosition__lastReserve',
  LpPositionPool = 'lpPosition__pool',
  LpPositionReservedLiquidity = 'lpPosition__reservedLiquidity',
  LpPositionShares = 'lpPosition__shares',
  LpPositionTimestamp = 'lpPosition__timestamp',
  LpPositionUser = 'lpPosition__user',
  Pool = 'pool',
  SqrtPriceX96 = 'sqrtPriceX96',
  Strike = 'strike',
  StrikeFeeGrowthInside0LastX128 = 'strike__feeGrowthInside0LastX128',
  StrikeFeeGrowthInside1LastX128 = 'strike__feeGrowthInside1LastX128',
  StrikeHandler = 'strike__handler',
  StrikeHook = 'strike__hook',
  StrikeId = 'strike__id',
  StrikePool = 'strike__pool',
  StrikeReservedLiquidity = 'strike__reservedLiquidity',
  StrikeTickLower = 'strike__tickLower',
  StrikeTickUpper = 'strike__tickUpper',
  StrikeTotalLiquidity = 'strike__totalLiquidity',
  StrikeTotalShares = 'strike__totalShares',
  StrikeUsedLiquidity = 'strike__usedLiquidity',
  Timestamp = 'timestamp',
  User = 'user'
}

export type LpPositionTransfer = {
  __typename?: 'LPPositionTransfer';
  from: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  liquidity: Scalars['BigInt']['output'];
  shares: Scalars['BigInt']['output'];
  sqrtPriceX96: Scalars['BigInt']['output'];
  strike: Strike;
  timestamp: Scalars['BigInt']['output'];
  to: Scalars['String']['output'];
};

export type LpPositionTransfer_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<LpPositionTransfer_Filter>>>;
  from?: InputMaybe<Scalars['String']['input']>;
  from_contains?: InputMaybe<Scalars['String']['input']>;
  from_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  from_ends_with?: InputMaybe<Scalars['String']['input']>;
  from_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  from_gt?: InputMaybe<Scalars['String']['input']>;
  from_gte?: InputMaybe<Scalars['String']['input']>;
  from_in?: InputMaybe<Array<Scalars['String']['input']>>;
  from_lt?: InputMaybe<Scalars['String']['input']>;
  from_lte?: InputMaybe<Scalars['String']['input']>;
  from_not?: InputMaybe<Scalars['String']['input']>;
  from_not_contains?: InputMaybe<Scalars['String']['input']>;
  from_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  from_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  from_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  from_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  from_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  from_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  from_starts_with?: InputMaybe<Scalars['String']['input']>;
  from_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  liquidity?: InputMaybe<Scalars['BigInt']['input']>;
  liquidity_gt?: InputMaybe<Scalars['BigInt']['input']>;
  liquidity_gte?: InputMaybe<Scalars['BigInt']['input']>;
  liquidity_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  liquidity_lt?: InputMaybe<Scalars['BigInt']['input']>;
  liquidity_lte?: InputMaybe<Scalars['BigInt']['input']>;
  liquidity_not?: InputMaybe<Scalars['BigInt']['input']>;
  liquidity_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  or?: InputMaybe<Array<InputMaybe<LpPositionTransfer_Filter>>>;
  shares?: InputMaybe<Scalars['BigInt']['input']>;
  shares_gt?: InputMaybe<Scalars['BigInt']['input']>;
  shares_gte?: InputMaybe<Scalars['BigInt']['input']>;
  shares_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  shares_lt?: InputMaybe<Scalars['BigInt']['input']>;
  shares_lte?: InputMaybe<Scalars['BigInt']['input']>;
  shares_not?: InputMaybe<Scalars['BigInt']['input']>;
  shares_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  sqrtPriceX96?: InputMaybe<Scalars['BigInt']['input']>;
  sqrtPriceX96_gt?: InputMaybe<Scalars['BigInt']['input']>;
  sqrtPriceX96_gte?: InputMaybe<Scalars['BigInt']['input']>;
  sqrtPriceX96_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  sqrtPriceX96_lt?: InputMaybe<Scalars['BigInt']['input']>;
  sqrtPriceX96_lte?: InputMaybe<Scalars['BigInt']['input']>;
  sqrtPriceX96_not?: InputMaybe<Scalars['BigInt']['input']>;
  sqrtPriceX96_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  strike?: InputMaybe<Scalars['String']['input']>;
  strike_?: InputMaybe<Strike_Filter>;
  strike_contains?: InputMaybe<Scalars['String']['input']>;
  strike_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  strike_ends_with?: InputMaybe<Scalars['String']['input']>;
  strike_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  strike_gt?: InputMaybe<Scalars['String']['input']>;
  strike_gte?: InputMaybe<Scalars['String']['input']>;
  strike_in?: InputMaybe<Array<Scalars['String']['input']>>;
  strike_lt?: InputMaybe<Scalars['String']['input']>;
  strike_lte?: InputMaybe<Scalars['String']['input']>;
  strike_not?: InputMaybe<Scalars['String']['input']>;
  strike_not_contains?: InputMaybe<Scalars['String']['input']>;
  strike_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  strike_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  strike_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  strike_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  strike_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  strike_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  strike_starts_with?: InputMaybe<Scalars['String']['input']>;
  strike_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  timestamp?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_gt?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_gte?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  timestamp_lt?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_lte?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_not?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  to?: InputMaybe<Scalars['String']['input']>;
  to_contains?: InputMaybe<Scalars['String']['input']>;
  to_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  to_ends_with?: InputMaybe<Scalars['String']['input']>;
  to_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  to_gt?: InputMaybe<Scalars['String']['input']>;
  to_gte?: InputMaybe<Scalars['String']['input']>;
  to_in?: InputMaybe<Array<Scalars['String']['input']>>;
  to_lt?: InputMaybe<Scalars['String']['input']>;
  to_lte?: InputMaybe<Scalars['String']['input']>;
  to_not?: InputMaybe<Scalars['String']['input']>;
  to_not_contains?: InputMaybe<Scalars['String']['input']>;
  to_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  to_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  to_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  to_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  to_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  to_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  to_starts_with?: InputMaybe<Scalars['String']['input']>;
  to_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
};

export enum LpPositionTransfer_OrderBy {
  From = 'from',
  Id = 'id',
  Liquidity = 'liquidity',
  Shares = 'shares',
  SqrtPriceX96 = 'sqrtPriceX96',
  Strike = 'strike',
  StrikeFeeGrowthInside0LastX128 = 'strike__feeGrowthInside0LastX128',
  StrikeFeeGrowthInside1LastX128 = 'strike__feeGrowthInside1LastX128',
  StrikeHandler = 'strike__handler',
  StrikeHook = 'strike__hook',
  StrikeId = 'strike__id',
  StrikePool = 'strike__pool',
  StrikeReservedLiquidity = 'strike__reservedLiquidity',
  StrikeTickLower = 'strike__tickLower',
  StrikeTickUpper = 'strike__tickUpper',
  StrikeTotalLiquidity = 'strike__totalLiquidity',
  StrikeTotalShares = 'strike__totalShares',
  StrikeUsedLiquidity = 'strike__usedLiquidity',
  Timestamp = 'timestamp',
  To = 'to'
}

export type LpPosition_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<LpPosition_Filter>>>;
  handler?: InputMaybe<Scalars['String']['input']>;
  handler_contains?: InputMaybe<Scalars['String']['input']>;
  handler_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  handler_ends_with?: InputMaybe<Scalars['String']['input']>;
  handler_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  handler_gt?: InputMaybe<Scalars['String']['input']>;
  handler_gte?: InputMaybe<Scalars['String']['input']>;
  handler_in?: InputMaybe<Array<Scalars['String']['input']>>;
  handler_lt?: InputMaybe<Scalars['String']['input']>;
  handler_lte?: InputMaybe<Scalars['String']['input']>;
  handler_not?: InputMaybe<Scalars['String']['input']>;
  handler_not_contains?: InputMaybe<Scalars['String']['input']>;
  handler_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  handler_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  handler_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  handler_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  handler_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  handler_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  handler_starts_with?: InputMaybe<Scalars['String']['input']>;
  handler_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  hook?: InputMaybe<Scalars['String']['input']>;
  hook_contains?: InputMaybe<Scalars['String']['input']>;
  hook_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  hook_ends_with?: InputMaybe<Scalars['String']['input']>;
  hook_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  hook_gt?: InputMaybe<Scalars['String']['input']>;
  hook_gte?: InputMaybe<Scalars['String']['input']>;
  hook_in?: InputMaybe<Array<Scalars['String']['input']>>;
  hook_lt?: InputMaybe<Scalars['String']['input']>;
  hook_lte?: InputMaybe<Scalars['String']['input']>;
  hook_not?: InputMaybe<Scalars['String']['input']>;
  hook_not_contains?: InputMaybe<Scalars['String']['input']>;
  hook_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  hook_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  hook_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  hook_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  hook_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  hook_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  hook_starts_with?: InputMaybe<Scalars['String']['input']>;
  hook_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  initalSqrtPriceX96?: InputMaybe<Scalars['BigInt']['input']>;
  initalSqrtPriceX96_gt?: InputMaybe<Scalars['BigInt']['input']>;
  initalSqrtPriceX96_gte?: InputMaybe<Scalars['BigInt']['input']>;
  initalSqrtPriceX96_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  initalSqrtPriceX96_lt?: InputMaybe<Scalars['BigInt']['input']>;
  initalSqrtPriceX96_lte?: InputMaybe<Scalars['BigInt']['input']>;
  initalSqrtPriceX96_not?: InputMaybe<Scalars['BigInt']['input']>;
  initalSqrtPriceX96_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  initialLiquidity?: InputMaybe<Scalars['BigInt']['input']>;
  initialLiquidity_gt?: InputMaybe<Scalars['BigInt']['input']>;
  initialLiquidity_gte?: InputMaybe<Scalars['BigInt']['input']>;
  initialLiquidity_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  initialLiquidity_lt?: InputMaybe<Scalars['BigInt']['input']>;
  initialLiquidity_lte?: InputMaybe<Scalars['BigInt']['input']>;
  initialLiquidity_not?: InputMaybe<Scalars['BigInt']['input']>;
  initialLiquidity_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  lastReserve?: InputMaybe<Scalars['BigInt']['input']>;
  lastReserve_gt?: InputMaybe<Scalars['BigInt']['input']>;
  lastReserve_gte?: InputMaybe<Scalars['BigInt']['input']>;
  lastReserve_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  lastReserve_lt?: InputMaybe<Scalars['BigInt']['input']>;
  lastReserve_lte?: InputMaybe<Scalars['BigInt']['input']>;
  lastReserve_not?: InputMaybe<Scalars['BigInt']['input']>;
  lastReserve_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  lpPositionBurns_?: InputMaybe<LpPositionBurn_Filter>;
  lpPositionMints_?: InputMaybe<LpPositionMint_Filter>;
  mintPosition_?: InputMaybe<MintPosition_Filter>;
  or?: InputMaybe<Array<InputMaybe<LpPosition_Filter>>>;
  pool?: InputMaybe<Scalars['String']['input']>;
  pool_contains?: InputMaybe<Scalars['String']['input']>;
  pool_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  pool_ends_with?: InputMaybe<Scalars['String']['input']>;
  pool_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  pool_gt?: InputMaybe<Scalars['String']['input']>;
  pool_gte?: InputMaybe<Scalars['String']['input']>;
  pool_in?: InputMaybe<Array<Scalars['String']['input']>>;
  pool_lt?: InputMaybe<Scalars['String']['input']>;
  pool_lte?: InputMaybe<Scalars['String']['input']>;
  pool_not?: InputMaybe<Scalars['String']['input']>;
  pool_not_contains?: InputMaybe<Scalars['String']['input']>;
  pool_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  pool_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  pool_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  pool_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  pool_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  pool_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  pool_starts_with?: InputMaybe<Scalars['String']['input']>;
  pool_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  reservedLiquidity?: InputMaybe<Scalars['BigInt']['input']>;
  reservedLiquidity_gt?: InputMaybe<Scalars['BigInt']['input']>;
  reservedLiquidity_gte?: InputMaybe<Scalars['BigInt']['input']>;
  reservedLiquidity_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  reservedLiquidity_lt?: InputMaybe<Scalars['BigInt']['input']>;
  reservedLiquidity_lte?: InputMaybe<Scalars['BigInt']['input']>;
  reservedLiquidity_not?: InputMaybe<Scalars['BigInt']['input']>;
  reservedLiquidity_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  shares?: InputMaybe<Scalars['BigInt']['input']>;
  shares_gt?: InputMaybe<Scalars['BigInt']['input']>;
  shares_gte?: InputMaybe<Scalars['BigInt']['input']>;
  shares_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  shares_lt?: InputMaybe<Scalars['BigInt']['input']>;
  shares_lte?: InputMaybe<Scalars['BigInt']['input']>;
  shares_not?: InputMaybe<Scalars['BigInt']['input']>;
  shares_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  strike?: InputMaybe<Scalars['String']['input']>;
  strike_?: InputMaybe<Strike_Filter>;
  strike_contains?: InputMaybe<Scalars['String']['input']>;
  strike_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  strike_ends_with?: InputMaybe<Scalars['String']['input']>;
  strike_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  strike_gt?: InputMaybe<Scalars['String']['input']>;
  strike_gte?: InputMaybe<Scalars['String']['input']>;
  strike_in?: InputMaybe<Array<Scalars['String']['input']>>;
  strike_lt?: InputMaybe<Scalars['String']['input']>;
  strike_lte?: InputMaybe<Scalars['String']['input']>;
  strike_not?: InputMaybe<Scalars['String']['input']>;
  strike_not_contains?: InputMaybe<Scalars['String']['input']>;
  strike_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  strike_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  strike_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  strike_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  strike_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  strike_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  strike_starts_with?: InputMaybe<Scalars['String']['input']>;
  strike_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  timestamp?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_gt?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_gte?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  timestamp_lt?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_lte?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_not?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  user?: InputMaybe<Scalars['String']['input']>;
  user_contains?: InputMaybe<Scalars['String']['input']>;
  user_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  user_ends_with?: InputMaybe<Scalars['String']['input']>;
  user_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  user_gt?: InputMaybe<Scalars['String']['input']>;
  user_gte?: InputMaybe<Scalars['String']['input']>;
  user_in?: InputMaybe<Array<Scalars['String']['input']>>;
  user_lt?: InputMaybe<Scalars['String']['input']>;
  user_lte?: InputMaybe<Scalars['String']['input']>;
  user_not?: InputMaybe<Scalars['String']['input']>;
  user_not_contains?: InputMaybe<Scalars['String']['input']>;
  user_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  user_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  user_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  user_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  user_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  user_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  user_starts_with?: InputMaybe<Scalars['String']['input']>;
  user_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
};

export enum LpPosition_OrderBy {
  Handler = 'handler',
  Hook = 'hook',
  Id = 'id',
  InitalSqrtPriceX96 = 'initalSqrtPriceX96',
  InitialLiquidity = 'initialLiquidity',
  LastReserve = 'lastReserve',
  LpPositionBurns = 'lpPositionBurns',
  LpPositionMints = 'lpPositionMints',
  MintPosition = 'mintPosition',
  Pool = 'pool',
  ReservedLiquidity = 'reservedLiquidity',
  Shares = 'shares',
  Strike = 'strike',
  StrikeFeeGrowthInside0LastX128 = 'strike__feeGrowthInside0LastX128',
  StrikeFeeGrowthInside1LastX128 = 'strike__feeGrowthInside1LastX128',
  StrikeHandler = 'strike__handler',
  StrikeHook = 'strike__hook',
  StrikeId = 'strike__id',
  StrikePool = 'strike__pool',
  StrikeReservedLiquidity = 'strike__reservedLiquidity',
  StrikeTickLower = 'strike__tickLower',
  StrikeTickUpper = 'strike__tickUpper',
  StrikeTotalLiquidity = 'strike__totalLiquidity',
  StrikeTotalShares = 'strike__totalShares',
  StrikeUsedLiquidity = 'strike__usedLiquidity',
  Timestamp = 'timestamp',
  User = 'user'
}

export type MintOption = {
  __typename?: 'MintOption';
  frontendId: Scalars['Bytes']['output'];
  id: Scalars['ID']['output'];
  option: Option;
  optionMarket: OptionMarket;
  priceAtAction: Scalars['BigInt']['output'];
  receiver: Scalars['String']['output'];
  referralId: Scalars['Bytes']['output'];
  size: Scalars['BigInt']['output'];
  timestamp: Scalars['BigInt']['output'];
  user: Scalars['String']['output'];
};

export type MintOption_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<MintOption_Filter>>>;
  frontendId?: InputMaybe<Scalars['Bytes']['input']>;
  frontendId_contains?: InputMaybe<Scalars['Bytes']['input']>;
  frontendId_gt?: InputMaybe<Scalars['Bytes']['input']>;
  frontendId_gte?: InputMaybe<Scalars['Bytes']['input']>;
  frontendId_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  frontendId_lt?: InputMaybe<Scalars['Bytes']['input']>;
  frontendId_lte?: InputMaybe<Scalars['Bytes']['input']>;
  frontendId_not?: InputMaybe<Scalars['Bytes']['input']>;
  frontendId_not_contains?: InputMaybe<Scalars['Bytes']['input']>;
  frontendId_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  option?: InputMaybe<Scalars['String']['input']>;
  optionMarket?: InputMaybe<Scalars['String']['input']>;
  optionMarket_?: InputMaybe<OptionMarket_Filter>;
  optionMarket_contains?: InputMaybe<Scalars['String']['input']>;
  optionMarket_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  optionMarket_ends_with?: InputMaybe<Scalars['String']['input']>;
  optionMarket_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  optionMarket_gt?: InputMaybe<Scalars['String']['input']>;
  optionMarket_gte?: InputMaybe<Scalars['String']['input']>;
  optionMarket_in?: InputMaybe<Array<Scalars['String']['input']>>;
  optionMarket_lt?: InputMaybe<Scalars['String']['input']>;
  optionMarket_lte?: InputMaybe<Scalars['String']['input']>;
  optionMarket_not?: InputMaybe<Scalars['String']['input']>;
  optionMarket_not_contains?: InputMaybe<Scalars['String']['input']>;
  optionMarket_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  optionMarket_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  optionMarket_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  optionMarket_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  optionMarket_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  optionMarket_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  optionMarket_starts_with?: InputMaybe<Scalars['String']['input']>;
  optionMarket_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  option_?: InputMaybe<Option_Filter>;
  option_contains?: InputMaybe<Scalars['String']['input']>;
  option_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  option_ends_with?: InputMaybe<Scalars['String']['input']>;
  option_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  option_gt?: InputMaybe<Scalars['String']['input']>;
  option_gte?: InputMaybe<Scalars['String']['input']>;
  option_in?: InputMaybe<Array<Scalars['String']['input']>>;
  option_lt?: InputMaybe<Scalars['String']['input']>;
  option_lte?: InputMaybe<Scalars['String']['input']>;
  option_not?: InputMaybe<Scalars['String']['input']>;
  option_not_contains?: InputMaybe<Scalars['String']['input']>;
  option_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  option_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  option_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  option_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  option_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  option_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  option_starts_with?: InputMaybe<Scalars['String']['input']>;
  option_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  or?: InputMaybe<Array<InputMaybe<MintOption_Filter>>>;
  priceAtAction?: InputMaybe<Scalars['BigInt']['input']>;
  priceAtAction_gt?: InputMaybe<Scalars['BigInt']['input']>;
  priceAtAction_gte?: InputMaybe<Scalars['BigInt']['input']>;
  priceAtAction_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  priceAtAction_lt?: InputMaybe<Scalars['BigInt']['input']>;
  priceAtAction_lte?: InputMaybe<Scalars['BigInt']['input']>;
  priceAtAction_not?: InputMaybe<Scalars['BigInt']['input']>;
  priceAtAction_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  receiver?: InputMaybe<Scalars['String']['input']>;
  receiver_contains?: InputMaybe<Scalars['String']['input']>;
  receiver_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  receiver_ends_with?: InputMaybe<Scalars['String']['input']>;
  receiver_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  receiver_gt?: InputMaybe<Scalars['String']['input']>;
  receiver_gte?: InputMaybe<Scalars['String']['input']>;
  receiver_in?: InputMaybe<Array<Scalars['String']['input']>>;
  receiver_lt?: InputMaybe<Scalars['String']['input']>;
  receiver_lte?: InputMaybe<Scalars['String']['input']>;
  receiver_not?: InputMaybe<Scalars['String']['input']>;
  receiver_not_contains?: InputMaybe<Scalars['String']['input']>;
  receiver_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  receiver_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  receiver_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  receiver_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  receiver_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  receiver_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  receiver_starts_with?: InputMaybe<Scalars['String']['input']>;
  receiver_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  referralId?: InputMaybe<Scalars['Bytes']['input']>;
  referralId_contains?: InputMaybe<Scalars['Bytes']['input']>;
  referralId_gt?: InputMaybe<Scalars['Bytes']['input']>;
  referralId_gte?: InputMaybe<Scalars['Bytes']['input']>;
  referralId_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  referralId_lt?: InputMaybe<Scalars['Bytes']['input']>;
  referralId_lte?: InputMaybe<Scalars['Bytes']['input']>;
  referralId_not?: InputMaybe<Scalars['Bytes']['input']>;
  referralId_not_contains?: InputMaybe<Scalars['Bytes']['input']>;
  referralId_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  size?: InputMaybe<Scalars['BigInt']['input']>;
  size_gt?: InputMaybe<Scalars['BigInt']['input']>;
  size_gte?: InputMaybe<Scalars['BigInt']['input']>;
  size_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  size_lt?: InputMaybe<Scalars['BigInt']['input']>;
  size_lte?: InputMaybe<Scalars['BigInt']['input']>;
  size_not?: InputMaybe<Scalars['BigInt']['input']>;
  size_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  timestamp?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_gt?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_gte?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  timestamp_lt?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_lte?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_not?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  user?: InputMaybe<Scalars['String']['input']>;
  user_contains?: InputMaybe<Scalars['String']['input']>;
  user_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  user_ends_with?: InputMaybe<Scalars['String']['input']>;
  user_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  user_gt?: InputMaybe<Scalars['String']['input']>;
  user_gte?: InputMaybe<Scalars['String']['input']>;
  user_in?: InputMaybe<Array<Scalars['String']['input']>>;
  user_lt?: InputMaybe<Scalars['String']['input']>;
  user_lte?: InputMaybe<Scalars['String']['input']>;
  user_not?: InputMaybe<Scalars['String']['input']>;
  user_not_contains?: InputMaybe<Scalars['String']['input']>;
  user_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  user_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  user_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  user_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  user_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  user_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  user_starts_with?: InputMaybe<Scalars['String']['input']>;
  user_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
};

export enum MintOption_OrderBy {
  FrontendId = 'frontendId',
  Id = 'id',
  Option = 'option',
  OptionMarket = 'optionMarket',
  OptionMarketDpFee = 'optionMarket__dpFee',
  OptionMarketId = 'optionMarket__id',
  OptionMarketOptionsPricing = 'optionMarket__optionsPricing',
  OptionMarketPrimePool = 'optionMarket__primePool',
  OptionMarketTokenUriFetcher = 'optionMarket__tokenURIFetcher',
  OptionMarketTotalFees = 'optionMarket__totalFees',
  OptionMarketTotalPremium = 'optionMarket__totalPremium',
  OptionMarketTotalVolume = 'optionMarket__totalVolume',
  OptionExpiry = 'option__expiry',
  OptionId = 'option__id',
  OptionInitialSize = 'option__initialSize',
  OptionIsCall = 'option__isCall',
  OptionPremium = 'option__premium',
  OptionPurchasePrice = 'option__purchasePrice',
  OptionSize = 'option__size',
  OptionTickLower = 'option__tickLower',
  OptionTickUpper = 'option__tickUpper',
  OptionTimestamp = 'option__timestamp',
  OptionTokenId = 'option__tokenId',
  OptionUser = 'option__user',
  PriceAtAction = 'priceAtAction',
  Receiver = 'receiver',
  ReferralId = 'referralId',
  Size = 'size',
  Timestamp = 'timestamp',
  User = 'user'
}

export type MintPosition = {
  __typename?: 'MintPosition';
  frontendId: Scalars['Bytes']['output'];
  handler: Scalars['String']['output'];
  hook: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  liquidity: Scalars['BigInt']['output'];
  lpPosition: LpPosition;
  pool: Scalars['String']['output'];
  receiver: Scalars['String']['output'];
  referralId: Scalars['Bytes']['output'];
  sharesMinted: Scalars['BigInt']['output'];
  sqrtPriceX96: Scalars['BigInt']['output'];
  strike: Strike;
  timestamp: Scalars['BigInt']['output'];
  tokenId: Scalars['BigInt']['output'];
  user: Scalars['String']['output'];
};

export type MintPosition_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<MintPosition_Filter>>>;
  frontendId?: InputMaybe<Scalars['Bytes']['input']>;
  frontendId_contains?: InputMaybe<Scalars['Bytes']['input']>;
  frontendId_gt?: InputMaybe<Scalars['Bytes']['input']>;
  frontendId_gte?: InputMaybe<Scalars['Bytes']['input']>;
  frontendId_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  frontendId_lt?: InputMaybe<Scalars['Bytes']['input']>;
  frontendId_lte?: InputMaybe<Scalars['Bytes']['input']>;
  frontendId_not?: InputMaybe<Scalars['Bytes']['input']>;
  frontendId_not_contains?: InputMaybe<Scalars['Bytes']['input']>;
  frontendId_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  handler?: InputMaybe<Scalars['String']['input']>;
  handler_contains?: InputMaybe<Scalars['String']['input']>;
  handler_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  handler_ends_with?: InputMaybe<Scalars['String']['input']>;
  handler_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  handler_gt?: InputMaybe<Scalars['String']['input']>;
  handler_gte?: InputMaybe<Scalars['String']['input']>;
  handler_in?: InputMaybe<Array<Scalars['String']['input']>>;
  handler_lt?: InputMaybe<Scalars['String']['input']>;
  handler_lte?: InputMaybe<Scalars['String']['input']>;
  handler_not?: InputMaybe<Scalars['String']['input']>;
  handler_not_contains?: InputMaybe<Scalars['String']['input']>;
  handler_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  handler_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  handler_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  handler_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  handler_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  handler_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  handler_starts_with?: InputMaybe<Scalars['String']['input']>;
  handler_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  hook?: InputMaybe<Scalars['String']['input']>;
  hook_contains?: InputMaybe<Scalars['String']['input']>;
  hook_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  hook_ends_with?: InputMaybe<Scalars['String']['input']>;
  hook_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  hook_gt?: InputMaybe<Scalars['String']['input']>;
  hook_gte?: InputMaybe<Scalars['String']['input']>;
  hook_in?: InputMaybe<Array<Scalars['String']['input']>>;
  hook_lt?: InputMaybe<Scalars['String']['input']>;
  hook_lte?: InputMaybe<Scalars['String']['input']>;
  hook_not?: InputMaybe<Scalars['String']['input']>;
  hook_not_contains?: InputMaybe<Scalars['String']['input']>;
  hook_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  hook_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  hook_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  hook_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  hook_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  hook_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  hook_starts_with?: InputMaybe<Scalars['String']['input']>;
  hook_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  liquidity?: InputMaybe<Scalars['BigInt']['input']>;
  liquidity_gt?: InputMaybe<Scalars['BigInt']['input']>;
  liquidity_gte?: InputMaybe<Scalars['BigInt']['input']>;
  liquidity_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  liquidity_lt?: InputMaybe<Scalars['BigInt']['input']>;
  liquidity_lte?: InputMaybe<Scalars['BigInt']['input']>;
  liquidity_not?: InputMaybe<Scalars['BigInt']['input']>;
  liquidity_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  lpPosition?: InputMaybe<Scalars['String']['input']>;
  lpPosition_?: InputMaybe<LpPosition_Filter>;
  lpPosition_contains?: InputMaybe<Scalars['String']['input']>;
  lpPosition_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  lpPosition_ends_with?: InputMaybe<Scalars['String']['input']>;
  lpPosition_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  lpPosition_gt?: InputMaybe<Scalars['String']['input']>;
  lpPosition_gte?: InputMaybe<Scalars['String']['input']>;
  lpPosition_in?: InputMaybe<Array<Scalars['String']['input']>>;
  lpPosition_lt?: InputMaybe<Scalars['String']['input']>;
  lpPosition_lte?: InputMaybe<Scalars['String']['input']>;
  lpPosition_not?: InputMaybe<Scalars['String']['input']>;
  lpPosition_not_contains?: InputMaybe<Scalars['String']['input']>;
  lpPosition_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  lpPosition_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  lpPosition_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  lpPosition_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  lpPosition_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  lpPosition_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  lpPosition_starts_with?: InputMaybe<Scalars['String']['input']>;
  lpPosition_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  or?: InputMaybe<Array<InputMaybe<MintPosition_Filter>>>;
  pool?: InputMaybe<Scalars['String']['input']>;
  pool_contains?: InputMaybe<Scalars['String']['input']>;
  pool_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  pool_ends_with?: InputMaybe<Scalars['String']['input']>;
  pool_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  pool_gt?: InputMaybe<Scalars['String']['input']>;
  pool_gte?: InputMaybe<Scalars['String']['input']>;
  pool_in?: InputMaybe<Array<Scalars['String']['input']>>;
  pool_lt?: InputMaybe<Scalars['String']['input']>;
  pool_lte?: InputMaybe<Scalars['String']['input']>;
  pool_not?: InputMaybe<Scalars['String']['input']>;
  pool_not_contains?: InputMaybe<Scalars['String']['input']>;
  pool_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  pool_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  pool_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  pool_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  pool_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  pool_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  pool_starts_with?: InputMaybe<Scalars['String']['input']>;
  pool_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  receiver?: InputMaybe<Scalars['String']['input']>;
  receiver_contains?: InputMaybe<Scalars['String']['input']>;
  receiver_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  receiver_ends_with?: InputMaybe<Scalars['String']['input']>;
  receiver_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  receiver_gt?: InputMaybe<Scalars['String']['input']>;
  receiver_gte?: InputMaybe<Scalars['String']['input']>;
  receiver_in?: InputMaybe<Array<Scalars['String']['input']>>;
  receiver_lt?: InputMaybe<Scalars['String']['input']>;
  receiver_lte?: InputMaybe<Scalars['String']['input']>;
  receiver_not?: InputMaybe<Scalars['String']['input']>;
  receiver_not_contains?: InputMaybe<Scalars['String']['input']>;
  receiver_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  receiver_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  receiver_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  receiver_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  receiver_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  receiver_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  receiver_starts_with?: InputMaybe<Scalars['String']['input']>;
  receiver_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  referralId?: InputMaybe<Scalars['Bytes']['input']>;
  referralId_contains?: InputMaybe<Scalars['Bytes']['input']>;
  referralId_gt?: InputMaybe<Scalars['Bytes']['input']>;
  referralId_gte?: InputMaybe<Scalars['Bytes']['input']>;
  referralId_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  referralId_lt?: InputMaybe<Scalars['Bytes']['input']>;
  referralId_lte?: InputMaybe<Scalars['Bytes']['input']>;
  referralId_not?: InputMaybe<Scalars['Bytes']['input']>;
  referralId_not_contains?: InputMaybe<Scalars['Bytes']['input']>;
  referralId_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  sharesMinted?: InputMaybe<Scalars['BigInt']['input']>;
  sharesMinted_gt?: InputMaybe<Scalars['BigInt']['input']>;
  sharesMinted_gte?: InputMaybe<Scalars['BigInt']['input']>;
  sharesMinted_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  sharesMinted_lt?: InputMaybe<Scalars['BigInt']['input']>;
  sharesMinted_lte?: InputMaybe<Scalars['BigInt']['input']>;
  sharesMinted_not?: InputMaybe<Scalars['BigInt']['input']>;
  sharesMinted_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  sqrtPriceX96?: InputMaybe<Scalars['BigInt']['input']>;
  sqrtPriceX96_gt?: InputMaybe<Scalars['BigInt']['input']>;
  sqrtPriceX96_gte?: InputMaybe<Scalars['BigInt']['input']>;
  sqrtPriceX96_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  sqrtPriceX96_lt?: InputMaybe<Scalars['BigInt']['input']>;
  sqrtPriceX96_lte?: InputMaybe<Scalars['BigInt']['input']>;
  sqrtPriceX96_not?: InputMaybe<Scalars['BigInt']['input']>;
  sqrtPriceX96_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  strike?: InputMaybe<Scalars['String']['input']>;
  strike_?: InputMaybe<Strike_Filter>;
  strike_contains?: InputMaybe<Scalars['String']['input']>;
  strike_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  strike_ends_with?: InputMaybe<Scalars['String']['input']>;
  strike_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  strike_gt?: InputMaybe<Scalars['String']['input']>;
  strike_gte?: InputMaybe<Scalars['String']['input']>;
  strike_in?: InputMaybe<Array<Scalars['String']['input']>>;
  strike_lt?: InputMaybe<Scalars['String']['input']>;
  strike_lte?: InputMaybe<Scalars['String']['input']>;
  strike_not?: InputMaybe<Scalars['String']['input']>;
  strike_not_contains?: InputMaybe<Scalars['String']['input']>;
  strike_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  strike_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  strike_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  strike_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  strike_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  strike_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  strike_starts_with?: InputMaybe<Scalars['String']['input']>;
  strike_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  timestamp?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_gt?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_gte?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  timestamp_lt?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_lte?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_not?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  tokenId?: InputMaybe<Scalars['BigInt']['input']>;
  tokenId_gt?: InputMaybe<Scalars['BigInt']['input']>;
  tokenId_gte?: InputMaybe<Scalars['BigInt']['input']>;
  tokenId_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  tokenId_lt?: InputMaybe<Scalars['BigInt']['input']>;
  tokenId_lte?: InputMaybe<Scalars['BigInt']['input']>;
  tokenId_not?: InputMaybe<Scalars['BigInt']['input']>;
  tokenId_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  user?: InputMaybe<Scalars['String']['input']>;
  user_contains?: InputMaybe<Scalars['String']['input']>;
  user_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  user_ends_with?: InputMaybe<Scalars['String']['input']>;
  user_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  user_gt?: InputMaybe<Scalars['String']['input']>;
  user_gte?: InputMaybe<Scalars['String']['input']>;
  user_in?: InputMaybe<Array<Scalars['String']['input']>>;
  user_lt?: InputMaybe<Scalars['String']['input']>;
  user_lte?: InputMaybe<Scalars['String']['input']>;
  user_not?: InputMaybe<Scalars['String']['input']>;
  user_not_contains?: InputMaybe<Scalars['String']['input']>;
  user_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  user_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  user_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  user_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  user_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  user_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  user_starts_with?: InputMaybe<Scalars['String']['input']>;
  user_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
};

export enum MintPosition_OrderBy {
  FrontendId = 'frontendId',
  Handler = 'handler',
  Hook = 'hook',
  Id = 'id',
  Liquidity = 'liquidity',
  LpPosition = 'lpPosition',
  LpPositionHandler = 'lpPosition__handler',
  LpPositionHook = 'lpPosition__hook',
  LpPositionId = 'lpPosition__id',
  LpPositionInitalSqrtPriceX96 = 'lpPosition__initalSqrtPriceX96',
  LpPositionInitialLiquidity = 'lpPosition__initialLiquidity',
  LpPositionLastReserve = 'lpPosition__lastReserve',
  LpPositionPool = 'lpPosition__pool',
  LpPositionReservedLiquidity = 'lpPosition__reservedLiquidity',
  LpPositionShares = 'lpPosition__shares',
  LpPositionTimestamp = 'lpPosition__timestamp',
  LpPositionUser = 'lpPosition__user',
  Pool = 'pool',
  Receiver = 'receiver',
  ReferralId = 'referralId',
  SharesMinted = 'sharesMinted',
  SqrtPriceX96 = 'sqrtPriceX96',
  Strike = 'strike',
  StrikeFeeGrowthInside0LastX128 = 'strike__feeGrowthInside0LastX128',
  StrikeFeeGrowthInside1LastX128 = 'strike__feeGrowthInside1LastX128',
  StrikeHandler = 'strike__handler',
  StrikeHook = 'strike__hook',
  StrikeId = 'strike__id',
  StrikePool = 'strike__pool',
  StrikeReservedLiquidity = 'strike__reservedLiquidity',
  StrikeTickLower = 'strike__tickLower',
  StrikeTickUpper = 'strike__tickUpper',
  StrikeTotalLiquidity = 'strike__totalLiquidity',
  StrikeTotalShares = 'strike__totalShares',
  StrikeUsedLiquidity = 'strike__usedLiquidity',
  Timestamp = 'timestamp',
  TokenId = 'tokenId',
  User = 'user'
}

export type Option = {
  __typename?: 'Option';
  expiry: Scalars['BigInt']['output'];
  handlers?: Maybe<Array<Scalars['String']['output']>>;
  hooks?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['ID']['output'];
  initialSize: Scalars['BigInt']['output'];
  isCall: Scalars['Boolean']['output'];
  liquidities?: Maybe<Array<Scalars['BigInt']['output']>>;
  mintOption: Array<MintOption>;
  optionMarket: OptionMarket;
  pools?: Maybe<Array<Scalars['String']['output']>>;
  premium: Scalars['BigInt']['output'];
  purchasePrice: Scalars['BigInt']['output'];
  size: Scalars['BigInt']['output'];
  tickLower: Scalars['Int']['output'];
  tickUpper: Scalars['Int']['output'];
  timestamp: Scalars['BigInt']['output'];
  tokenId: Scalars['BigInt']['output'];
  user: Scalars['String']['output'];
};


export type OptionMintOptionArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<MintOption_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MintOption_Filter>;
};

export type OptionMarket = {
  __typename?: 'OptionMarket';
  callToken: Token;
  dpFee: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  optionsPricing: Scalars['String']['output'];
  primePool: Scalars['String']['output'];
  putToken: Token;
  tokenURIFetcher?: Maybe<Scalars['String']['output']>;
  totalFees: Scalars['BigDecimal']['output'];
  totalPremium: Scalars['BigDecimal']['output'];
  totalVolume: Scalars['BigDecimal']['output'];
};

export type OptionMarketDailyStat = {
  __typename?: 'OptionMarketDailyStat';
  fees: Scalars['BigDecimal']['output'];
  id: Scalars['ID']['output'];
  optionMarket: OptionMarket;
  premium: Scalars['BigDecimal']['output'];
  startTimestamp: Scalars['BigInt']['output'];
  volume: Scalars['BigDecimal']['output'];
};

export type OptionMarketDailyStat_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<OptionMarketDailyStat_Filter>>>;
  fees?: InputMaybe<Scalars['BigDecimal']['input']>;
  fees_gt?: InputMaybe<Scalars['BigDecimal']['input']>;
  fees_gte?: InputMaybe<Scalars['BigDecimal']['input']>;
  fees_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  fees_lt?: InputMaybe<Scalars['BigDecimal']['input']>;
  fees_lte?: InputMaybe<Scalars['BigDecimal']['input']>;
  fees_not?: InputMaybe<Scalars['BigDecimal']['input']>;
  fees_not_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  optionMarket?: InputMaybe<Scalars['String']['input']>;
  optionMarket_?: InputMaybe<OptionMarket_Filter>;
  optionMarket_contains?: InputMaybe<Scalars['String']['input']>;
  optionMarket_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  optionMarket_ends_with?: InputMaybe<Scalars['String']['input']>;
  optionMarket_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  optionMarket_gt?: InputMaybe<Scalars['String']['input']>;
  optionMarket_gte?: InputMaybe<Scalars['String']['input']>;
  optionMarket_in?: InputMaybe<Array<Scalars['String']['input']>>;
  optionMarket_lt?: InputMaybe<Scalars['String']['input']>;
  optionMarket_lte?: InputMaybe<Scalars['String']['input']>;
  optionMarket_not?: InputMaybe<Scalars['String']['input']>;
  optionMarket_not_contains?: InputMaybe<Scalars['String']['input']>;
  optionMarket_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  optionMarket_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  optionMarket_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  optionMarket_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  optionMarket_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  optionMarket_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  optionMarket_starts_with?: InputMaybe<Scalars['String']['input']>;
  optionMarket_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  or?: InputMaybe<Array<InputMaybe<OptionMarketDailyStat_Filter>>>;
  premium?: InputMaybe<Scalars['BigDecimal']['input']>;
  premium_gt?: InputMaybe<Scalars['BigDecimal']['input']>;
  premium_gte?: InputMaybe<Scalars['BigDecimal']['input']>;
  premium_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  premium_lt?: InputMaybe<Scalars['BigDecimal']['input']>;
  premium_lte?: InputMaybe<Scalars['BigDecimal']['input']>;
  premium_not?: InputMaybe<Scalars['BigDecimal']['input']>;
  premium_not_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  startTimestamp?: InputMaybe<Scalars['BigInt']['input']>;
  startTimestamp_gt?: InputMaybe<Scalars['BigInt']['input']>;
  startTimestamp_gte?: InputMaybe<Scalars['BigInt']['input']>;
  startTimestamp_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  startTimestamp_lt?: InputMaybe<Scalars['BigInt']['input']>;
  startTimestamp_lte?: InputMaybe<Scalars['BigInt']['input']>;
  startTimestamp_not?: InputMaybe<Scalars['BigInt']['input']>;
  startTimestamp_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  volume?: InputMaybe<Scalars['BigDecimal']['input']>;
  volume_gt?: InputMaybe<Scalars['BigDecimal']['input']>;
  volume_gte?: InputMaybe<Scalars['BigDecimal']['input']>;
  volume_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  volume_lt?: InputMaybe<Scalars['BigDecimal']['input']>;
  volume_lte?: InputMaybe<Scalars['BigDecimal']['input']>;
  volume_not?: InputMaybe<Scalars['BigDecimal']['input']>;
  volume_not_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
};

export enum OptionMarketDailyStat_OrderBy {
  Fees = 'fees',
  Id = 'id',
  OptionMarket = 'optionMarket',
  OptionMarketDpFee = 'optionMarket__dpFee',
  OptionMarketId = 'optionMarket__id',
  OptionMarketOptionsPricing = 'optionMarket__optionsPricing',
  OptionMarketPrimePool = 'optionMarket__primePool',
  OptionMarketTokenUriFetcher = 'optionMarket__tokenURIFetcher',
  OptionMarketTotalFees = 'optionMarket__totalFees',
  OptionMarketTotalPremium = 'optionMarket__totalPremium',
  OptionMarketTotalVolume = 'optionMarket__totalVolume',
  Premium = 'premium',
  StartTimestamp = 'startTimestamp',
  Volume = 'volume'
}

export type OptionMarket_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<OptionMarket_Filter>>>;
  callToken?: InputMaybe<Scalars['String']['input']>;
  callToken_?: InputMaybe<Token_Filter>;
  callToken_contains?: InputMaybe<Scalars['String']['input']>;
  callToken_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  callToken_ends_with?: InputMaybe<Scalars['String']['input']>;
  callToken_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  callToken_gt?: InputMaybe<Scalars['String']['input']>;
  callToken_gte?: InputMaybe<Scalars['String']['input']>;
  callToken_in?: InputMaybe<Array<Scalars['String']['input']>>;
  callToken_lt?: InputMaybe<Scalars['String']['input']>;
  callToken_lte?: InputMaybe<Scalars['String']['input']>;
  callToken_not?: InputMaybe<Scalars['String']['input']>;
  callToken_not_contains?: InputMaybe<Scalars['String']['input']>;
  callToken_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  callToken_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  callToken_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  callToken_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  callToken_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  callToken_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  callToken_starts_with?: InputMaybe<Scalars['String']['input']>;
  callToken_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  dpFee?: InputMaybe<Scalars['String']['input']>;
  dpFee_contains?: InputMaybe<Scalars['String']['input']>;
  dpFee_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  dpFee_ends_with?: InputMaybe<Scalars['String']['input']>;
  dpFee_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  dpFee_gt?: InputMaybe<Scalars['String']['input']>;
  dpFee_gte?: InputMaybe<Scalars['String']['input']>;
  dpFee_in?: InputMaybe<Array<Scalars['String']['input']>>;
  dpFee_lt?: InputMaybe<Scalars['String']['input']>;
  dpFee_lte?: InputMaybe<Scalars['String']['input']>;
  dpFee_not?: InputMaybe<Scalars['String']['input']>;
  dpFee_not_contains?: InputMaybe<Scalars['String']['input']>;
  dpFee_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  dpFee_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  dpFee_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  dpFee_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  dpFee_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  dpFee_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  dpFee_starts_with?: InputMaybe<Scalars['String']['input']>;
  dpFee_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  optionsPricing?: InputMaybe<Scalars['String']['input']>;
  optionsPricing_contains?: InputMaybe<Scalars['String']['input']>;
  optionsPricing_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  optionsPricing_ends_with?: InputMaybe<Scalars['String']['input']>;
  optionsPricing_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  optionsPricing_gt?: InputMaybe<Scalars['String']['input']>;
  optionsPricing_gte?: InputMaybe<Scalars['String']['input']>;
  optionsPricing_in?: InputMaybe<Array<Scalars['String']['input']>>;
  optionsPricing_lt?: InputMaybe<Scalars['String']['input']>;
  optionsPricing_lte?: InputMaybe<Scalars['String']['input']>;
  optionsPricing_not?: InputMaybe<Scalars['String']['input']>;
  optionsPricing_not_contains?: InputMaybe<Scalars['String']['input']>;
  optionsPricing_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  optionsPricing_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  optionsPricing_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  optionsPricing_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  optionsPricing_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  optionsPricing_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  optionsPricing_starts_with?: InputMaybe<Scalars['String']['input']>;
  optionsPricing_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  or?: InputMaybe<Array<InputMaybe<OptionMarket_Filter>>>;
  primePool?: InputMaybe<Scalars['String']['input']>;
  primePool_contains?: InputMaybe<Scalars['String']['input']>;
  primePool_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  primePool_ends_with?: InputMaybe<Scalars['String']['input']>;
  primePool_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  primePool_gt?: InputMaybe<Scalars['String']['input']>;
  primePool_gte?: InputMaybe<Scalars['String']['input']>;
  primePool_in?: InputMaybe<Array<Scalars['String']['input']>>;
  primePool_lt?: InputMaybe<Scalars['String']['input']>;
  primePool_lte?: InputMaybe<Scalars['String']['input']>;
  primePool_not?: InputMaybe<Scalars['String']['input']>;
  primePool_not_contains?: InputMaybe<Scalars['String']['input']>;
  primePool_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  primePool_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  primePool_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  primePool_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  primePool_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  primePool_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  primePool_starts_with?: InputMaybe<Scalars['String']['input']>;
  primePool_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  putToken?: InputMaybe<Scalars['String']['input']>;
  putToken_?: InputMaybe<Token_Filter>;
  putToken_contains?: InputMaybe<Scalars['String']['input']>;
  putToken_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  putToken_ends_with?: InputMaybe<Scalars['String']['input']>;
  putToken_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  putToken_gt?: InputMaybe<Scalars['String']['input']>;
  putToken_gte?: InputMaybe<Scalars['String']['input']>;
  putToken_in?: InputMaybe<Array<Scalars['String']['input']>>;
  putToken_lt?: InputMaybe<Scalars['String']['input']>;
  putToken_lte?: InputMaybe<Scalars['String']['input']>;
  putToken_not?: InputMaybe<Scalars['String']['input']>;
  putToken_not_contains?: InputMaybe<Scalars['String']['input']>;
  putToken_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  putToken_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  putToken_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  putToken_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  putToken_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  putToken_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  putToken_starts_with?: InputMaybe<Scalars['String']['input']>;
  putToken_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  tokenURIFetcher?: InputMaybe<Scalars['String']['input']>;
  tokenURIFetcher_contains?: InputMaybe<Scalars['String']['input']>;
  tokenURIFetcher_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  tokenURIFetcher_ends_with?: InputMaybe<Scalars['String']['input']>;
  tokenURIFetcher_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  tokenURIFetcher_gt?: InputMaybe<Scalars['String']['input']>;
  tokenURIFetcher_gte?: InputMaybe<Scalars['String']['input']>;
  tokenURIFetcher_in?: InputMaybe<Array<Scalars['String']['input']>>;
  tokenURIFetcher_lt?: InputMaybe<Scalars['String']['input']>;
  tokenURIFetcher_lte?: InputMaybe<Scalars['String']['input']>;
  tokenURIFetcher_not?: InputMaybe<Scalars['String']['input']>;
  tokenURIFetcher_not_contains?: InputMaybe<Scalars['String']['input']>;
  tokenURIFetcher_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  tokenURIFetcher_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  tokenURIFetcher_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  tokenURIFetcher_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  tokenURIFetcher_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  tokenURIFetcher_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  tokenURIFetcher_starts_with?: InputMaybe<Scalars['String']['input']>;
  tokenURIFetcher_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  totalFees?: InputMaybe<Scalars['BigDecimal']['input']>;
  totalFees_gt?: InputMaybe<Scalars['BigDecimal']['input']>;
  totalFees_gte?: InputMaybe<Scalars['BigDecimal']['input']>;
  totalFees_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  totalFees_lt?: InputMaybe<Scalars['BigDecimal']['input']>;
  totalFees_lte?: InputMaybe<Scalars['BigDecimal']['input']>;
  totalFees_not?: InputMaybe<Scalars['BigDecimal']['input']>;
  totalFees_not_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  totalPremium?: InputMaybe<Scalars['BigDecimal']['input']>;
  totalPremium_gt?: InputMaybe<Scalars['BigDecimal']['input']>;
  totalPremium_gte?: InputMaybe<Scalars['BigDecimal']['input']>;
  totalPremium_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  totalPremium_lt?: InputMaybe<Scalars['BigDecimal']['input']>;
  totalPremium_lte?: InputMaybe<Scalars['BigDecimal']['input']>;
  totalPremium_not?: InputMaybe<Scalars['BigDecimal']['input']>;
  totalPremium_not_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  totalVolume?: InputMaybe<Scalars['BigDecimal']['input']>;
  totalVolume_gt?: InputMaybe<Scalars['BigDecimal']['input']>;
  totalVolume_gte?: InputMaybe<Scalars['BigDecimal']['input']>;
  totalVolume_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  totalVolume_lt?: InputMaybe<Scalars['BigDecimal']['input']>;
  totalVolume_lte?: InputMaybe<Scalars['BigDecimal']['input']>;
  totalVolume_not?: InputMaybe<Scalars['BigDecimal']['input']>;
  totalVolume_not_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
};

export enum OptionMarket_OrderBy {
  CallToken = 'callToken',
  CallTokenDecimals = 'callToken__decimals',
  CallTokenId = 'callToken__id',
  CallTokenSymbol = 'callToken__symbol',
  DpFee = 'dpFee',
  Id = 'id',
  OptionsPricing = 'optionsPricing',
  PrimePool = 'primePool',
  PutToken = 'putToken',
  PutTokenDecimals = 'putToken__decimals',
  PutTokenId = 'putToken__id',
  PutTokenSymbol = 'putToken__symbol',
  TokenUriFetcher = 'tokenURIFetcher',
  TotalFees = 'totalFees',
  TotalPremium = 'totalPremium',
  TotalVolume = 'totalVolume'
}

export type Option_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<Option_Filter>>>;
  expiry?: InputMaybe<Scalars['BigInt']['input']>;
  expiry_gt?: InputMaybe<Scalars['BigInt']['input']>;
  expiry_gte?: InputMaybe<Scalars['BigInt']['input']>;
  expiry_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  expiry_lt?: InputMaybe<Scalars['BigInt']['input']>;
  expiry_lte?: InputMaybe<Scalars['BigInt']['input']>;
  expiry_not?: InputMaybe<Scalars['BigInt']['input']>;
  expiry_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  handlers?: InputMaybe<Array<Scalars['String']['input']>>;
  handlers_contains?: InputMaybe<Array<Scalars['String']['input']>>;
  handlers_contains_nocase?: InputMaybe<Array<Scalars['String']['input']>>;
  handlers_not?: InputMaybe<Array<Scalars['String']['input']>>;
  handlers_not_contains?: InputMaybe<Array<Scalars['String']['input']>>;
  handlers_not_contains_nocase?: InputMaybe<Array<Scalars['String']['input']>>;
  hooks?: InputMaybe<Array<Scalars['String']['input']>>;
  hooks_contains?: InputMaybe<Array<Scalars['String']['input']>>;
  hooks_contains_nocase?: InputMaybe<Array<Scalars['String']['input']>>;
  hooks_not?: InputMaybe<Array<Scalars['String']['input']>>;
  hooks_not_contains?: InputMaybe<Array<Scalars['String']['input']>>;
  hooks_not_contains_nocase?: InputMaybe<Array<Scalars['String']['input']>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  initialSize?: InputMaybe<Scalars['BigInt']['input']>;
  initialSize_gt?: InputMaybe<Scalars['BigInt']['input']>;
  initialSize_gte?: InputMaybe<Scalars['BigInt']['input']>;
  initialSize_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  initialSize_lt?: InputMaybe<Scalars['BigInt']['input']>;
  initialSize_lte?: InputMaybe<Scalars['BigInt']['input']>;
  initialSize_not?: InputMaybe<Scalars['BigInt']['input']>;
  initialSize_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  isCall?: InputMaybe<Scalars['Boolean']['input']>;
  isCall_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isCall_not?: InputMaybe<Scalars['Boolean']['input']>;
  isCall_not_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  liquidities?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  liquidities_contains?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  liquidities_contains_nocase?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  liquidities_not?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  liquidities_not_contains?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  liquidities_not_contains_nocase?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  mintOption_?: InputMaybe<MintOption_Filter>;
  optionMarket?: InputMaybe<Scalars['String']['input']>;
  optionMarket_?: InputMaybe<OptionMarket_Filter>;
  optionMarket_contains?: InputMaybe<Scalars['String']['input']>;
  optionMarket_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  optionMarket_ends_with?: InputMaybe<Scalars['String']['input']>;
  optionMarket_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  optionMarket_gt?: InputMaybe<Scalars['String']['input']>;
  optionMarket_gte?: InputMaybe<Scalars['String']['input']>;
  optionMarket_in?: InputMaybe<Array<Scalars['String']['input']>>;
  optionMarket_lt?: InputMaybe<Scalars['String']['input']>;
  optionMarket_lte?: InputMaybe<Scalars['String']['input']>;
  optionMarket_not?: InputMaybe<Scalars['String']['input']>;
  optionMarket_not_contains?: InputMaybe<Scalars['String']['input']>;
  optionMarket_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  optionMarket_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  optionMarket_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  optionMarket_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  optionMarket_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  optionMarket_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  optionMarket_starts_with?: InputMaybe<Scalars['String']['input']>;
  optionMarket_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  or?: InputMaybe<Array<InputMaybe<Option_Filter>>>;
  pools?: InputMaybe<Array<Scalars['String']['input']>>;
  pools_contains?: InputMaybe<Array<Scalars['String']['input']>>;
  pools_contains_nocase?: InputMaybe<Array<Scalars['String']['input']>>;
  pools_not?: InputMaybe<Array<Scalars['String']['input']>>;
  pools_not_contains?: InputMaybe<Array<Scalars['String']['input']>>;
  pools_not_contains_nocase?: InputMaybe<Array<Scalars['String']['input']>>;
  premium?: InputMaybe<Scalars['BigInt']['input']>;
  premium_gt?: InputMaybe<Scalars['BigInt']['input']>;
  premium_gte?: InputMaybe<Scalars['BigInt']['input']>;
  premium_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  premium_lt?: InputMaybe<Scalars['BigInt']['input']>;
  premium_lte?: InputMaybe<Scalars['BigInt']['input']>;
  premium_not?: InputMaybe<Scalars['BigInt']['input']>;
  premium_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  purchasePrice?: InputMaybe<Scalars['BigInt']['input']>;
  purchasePrice_gt?: InputMaybe<Scalars['BigInt']['input']>;
  purchasePrice_gte?: InputMaybe<Scalars['BigInt']['input']>;
  purchasePrice_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  purchasePrice_lt?: InputMaybe<Scalars['BigInt']['input']>;
  purchasePrice_lte?: InputMaybe<Scalars['BigInt']['input']>;
  purchasePrice_not?: InputMaybe<Scalars['BigInt']['input']>;
  purchasePrice_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  size?: InputMaybe<Scalars['BigInt']['input']>;
  size_gt?: InputMaybe<Scalars['BigInt']['input']>;
  size_gte?: InputMaybe<Scalars['BigInt']['input']>;
  size_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  size_lt?: InputMaybe<Scalars['BigInt']['input']>;
  size_lte?: InputMaybe<Scalars['BigInt']['input']>;
  size_not?: InputMaybe<Scalars['BigInt']['input']>;
  size_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  tickLower?: InputMaybe<Scalars['Int']['input']>;
  tickLower_gt?: InputMaybe<Scalars['Int']['input']>;
  tickLower_gte?: InputMaybe<Scalars['Int']['input']>;
  tickLower_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  tickLower_lt?: InputMaybe<Scalars['Int']['input']>;
  tickLower_lte?: InputMaybe<Scalars['Int']['input']>;
  tickLower_not?: InputMaybe<Scalars['Int']['input']>;
  tickLower_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  tickUpper?: InputMaybe<Scalars['Int']['input']>;
  tickUpper_gt?: InputMaybe<Scalars['Int']['input']>;
  tickUpper_gte?: InputMaybe<Scalars['Int']['input']>;
  tickUpper_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  tickUpper_lt?: InputMaybe<Scalars['Int']['input']>;
  tickUpper_lte?: InputMaybe<Scalars['Int']['input']>;
  tickUpper_not?: InputMaybe<Scalars['Int']['input']>;
  tickUpper_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  timestamp?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_gt?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_gte?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  timestamp_lt?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_lte?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_not?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  tokenId?: InputMaybe<Scalars['BigInt']['input']>;
  tokenId_gt?: InputMaybe<Scalars['BigInt']['input']>;
  tokenId_gte?: InputMaybe<Scalars['BigInt']['input']>;
  tokenId_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  tokenId_lt?: InputMaybe<Scalars['BigInt']['input']>;
  tokenId_lte?: InputMaybe<Scalars['BigInt']['input']>;
  tokenId_not?: InputMaybe<Scalars['BigInt']['input']>;
  tokenId_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  user?: InputMaybe<Scalars['String']['input']>;
  user_contains?: InputMaybe<Scalars['String']['input']>;
  user_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  user_ends_with?: InputMaybe<Scalars['String']['input']>;
  user_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  user_gt?: InputMaybe<Scalars['String']['input']>;
  user_gte?: InputMaybe<Scalars['String']['input']>;
  user_in?: InputMaybe<Array<Scalars['String']['input']>>;
  user_lt?: InputMaybe<Scalars['String']['input']>;
  user_lte?: InputMaybe<Scalars['String']['input']>;
  user_not?: InputMaybe<Scalars['String']['input']>;
  user_not_contains?: InputMaybe<Scalars['String']['input']>;
  user_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  user_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  user_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  user_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  user_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  user_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  user_starts_with?: InputMaybe<Scalars['String']['input']>;
  user_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
};

export enum Option_OrderBy {
  Expiry = 'expiry',
  Handlers = 'handlers',
  Hooks = 'hooks',
  Id = 'id',
  InitialSize = 'initialSize',
  IsCall = 'isCall',
  Liquidities = 'liquidities',
  MintOption = 'mintOption',
  OptionMarket = 'optionMarket',
  OptionMarketDpFee = 'optionMarket__dpFee',
  OptionMarketId = 'optionMarket__id',
  OptionMarketOptionsPricing = 'optionMarket__optionsPricing',
  OptionMarketPrimePool = 'optionMarket__primePool',
  OptionMarketTokenUriFetcher = 'optionMarket__tokenURIFetcher',
  OptionMarketTotalFees = 'optionMarket__totalFees',
  OptionMarketTotalPremium = 'optionMarket__totalPremium',
  OptionMarketTotalVolume = 'optionMarket__totalVolume',
  Pools = 'pools',
  Premium = 'premium',
  PurchasePrice = 'purchasePrice',
  Size = 'size',
  TickLower = 'tickLower',
  TickUpper = 'tickUpper',
  Timestamp = 'timestamp',
  TokenId = 'tokenId',
  User = 'user'
}

export type OptionsExercise = {
  __typename?: 'OptionsExercise';
  id: Scalars['ID']['output'];
  option: Option;
  optionMarket: OptionMarket;
  priceAtAction: Scalars['BigInt']['output'];
  profit: Scalars['BigInt']['output'];
  size: Scalars['BigInt']['output'];
  timestamp: Scalars['BigInt']['output'];
  user: Scalars['String']['output'];
};

export type OptionsExercise_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<OptionsExercise_Filter>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  option?: InputMaybe<Scalars['String']['input']>;
  optionMarket?: InputMaybe<Scalars['String']['input']>;
  optionMarket_?: InputMaybe<OptionMarket_Filter>;
  optionMarket_contains?: InputMaybe<Scalars['String']['input']>;
  optionMarket_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  optionMarket_ends_with?: InputMaybe<Scalars['String']['input']>;
  optionMarket_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  optionMarket_gt?: InputMaybe<Scalars['String']['input']>;
  optionMarket_gte?: InputMaybe<Scalars['String']['input']>;
  optionMarket_in?: InputMaybe<Array<Scalars['String']['input']>>;
  optionMarket_lt?: InputMaybe<Scalars['String']['input']>;
  optionMarket_lte?: InputMaybe<Scalars['String']['input']>;
  optionMarket_not?: InputMaybe<Scalars['String']['input']>;
  optionMarket_not_contains?: InputMaybe<Scalars['String']['input']>;
  optionMarket_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  optionMarket_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  optionMarket_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  optionMarket_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  optionMarket_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  optionMarket_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  optionMarket_starts_with?: InputMaybe<Scalars['String']['input']>;
  optionMarket_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  option_?: InputMaybe<Option_Filter>;
  option_contains?: InputMaybe<Scalars['String']['input']>;
  option_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  option_ends_with?: InputMaybe<Scalars['String']['input']>;
  option_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  option_gt?: InputMaybe<Scalars['String']['input']>;
  option_gte?: InputMaybe<Scalars['String']['input']>;
  option_in?: InputMaybe<Array<Scalars['String']['input']>>;
  option_lt?: InputMaybe<Scalars['String']['input']>;
  option_lte?: InputMaybe<Scalars['String']['input']>;
  option_not?: InputMaybe<Scalars['String']['input']>;
  option_not_contains?: InputMaybe<Scalars['String']['input']>;
  option_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  option_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  option_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  option_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  option_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  option_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  option_starts_with?: InputMaybe<Scalars['String']['input']>;
  option_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  or?: InputMaybe<Array<InputMaybe<OptionsExercise_Filter>>>;
  priceAtAction?: InputMaybe<Scalars['BigInt']['input']>;
  priceAtAction_gt?: InputMaybe<Scalars['BigInt']['input']>;
  priceAtAction_gte?: InputMaybe<Scalars['BigInt']['input']>;
  priceAtAction_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  priceAtAction_lt?: InputMaybe<Scalars['BigInt']['input']>;
  priceAtAction_lte?: InputMaybe<Scalars['BigInt']['input']>;
  priceAtAction_not?: InputMaybe<Scalars['BigInt']['input']>;
  priceAtAction_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  profit?: InputMaybe<Scalars['BigInt']['input']>;
  profit_gt?: InputMaybe<Scalars['BigInt']['input']>;
  profit_gte?: InputMaybe<Scalars['BigInt']['input']>;
  profit_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  profit_lt?: InputMaybe<Scalars['BigInt']['input']>;
  profit_lte?: InputMaybe<Scalars['BigInt']['input']>;
  profit_not?: InputMaybe<Scalars['BigInt']['input']>;
  profit_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  size?: InputMaybe<Scalars['BigInt']['input']>;
  size_gt?: InputMaybe<Scalars['BigInt']['input']>;
  size_gte?: InputMaybe<Scalars['BigInt']['input']>;
  size_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  size_lt?: InputMaybe<Scalars['BigInt']['input']>;
  size_lte?: InputMaybe<Scalars['BigInt']['input']>;
  size_not?: InputMaybe<Scalars['BigInt']['input']>;
  size_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  timestamp?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_gt?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_gte?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  timestamp_lt?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_lte?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_not?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  user?: InputMaybe<Scalars['String']['input']>;
  user_contains?: InputMaybe<Scalars['String']['input']>;
  user_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  user_ends_with?: InputMaybe<Scalars['String']['input']>;
  user_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  user_gt?: InputMaybe<Scalars['String']['input']>;
  user_gte?: InputMaybe<Scalars['String']['input']>;
  user_in?: InputMaybe<Array<Scalars['String']['input']>>;
  user_lt?: InputMaybe<Scalars['String']['input']>;
  user_lte?: InputMaybe<Scalars['String']['input']>;
  user_not?: InputMaybe<Scalars['String']['input']>;
  user_not_contains?: InputMaybe<Scalars['String']['input']>;
  user_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  user_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  user_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  user_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  user_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  user_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  user_starts_with?: InputMaybe<Scalars['String']['input']>;
  user_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
};

export enum OptionsExercise_OrderBy {
  Id = 'id',
  Option = 'option',
  OptionMarket = 'optionMarket',
  OptionMarketDpFee = 'optionMarket__dpFee',
  OptionMarketId = 'optionMarket__id',
  OptionMarketOptionsPricing = 'optionMarket__optionsPricing',
  OptionMarketPrimePool = 'optionMarket__primePool',
  OptionMarketTokenUriFetcher = 'optionMarket__tokenURIFetcher',
  OptionMarketTotalFees = 'optionMarket__totalFees',
  OptionMarketTotalPremium = 'optionMarket__totalPremium',
  OptionMarketTotalVolume = 'optionMarket__totalVolume',
  OptionExpiry = 'option__expiry',
  OptionId = 'option__id',
  OptionInitialSize = 'option__initialSize',
  OptionIsCall = 'option__isCall',
  OptionPremium = 'option__premium',
  OptionPurchasePrice = 'option__purchasePrice',
  OptionSize = 'option__size',
  OptionTickLower = 'option__tickLower',
  OptionTickUpper = 'option__tickUpper',
  OptionTimestamp = 'option__timestamp',
  OptionTokenId = 'option__tokenId',
  OptionUser = 'option__user',
  PriceAtAction = 'priceAtAction',
  Profit = 'profit',
  Size = 'size',
  Timestamp = 'timestamp',
  User = 'user'
}

export type OptionsMint = {
  __typename?: 'OptionsMint';
  id: Scalars['ID']['output'];
  option: Option;
  optionMarket: OptionMarket;
  priceAtAction: Scalars['BigInt']['output'];
  size: Scalars['BigInt']['output'];
  timestamp: Scalars['BigInt']['output'];
  user: Scalars['String']['output'];
};

export type OptionsMint_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<OptionsMint_Filter>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  option?: InputMaybe<Scalars['String']['input']>;
  optionMarket?: InputMaybe<Scalars['String']['input']>;
  optionMarket_?: InputMaybe<OptionMarket_Filter>;
  optionMarket_contains?: InputMaybe<Scalars['String']['input']>;
  optionMarket_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  optionMarket_ends_with?: InputMaybe<Scalars['String']['input']>;
  optionMarket_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  optionMarket_gt?: InputMaybe<Scalars['String']['input']>;
  optionMarket_gte?: InputMaybe<Scalars['String']['input']>;
  optionMarket_in?: InputMaybe<Array<Scalars['String']['input']>>;
  optionMarket_lt?: InputMaybe<Scalars['String']['input']>;
  optionMarket_lte?: InputMaybe<Scalars['String']['input']>;
  optionMarket_not?: InputMaybe<Scalars['String']['input']>;
  optionMarket_not_contains?: InputMaybe<Scalars['String']['input']>;
  optionMarket_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  optionMarket_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  optionMarket_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  optionMarket_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  optionMarket_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  optionMarket_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  optionMarket_starts_with?: InputMaybe<Scalars['String']['input']>;
  optionMarket_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  option_?: InputMaybe<Option_Filter>;
  option_contains?: InputMaybe<Scalars['String']['input']>;
  option_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  option_ends_with?: InputMaybe<Scalars['String']['input']>;
  option_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  option_gt?: InputMaybe<Scalars['String']['input']>;
  option_gte?: InputMaybe<Scalars['String']['input']>;
  option_in?: InputMaybe<Array<Scalars['String']['input']>>;
  option_lt?: InputMaybe<Scalars['String']['input']>;
  option_lte?: InputMaybe<Scalars['String']['input']>;
  option_not?: InputMaybe<Scalars['String']['input']>;
  option_not_contains?: InputMaybe<Scalars['String']['input']>;
  option_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  option_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  option_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  option_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  option_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  option_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  option_starts_with?: InputMaybe<Scalars['String']['input']>;
  option_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  or?: InputMaybe<Array<InputMaybe<OptionsMint_Filter>>>;
  priceAtAction?: InputMaybe<Scalars['BigInt']['input']>;
  priceAtAction_gt?: InputMaybe<Scalars['BigInt']['input']>;
  priceAtAction_gte?: InputMaybe<Scalars['BigInt']['input']>;
  priceAtAction_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  priceAtAction_lt?: InputMaybe<Scalars['BigInt']['input']>;
  priceAtAction_lte?: InputMaybe<Scalars['BigInt']['input']>;
  priceAtAction_not?: InputMaybe<Scalars['BigInt']['input']>;
  priceAtAction_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  size?: InputMaybe<Scalars['BigInt']['input']>;
  size_gt?: InputMaybe<Scalars['BigInt']['input']>;
  size_gte?: InputMaybe<Scalars['BigInt']['input']>;
  size_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  size_lt?: InputMaybe<Scalars['BigInt']['input']>;
  size_lte?: InputMaybe<Scalars['BigInt']['input']>;
  size_not?: InputMaybe<Scalars['BigInt']['input']>;
  size_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  timestamp?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_gt?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_gte?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  timestamp_lt?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_lte?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_not?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  user?: InputMaybe<Scalars['String']['input']>;
  user_contains?: InputMaybe<Scalars['String']['input']>;
  user_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  user_ends_with?: InputMaybe<Scalars['String']['input']>;
  user_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  user_gt?: InputMaybe<Scalars['String']['input']>;
  user_gte?: InputMaybe<Scalars['String']['input']>;
  user_in?: InputMaybe<Array<Scalars['String']['input']>>;
  user_lt?: InputMaybe<Scalars['String']['input']>;
  user_lte?: InputMaybe<Scalars['String']['input']>;
  user_not?: InputMaybe<Scalars['String']['input']>;
  user_not_contains?: InputMaybe<Scalars['String']['input']>;
  user_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  user_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  user_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  user_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  user_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  user_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  user_starts_with?: InputMaybe<Scalars['String']['input']>;
  user_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
};

export enum OptionsMint_OrderBy {
  Id = 'id',
  Option = 'option',
  OptionMarket = 'optionMarket',
  OptionMarketDpFee = 'optionMarket__dpFee',
  OptionMarketId = 'optionMarket__id',
  OptionMarketOptionsPricing = 'optionMarket__optionsPricing',
  OptionMarketPrimePool = 'optionMarket__primePool',
  OptionMarketTokenUriFetcher = 'optionMarket__tokenURIFetcher',
  OptionMarketTotalFees = 'optionMarket__totalFees',
  OptionMarketTotalPremium = 'optionMarket__totalPremium',
  OptionMarketTotalVolume = 'optionMarket__totalVolume',
  OptionExpiry = 'option__expiry',
  OptionId = 'option__id',
  OptionInitialSize = 'option__initialSize',
  OptionIsCall = 'option__isCall',
  OptionPremium = 'option__premium',
  OptionPurchasePrice = 'option__purchasePrice',
  OptionSize = 'option__size',
  OptionTickLower = 'option__tickLower',
  OptionTickUpper = 'option__tickUpper',
  OptionTimestamp = 'option__timestamp',
  OptionTokenId = 'option__tokenId',
  OptionUser = 'option__user',
  PriceAtAction = 'priceAtAction',
  Size = 'size',
  Timestamp = 'timestamp',
  User = 'user'
}

export type OptionsSettle = {
  __typename?: 'OptionsSettle';
  id: Scalars['ID']['output'];
  option: Option;
  optionMarket: OptionMarket;
  priceAtAction: Scalars['BigInt']['output'];
  timestamp: Scalars['BigInt']['output'];
  user: Scalars['String']['output'];
};

export type OptionsSettle_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<OptionsSettle_Filter>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  option?: InputMaybe<Scalars['String']['input']>;
  optionMarket?: InputMaybe<Scalars['String']['input']>;
  optionMarket_?: InputMaybe<OptionMarket_Filter>;
  optionMarket_contains?: InputMaybe<Scalars['String']['input']>;
  optionMarket_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  optionMarket_ends_with?: InputMaybe<Scalars['String']['input']>;
  optionMarket_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  optionMarket_gt?: InputMaybe<Scalars['String']['input']>;
  optionMarket_gte?: InputMaybe<Scalars['String']['input']>;
  optionMarket_in?: InputMaybe<Array<Scalars['String']['input']>>;
  optionMarket_lt?: InputMaybe<Scalars['String']['input']>;
  optionMarket_lte?: InputMaybe<Scalars['String']['input']>;
  optionMarket_not?: InputMaybe<Scalars['String']['input']>;
  optionMarket_not_contains?: InputMaybe<Scalars['String']['input']>;
  optionMarket_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  optionMarket_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  optionMarket_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  optionMarket_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  optionMarket_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  optionMarket_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  optionMarket_starts_with?: InputMaybe<Scalars['String']['input']>;
  optionMarket_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  option_?: InputMaybe<Option_Filter>;
  option_contains?: InputMaybe<Scalars['String']['input']>;
  option_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  option_ends_with?: InputMaybe<Scalars['String']['input']>;
  option_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  option_gt?: InputMaybe<Scalars['String']['input']>;
  option_gte?: InputMaybe<Scalars['String']['input']>;
  option_in?: InputMaybe<Array<Scalars['String']['input']>>;
  option_lt?: InputMaybe<Scalars['String']['input']>;
  option_lte?: InputMaybe<Scalars['String']['input']>;
  option_not?: InputMaybe<Scalars['String']['input']>;
  option_not_contains?: InputMaybe<Scalars['String']['input']>;
  option_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  option_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  option_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  option_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  option_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  option_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  option_starts_with?: InputMaybe<Scalars['String']['input']>;
  option_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  or?: InputMaybe<Array<InputMaybe<OptionsSettle_Filter>>>;
  priceAtAction?: InputMaybe<Scalars['BigInt']['input']>;
  priceAtAction_gt?: InputMaybe<Scalars['BigInt']['input']>;
  priceAtAction_gte?: InputMaybe<Scalars['BigInt']['input']>;
  priceAtAction_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  priceAtAction_lt?: InputMaybe<Scalars['BigInt']['input']>;
  priceAtAction_lte?: InputMaybe<Scalars['BigInt']['input']>;
  priceAtAction_not?: InputMaybe<Scalars['BigInt']['input']>;
  priceAtAction_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  timestamp?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_gt?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_gte?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  timestamp_lt?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_lte?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_not?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  user?: InputMaybe<Scalars['String']['input']>;
  user_contains?: InputMaybe<Scalars['String']['input']>;
  user_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  user_ends_with?: InputMaybe<Scalars['String']['input']>;
  user_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  user_gt?: InputMaybe<Scalars['String']['input']>;
  user_gte?: InputMaybe<Scalars['String']['input']>;
  user_in?: InputMaybe<Array<Scalars['String']['input']>>;
  user_lt?: InputMaybe<Scalars['String']['input']>;
  user_lte?: InputMaybe<Scalars['String']['input']>;
  user_not?: InputMaybe<Scalars['String']['input']>;
  user_not_contains?: InputMaybe<Scalars['String']['input']>;
  user_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  user_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  user_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  user_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  user_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  user_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  user_starts_with?: InputMaybe<Scalars['String']['input']>;
  user_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
};

export enum OptionsSettle_OrderBy {
  Id = 'id',
  Option = 'option',
  OptionMarket = 'optionMarket',
  OptionMarketDpFee = 'optionMarket__dpFee',
  OptionMarketId = 'optionMarket__id',
  OptionMarketOptionsPricing = 'optionMarket__optionsPricing',
  OptionMarketPrimePool = 'optionMarket__primePool',
  OptionMarketTokenUriFetcher = 'optionMarket__tokenURIFetcher',
  OptionMarketTotalFees = 'optionMarket__totalFees',
  OptionMarketTotalPremium = 'optionMarket__totalPremium',
  OptionMarketTotalVolume = 'optionMarket__totalVolume',
  OptionExpiry = 'option__expiry',
  OptionId = 'option__id',
  OptionInitialSize = 'option__initialSize',
  OptionIsCall = 'option__isCall',
  OptionPremium = 'option__premium',
  OptionPurchasePrice = 'option__purchasePrice',
  OptionSize = 'option__size',
  OptionTickLower = 'option__tickLower',
  OptionTickUpper = 'option__tickUpper',
  OptionTimestamp = 'option__timestamp',
  OptionTokenId = 'option__tokenId',
  OptionUser = 'option__user',
  PriceAtAction = 'priceAtAction',
  Timestamp = 'timestamp',
  User = 'user'
}

export type OptionsTransfer = {
  __typename?: 'OptionsTransfer';
  from: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  option: Option;
  optionMarket: OptionMarket;
  size: Scalars['BigInt']['output'];
  timestamp: Scalars['BigInt']['output'];
  to: Scalars['String']['output'];
};

export type OptionsTransfer_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<OptionsTransfer_Filter>>>;
  from?: InputMaybe<Scalars['String']['input']>;
  from_contains?: InputMaybe<Scalars['String']['input']>;
  from_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  from_ends_with?: InputMaybe<Scalars['String']['input']>;
  from_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  from_gt?: InputMaybe<Scalars['String']['input']>;
  from_gte?: InputMaybe<Scalars['String']['input']>;
  from_in?: InputMaybe<Array<Scalars['String']['input']>>;
  from_lt?: InputMaybe<Scalars['String']['input']>;
  from_lte?: InputMaybe<Scalars['String']['input']>;
  from_not?: InputMaybe<Scalars['String']['input']>;
  from_not_contains?: InputMaybe<Scalars['String']['input']>;
  from_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  from_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  from_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  from_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  from_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  from_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  from_starts_with?: InputMaybe<Scalars['String']['input']>;
  from_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  option?: InputMaybe<Scalars['String']['input']>;
  optionMarket?: InputMaybe<Scalars['String']['input']>;
  optionMarket_?: InputMaybe<OptionMarket_Filter>;
  optionMarket_contains?: InputMaybe<Scalars['String']['input']>;
  optionMarket_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  optionMarket_ends_with?: InputMaybe<Scalars['String']['input']>;
  optionMarket_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  optionMarket_gt?: InputMaybe<Scalars['String']['input']>;
  optionMarket_gte?: InputMaybe<Scalars['String']['input']>;
  optionMarket_in?: InputMaybe<Array<Scalars['String']['input']>>;
  optionMarket_lt?: InputMaybe<Scalars['String']['input']>;
  optionMarket_lte?: InputMaybe<Scalars['String']['input']>;
  optionMarket_not?: InputMaybe<Scalars['String']['input']>;
  optionMarket_not_contains?: InputMaybe<Scalars['String']['input']>;
  optionMarket_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  optionMarket_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  optionMarket_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  optionMarket_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  optionMarket_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  optionMarket_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  optionMarket_starts_with?: InputMaybe<Scalars['String']['input']>;
  optionMarket_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  option_?: InputMaybe<Option_Filter>;
  option_contains?: InputMaybe<Scalars['String']['input']>;
  option_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  option_ends_with?: InputMaybe<Scalars['String']['input']>;
  option_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  option_gt?: InputMaybe<Scalars['String']['input']>;
  option_gte?: InputMaybe<Scalars['String']['input']>;
  option_in?: InputMaybe<Array<Scalars['String']['input']>>;
  option_lt?: InputMaybe<Scalars['String']['input']>;
  option_lte?: InputMaybe<Scalars['String']['input']>;
  option_not?: InputMaybe<Scalars['String']['input']>;
  option_not_contains?: InputMaybe<Scalars['String']['input']>;
  option_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  option_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  option_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  option_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  option_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  option_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  option_starts_with?: InputMaybe<Scalars['String']['input']>;
  option_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  or?: InputMaybe<Array<InputMaybe<OptionsTransfer_Filter>>>;
  size?: InputMaybe<Scalars['BigInt']['input']>;
  size_gt?: InputMaybe<Scalars['BigInt']['input']>;
  size_gte?: InputMaybe<Scalars['BigInt']['input']>;
  size_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  size_lt?: InputMaybe<Scalars['BigInt']['input']>;
  size_lte?: InputMaybe<Scalars['BigInt']['input']>;
  size_not?: InputMaybe<Scalars['BigInt']['input']>;
  size_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  timestamp?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_gt?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_gte?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  timestamp_lt?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_lte?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_not?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  to?: InputMaybe<Scalars['String']['input']>;
  to_contains?: InputMaybe<Scalars['String']['input']>;
  to_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  to_ends_with?: InputMaybe<Scalars['String']['input']>;
  to_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  to_gt?: InputMaybe<Scalars['String']['input']>;
  to_gte?: InputMaybe<Scalars['String']['input']>;
  to_in?: InputMaybe<Array<Scalars['String']['input']>>;
  to_lt?: InputMaybe<Scalars['String']['input']>;
  to_lte?: InputMaybe<Scalars['String']['input']>;
  to_not?: InputMaybe<Scalars['String']['input']>;
  to_not_contains?: InputMaybe<Scalars['String']['input']>;
  to_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  to_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  to_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  to_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  to_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  to_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  to_starts_with?: InputMaybe<Scalars['String']['input']>;
  to_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
};

export enum OptionsTransfer_OrderBy {
  From = 'from',
  Id = 'id',
  Option = 'option',
  OptionMarket = 'optionMarket',
  OptionMarketDpFee = 'optionMarket__dpFee',
  OptionMarketId = 'optionMarket__id',
  OptionMarketOptionsPricing = 'optionMarket__optionsPricing',
  OptionMarketPrimePool = 'optionMarket__primePool',
  OptionMarketTokenUriFetcher = 'optionMarket__tokenURIFetcher',
  OptionMarketTotalFees = 'optionMarket__totalFees',
  OptionMarketTotalPremium = 'optionMarket__totalPremium',
  OptionMarketTotalVolume = 'optionMarket__totalVolume',
  OptionExpiry = 'option__expiry',
  OptionId = 'option__id',
  OptionInitialSize = 'option__initialSize',
  OptionIsCall = 'option__isCall',
  OptionPremium = 'option__premium',
  OptionPurchasePrice = 'option__purchasePrice',
  OptionSize = 'option__size',
  OptionTickLower = 'option__tickLower',
  OptionTickUpper = 'option__tickUpper',
  OptionTimestamp = 'option__timestamp',
  OptionTokenId = 'option__tokenId',
  OptionUser = 'option__user',
  Size = 'size',
  Timestamp = 'timestamp',
  To = 'to'
}

/** Defines the order direction, either ascending or descending */
export enum OrderDirection {
  Asc = 'asc',
  Desc = 'desc'
}

export type Query = {
  __typename?: 'Query';
  /** Access to subgraph metadata */
  _meta?: Maybe<_Meta_>;
  dailyDonation?: Maybe<DailyDonation>;
  dailyDonations: Array<DailyDonation>;
  dailyFeeCompound?: Maybe<DailyFeeCompound>;
  dailyFeeCompounds: Array<DailyFeeCompound>;
  donation?: Maybe<Donation>;
  donations: Array<Donation>;
  feeCompound?: Maybe<FeeCompound>;
  feeCompounds: Array<FeeCompound>;
  lpposition?: Maybe<LpPosition>;
  lppositionBurn?: Maybe<LpPositionBurn>;
  lppositionBurns: Array<LpPositionBurn>;
  lppositionMint?: Maybe<LpPositionMint>;
  lppositionMints: Array<LpPositionMint>;
  lppositionTransfer?: Maybe<LpPositionTransfer>;
  lppositionTransfers: Array<LpPositionTransfer>;
  lppositions: Array<LpPosition>;
  mintOption?: Maybe<MintOption>;
  mintOptions: Array<MintOption>;
  mintPosition?: Maybe<MintPosition>;
  mintPositions: Array<MintPosition>;
  option?: Maybe<Option>;
  optionMarket?: Maybe<OptionMarket>;
  optionMarketDailyStat?: Maybe<OptionMarketDailyStat>;
  optionMarketDailyStats: Array<OptionMarketDailyStat>;
  optionMarkets: Array<OptionMarket>;
  options: Array<Option>;
  optionsExercise?: Maybe<OptionsExercise>;
  optionsExercises: Array<OptionsExercise>;
  optionsMint?: Maybe<OptionsMint>;
  optionsMints: Array<OptionsMint>;
  optionsSettle?: Maybe<OptionsSettle>;
  optionsSettles: Array<OptionsSettle>;
  optionsTransfer?: Maybe<OptionsTransfer>;
  optionsTransfers: Array<OptionsTransfer>;
  strike?: Maybe<Strike>;
  strikes: Array<Strike>;
  swapReceivedLog?: Maybe<SwapReceivedLog>;
  swapReceivedLogs: Array<SwapReceivedLog>;
  token?: Maybe<Token>;
  tokens: Array<Token>;
};


export type Query_MetaArgs = {
  block?: InputMaybe<Block_Height>;
};


export type QueryDailyDonationArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryDailyDonationsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<DailyDonation_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<DailyDonation_Filter>;
};


export type QueryDailyFeeCompoundArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryDailyFeeCompoundsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<DailyFeeCompound_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<DailyFeeCompound_Filter>;
};


export type QueryDonationArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryDonationsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Donation_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<Donation_Filter>;
};


export type QueryFeeCompoundArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryFeeCompoundsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<FeeCompound_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<FeeCompound_Filter>;
};


export type QueryLppositionArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryLppositionBurnArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryLppositionBurnsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<LpPositionBurn_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<LpPositionBurn_Filter>;
};


export type QueryLppositionMintArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryLppositionMintsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<LpPositionMint_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<LpPositionMint_Filter>;
};


export type QueryLppositionTransferArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryLppositionTransfersArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<LpPositionTransfer_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<LpPositionTransfer_Filter>;
};


export type QueryLppositionsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<LpPosition_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<LpPosition_Filter>;
};


export type QueryMintOptionArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryMintOptionsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<MintOption_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<MintOption_Filter>;
};


export type QueryMintPositionArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryMintPositionsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<MintPosition_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<MintPosition_Filter>;
};


export type QueryOptionArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryOptionMarketArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryOptionMarketDailyStatArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryOptionMarketDailyStatsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OptionMarketDailyStat_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<OptionMarketDailyStat_Filter>;
};


export type QueryOptionMarketsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OptionMarket_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<OptionMarket_Filter>;
};


export type QueryOptionsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Option_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<Option_Filter>;
};


export type QueryOptionsExerciseArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryOptionsExercisesArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OptionsExercise_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<OptionsExercise_Filter>;
};


export type QueryOptionsMintArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryOptionsMintsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OptionsMint_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<OptionsMint_Filter>;
};


export type QueryOptionsSettleArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryOptionsSettlesArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OptionsSettle_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<OptionsSettle_Filter>;
};


export type QueryOptionsTransferArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryOptionsTransfersArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OptionsTransfer_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<OptionsTransfer_Filter>;
};


export type QueryStrikeArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryStrikesArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Strike_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<Strike_Filter>;
};


export type QuerySwapReceivedLogArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QuerySwapReceivedLogsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SwapReceivedLog_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<SwapReceivedLog_Filter>;
};


export type QueryTokenArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryTokensArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Token_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<Token_Filter>;
};

export type Strike = {
  __typename?: 'Strike';
  currentDayDonation: DailyDonation;
  currentDayFeeCompound: DailyFeeCompound;
  feeGrowthInside0LastX128: Scalars['BigInt']['output'];
  feeGrowthInside1LastX128: Scalars['BigInt']['output'];
  handler: Scalars['String']['output'];
  hook: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  pool: Scalars['String']['output'];
  reservedLiquidity: Scalars['BigInt']['output'];
  tickLower: Scalars['Int']['output'];
  tickUpper: Scalars['Int']['output'];
  token0: Token;
  token1: Token;
  totalLiquidity: Scalars['BigInt']['output'];
  totalShares: Scalars['BigInt']['output'];
  usedLiquidity: Scalars['BigInt']['output'];
};

export type Strike_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<Strike_Filter>>>;
  currentDayDonation?: InputMaybe<Scalars['String']['input']>;
  currentDayDonation_?: InputMaybe<DailyDonation_Filter>;
  currentDayDonation_contains?: InputMaybe<Scalars['String']['input']>;
  currentDayDonation_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  currentDayDonation_ends_with?: InputMaybe<Scalars['String']['input']>;
  currentDayDonation_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  currentDayDonation_gt?: InputMaybe<Scalars['String']['input']>;
  currentDayDonation_gte?: InputMaybe<Scalars['String']['input']>;
  currentDayDonation_in?: InputMaybe<Array<Scalars['String']['input']>>;
  currentDayDonation_lt?: InputMaybe<Scalars['String']['input']>;
  currentDayDonation_lte?: InputMaybe<Scalars['String']['input']>;
  currentDayDonation_not?: InputMaybe<Scalars['String']['input']>;
  currentDayDonation_not_contains?: InputMaybe<Scalars['String']['input']>;
  currentDayDonation_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  currentDayDonation_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  currentDayDonation_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  currentDayDonation_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  currentDayDonation_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  currentDayDonation_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  currentDayDonation_starts_with?: InputMaybe<Scalars['String']['input']>;
  currentDayDonation_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  currentDayFeeCompound?: InputMaybe<Scalars['String']['input']>;
  currentDayFeeCompound_?: InputMaybe<DailyFeeCompound_Filter>;
  currentDayFeeCompound_contains?: InputMaybe<Scalars['String']['input']>;
  currentDayFeeCompound_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  currentDayFeeCompound_ends_with?: InputMaybe<Scalars['String']['input']>;
  currentDayFeeCompound_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  currentDayFeeCompound_gt?: InputMaybe<Scalars['String']['input']>;
  currentDayFeeCompound_gte?: InputMaybe<Scalars['String']['input']>;
  currentDayFeeCompound_in?: InputMaybe<Array<Scalars['String']['input']>>;
  currentDayFeeCompound_lt?: InputMaybe<Scalars['String']['input']>;
  currentDayFeeCompound_lte?: InputMaybe<Scalars['String']['input']>;
  currentDayFeeCompound_not?: InputMaybe<Scalars['String']['input']>;
  currentDayFeeCompound_not_contains?: InputMaybe<Scalars['String']['input']>;
  currentDayFeeCompound_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  currentDayFeeCompound_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  currentDayFeeCompound_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  currentDayFeeCompound_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  currentDayFeeCompound_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  currentDayFeeCompound_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  currentDayFeeCompound_starts_with?: InputMaybe<Scalars['String']['input']>;
  currentDayFeeCompound_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  feeGrowthInside0LastX128?: InputMaybe<Scalars['BigInt']['input']>;
  feeGrowthInside0LastX128_gt?: InputMaybe<Scalars['BigInt']['input']>;
  feeGrowthInside0LastX128_gte?: InputMaybe<Scalars['BigInt']['input']>;
  feeGrowthInside0LastX128_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  feeGrowthInside0LastX128_lt?: InputMaybe<Scalars['BigInt']['input']>;
  feeGrowthInside0LastX128_lte?: InputMaybe<Scalars['BigInt']['input']>;
  feeGrowthInside0LastX128_not?: InputMaybe<Scalars['BigInt']['input']>;
  feeGrowthInside0LastX128_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  feeGrowthInside1LastX128?: InputMaybe<Scalars['BigInt']['input']>;
  feeGrowthInside1LastX128_gt?: InputMaybe<Scalars['BigInt']['input']>;
  feeGrowthInside1LastX128_gte?: InputMaybe<Scalars['BigInt']['input']>;
  feeGrowthInside1LastX128_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  feeGrowthInside1LastX128_lt?: InputMaybe<Scalars['BigInt']['input']>;
  feeGrowthInside1LastX128_lte?: InputMaybe<Scalars['BigInt']['input']>;
  feeGrowthInside1LastX128_not?: InputMaybe<Scalars['BigInt']['input']>;
  feeGrowthInside1LastX128_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  handler?: InputMaybe<Scalars['String']['input']>;
  handler_contains?: InputMaybe<Scalars['String']['input']>;
  handler_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  handler_ends_with?: InputMaybe<Scalars['String']['input']>;
  handler_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  handler_gt?: InputMaybe<Scalars['String']['input']>;
  handler_gte?: InputMaybe<Scalars['String']['input']>;
  handler_in?: InputMaybe<Array<Scalars['String']['input']>>;
  handler_lt?: InputMaybe<Scalars['String']['input']>;
  handler_lte?: InputMaybe<Scalars['String']['input']>;
  handler_not?: InputMaybe<Scalars['String']['input']>;
  handler_not_contains?: InputMaybe<Scalars['String']['input']>;
  handler_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  handler_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  handler_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  handler_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  handler_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  handler_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  handler_starts_with?: InputMaybe<Scalars['String']['input']>;
  handler_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  hook?: InputMaybe<Scalars['String']['input']>;
  hook_contains?: InputMaybe<Scalars['String']['input']>;
  hook_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  hook_ends_with?: InputMaybe<Scalars['String']['input']>;
  hook_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  hook_gt?: InputMaybe<Scalars['String']['input']>;
  hook_gte?: InputMaybe<Scalars['String']['input']>;
  hook_in?: InputMaybe<Array<Scalars['String']['input']>>;
  hook_lt?: InputMaybe<Scalars['String']['input']>;
  hook_lte?: InputMaybe<Scalars['String']['input']>;
  hook_not?: InputMaybe<Scalars['String']['input']>;
  hook_not_contains?: InputMaybe<Scalars['String']['input']>;
  hook_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  hook_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  hook_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  hook_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  hook_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  hook_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  hook_starts_with?: InputMaybe<Scalars['String']['input']>;
  hook_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  or?: InputMaybe<Array<InputMaybe<Strike_Filter>>>;
  pool?: InputMaybe<Scalars['String']['input']>;
  pool_contains?: InputMaybe<Scalars['String']['input']>;
  pool_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  pool_ends_with?: InputMaybe<Scalars['String']['input']>;
  pool_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  pool_gt?: InputMaybe<Scalars['String']['input']>;
  pool_gte?: InputMaybe<Scalars['String']['input']>;
  pool_in?: InputMaybe<Array<Scalars['String']['input']>>;
  pool_lt?: InputMaybe<Scalars['String']['input']>;
  pool_lte?: InputMaybe<Scalars['String']['input']>;
  pool_not?: InputMaybe<Scalars['String']['input']>;
  pool_not_contains?: InputMaybe<Scalars['String']['input']>;
  pool_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  pool_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  pool_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  pool_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  pool_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  pool_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  pool_starts_with?: InputMaybe<Scalars['String']['input']>;
  pool_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  reservedLiquidity?: InputMaybe<Scalars['BigInt']['input']>;
  reservedLiquidity_gt?: InputMaybe<Scalars['BigInt']['input']>;
  reservedLiquidity_gte?: InputMaybe<Scalars['BigInt']['input']>;
  reservedLiquidity_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  reservedLiquidity_lt?: InputMaybe<Scalars['BigInt']['input']>;
  reservedLiquidity_lte?: InputMaybe<Scalars['BigInt']['input']>;
  reservedLiquidity_not?: InputMaybe<Scalars['BigInt']['input']>;
  reservedLiquidity_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  tickLower?: InputMaybe<Scalars['Int']['input']>;
  tickLower_gt?: InputMaybe<Scalars['Int']['input']>;
  tickLower_gte?: InputMaybe<Scalars['Int']['input']>;
  tickLower_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  tickLower_lt?: InputMaybe<Scalars['Int']['input']>;
  tickLower_lte?: InputMaybe<Scalars['Int']['input']>;
  tickLower_not?: InputMaybe<Scalars['Int']['input']>;
  tickLower_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  tickUpper?: InputMaybe<Scalars['Int']['input']>;
  tickUpper_gt?: InputMaybe<Scalars['Int']['input']>;
  tickUpper_gte?: InputMaybe<Scalars['Int']['input']>;
  tickUpper_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  tickUpper_lt?: InputMaybe<Scalars['Int']['input']>;
  tickUpper_lte?: InputMaybe<Scalars['Int']['input']>;
  tickUpper_not?: InputMaybe<Scalars['Int']['input']>;
  tickUpper_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  token0?: InputMaybe<Scalars['String']['input']>;
  token0_?: InputMaybe<Token_Filter>;
  token0_contains?: InputMaybe<Scalars['String']['input']>;
  token0_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  token0_ends_with?: InputMaybe<Scalars['String']['input']>;
  token0_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  token0_gt?: InputMaybe<Scalars['String']['input']>;
  token0_gte?: InputMaybe<Scalars['String']['input']>;
  token0_in?: InputMaybe<Array<Scalars['String']['input']>>;
  token0_lt?: InputMaybe<Scalars['String']['input']>;
  token0_lte?: InputMaybe<Scalars['String']['input']>;
  token0_not?: InputMaybe<Scalars['String']['input']>;
  token0_not_contains?: InputMaybe<Scalars['String']['input']>;
  token0_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  token0_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  token0_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  token0_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  token0_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  token0_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  token0_starts_with?: InputMaybe<Scalars['String']['input']>;
  token0_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  token1?: InputMaybe<Scalars['String']['input']>;
  token1_?: InputMaybe<Token_Filter>;
  token1_contains?: InputMaybe<Scalars['String']['input']>;
  token1_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  token1_ends_with?: InputMaybe<Scalars['String']['input']>;
  token1_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  token1_gt?: InputMaybe<Scalars['String']['input']>;
  token1_gte?: InputMaybe<Scalars['String']['input']>;
  token1_in?: InputMaybe<Array<Scalars['String']['input']>>;
  token1_lt?: InputMaybe<Scalars['String']['input']>;
  token1_lte?: InputMaybe<Scalars['String']['input']>;
  token1_not?: InputMaybe<Scalars['String']['input']>;
  token1_not_contains?: InputMaybe<Scalars['String']['input']>;
  token1_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  token1_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  token1_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  token1_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  token1_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  token1_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  token1_starts_with?: InputMaybe<Scalars['String']['input']>;
  token1_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  totalLiquidity?: InputMaybe<Scalars['BigInt']['input']>;
  totalLiquidity_gt?: InputMaybe<Scalars['BigInt']['input']>;
  totalLiquidity_gte?: InputMaybe<Scalars['BigInt']['input']>;
  totalLiquidity_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  totalLiquidity_lt?: InputMaybe<Scalars['BigInt']['input']>;
  totalLiquidity_lte?: InputMaybe<Scalars['BigInt']['input']>;
  totalLiquidity_not?: InputMaybe<Scalars['BigInt']['input']>;
  totalLiquidity_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  totalShares?: InputMaybe<Scalars['BigInt']['input']>;
  totalShares_gt?: InputMaybe<Scalars['BigInt']['input']>;
  totalShares_gte?: InputMaybe<Scalars['BigInt']['input']>;
  totalShares_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  totalShares_lt?: InputMaybe<Scalars['BigInt']['input']>;
  totalShares_lte?: InputMaybe<Scalars['BigInt']['input']>;
  totalShares_not?: InputMaybe<Scalars['BigInt']['input']>;
  totalShares_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  usedLiquidity?: InputMaybe<Scalars['BigInt']['input']>;
  usedLiquidity_gt?: InputMaybe<Scalars['BigInt']['input']>;
  usedLiquidity_gte?: InputMaybe<Scalars['BigInt']['input']>;
  usedLiquidity_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  usedLiquidity_lt?: InputMaybe<Scalars['BigInt']['input']>;
  usedLiquidity_lte?: InputMaybe<Scalars['BigInt']['input']>;
  usedLiquidity_not?: InputMaybe<Scalars['BigInt']['input']>;
  usedLiquidity_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
};

export enum Strike_OrderBy {
  CurrentDayDonation = 'currentDayDonation',
  CurrentDayDonationDonation = 'currentDayDonation__donation',
  CurrentDayDonationId = 'currentDayDonation__id',
  CurrentDayDonationSqrtPriceX96 = 'currentDayDonation__sqrtPriceX96',
  CurrentDayDonationStart = 'currentDayDonation__start',
  CurrentDayFeeCompound = 'currentDayFeeCompound',
  CurrentDayFeeCompoundCompound = 'currentDayFeeCompound__compound',
  CurrentDayFeeCompoundId = 'currentDayFeeCompound__id',
  CurrentDayFeeCompoundSqrtPriceX96 = 'currentDayFeeCompound__sqrtPriceX96',
  CurrentDayFeeCompoundStart = 'currentDayFeeCompound__start',
  FeeGrowthInside0LastX128 = 'feeGrowthInside0LastX128',
  FeeGrowthInside1LastX128 = 'feeGrowthInside1LastX128',
  Handler = 'handler',
  Hook = 'hook',
  Id = 'id',
  Pool = 'pool',
  ReservedLiquidity = 'reservedLiquidity',
  TickLower = 'tickLower',
  TickUpper = 'tickUpper',
  Token0 = 'token0',
  Token0Decimals = 'token0__decimals',
  Token0Id = 'token0__id',
  Token0Symbol = 'token0__symbol',
  Token1 = 'token1',
  Token1Decimals = 'token1__decimals',
  Token1Id = 'token1__id',
  Token1Symbol = 'token1__symbol',
  TotalLiquidity = 'totalLiquidity',
  TotalShares = 'totalShares',
  UsedLiquidity = 'usedLiquidity'
}

export type Subscription = {
  __typename?: 'Subscription';
  /** Access to subgraph metadata */
  _meta?: Maybe<_Meta_>;
  dailyDonation?: Maybe<DailyDonation>;
  dailyDonations: Array<DailyDonation>;
  dailyFeeCompound?: Maybe<DailyFeeCompound>;
  dailyFeeCompounds: Array<DailyFeeCompound>;
  donation?: Maybe<Donation>;
  donations: Array<Donation>;
  feeCompound?: Maybe<FeeCompound>;
  feeCompounds: Array<FeeCompound>;
  lpposition?: Maybe<LpPosition>;
  lppositionBurn?: Maybe<LpPositionBurn>;
  lppositionBurns: Array<LpPositionBurn>;
  lppositionMint?: Maybe<LpPositionMint>;
  lppositionMints: Array<LpPositionMint>;
  lppositionTransfer?: Maybe<LpPositionTransfer>;
  lppositionTransfers: Array<LpPositionTransfer>;
  lppositions: Array<LpPosition>;
  mintOption?: Maybe<MintOption>;
  mintOptions: Array<MintOption>;
  mintPosition?: Maybe<MintPosition>;
  mintPositions: Array<MintPosition>;
  option?: Maybe<Option>;
  optionMarket?: Maybe<OptionMarket>;
  optionMarketDailyStat?: Maybe<OptionMarketDailyStat>;
  optionMarketDailyStats: Array<OptionMarketDailyStat>;
  optionMarkets: Array<OptionMarket>;
  options: Array<Option>;
  optionsExercise?: Maybe<OptionsExercise>;
  optionsExercises: Array<OptionsExercise>;
  optionsMint?: Maybe<OptionsMint>;
  optionsMints: Array<OptionsMint>;
  optionsSettle?: Maybe<OptionsSettle>;
  optionsSettles: Array<OptionsSettle>;
  optionsTransfer?: Maybe<OptionsTransfer>;
  optionsTransfers: Array<OptionsTransfer>;
  strike?: Maybe<Strike>;
  strikes: Array<Strike>;
  swapReceivedLog?: Maybe<SwapReceivedLog>;
  swapReceivedLogs: Array<SwapReceivedLog>;
  token?: Maybe<Token>;
  tokens: Array<Token>;
};


export type Subscription_MetaArgs = {
  block?: InputMaybe<Block_Height>;
};


export type SubscriptionDailyDonationArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionDailyDonationsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<DailyDonation_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<DailyDonation_Filter>;
};


export type SubscriptionDailyFeeCompoundArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionDailyFeeCompoundsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<DailyFeeCompound_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<DailyFeeCompound_Filter>;
};


export type SubscriptionDonationArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionDonationsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Donation_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<Donation_Filter>;
};


export type SubscriptionFeeCompoundArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionFeeCompoundsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<FeeCompound_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<FeeCompound_Filter>;
};


export type SubscriptionLppositionArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionLppositionBurnArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionLppositionBurnsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<LpPositionBurn_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<LpPositionBurn_Filter>;
};


export type SubscriptionLppositionMintArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionLppositionMintsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<LpPositionMint_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<LpPositionMint_Filter>;
};


export type SubscriptionLppositionTransferArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionLppositionTransfersArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<LpPositionTransfer_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<LpPositionTransfer_Filter>;
};


export type SubscriptionLppositionsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<LpPosition_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<LpPosition_Filter>;
};


export type SubscriptionMintOptionArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionMintOptionsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<MintOption_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<MintOption_Filter>;
};


export type SubscriptionMintPositionArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionMintPositionsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<MintPosition_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<MintPosition_Filter>;
};


export type SubscriptionOptionArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionOptionMarketArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionOptionMarketDailyStatArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionOptionMarketDailyStatsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OptionMarketDailyStat_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<OptionMarketDailyStat_Filter>;
};


export type SubscriptionOptionMarketsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OptionMarket_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<OptionMarket_Filter>;
};


export type SubscriptionOptionsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Option_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<Option_Filter>;
};


export type SubscriptionOptionsExerciseArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionOptionsExercisesArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OptionsExercise_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<OptionsExercise_Filter>;
};


export type SubscriptionOptionsMintArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionOptionsMintsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OptionsMint_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<OptionsMint_Filter>;
};


export type SubscriptionOptionsSettleArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionOptionsSettlesArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OptionsSettle_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<OptionsSettle_Filter>;
};


export type SubscriptionOptionsTransferArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionOptionsTransfersArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OptionsTransfer_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<OptionsTransfer_Filter>;
};


export type SubscriptionStrikeArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionStrikesArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Strike_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<Strike_Filter>;
};


export type SubscriptionSwapReceivedLogArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionSwapReceivedLogsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SwapReceivedLog_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<SwapReceivedLog_Filter>;
};


export type SubscriptionTokenArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionTokensArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Token_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<Token_Filter>;
};

export type SwapReceivedLog = {
  __typename?: 'SwapReceivedLog';
  amountIn: Scalars['BigInt']['output'];
  amountOut: Scalars['BigInt']['output'];
  id: Scalars['ID']['output'];
  swapper: Scalars['String']['output'];
  timestamp: Scalars['BigInt']['output'];
  tokenIn: Scalars['String']['output'];
  tokenOut: Scalars['String']['output'];
};

export type SwapReceivedLog_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  amountIn?: InputMaybe<Scalars['BigInt']['input']>;
  amountIn_gt?: InputMaybe<Scalars['BigInt']['input']>;
  amountIn_gte?: InputMaybe<Scalars['BigInt']['input']>;
  amountIn_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  amountIn_lt?: InputMaybe<Scalars['BigInt']['input']>;
  amountIn_lte?: InputMaybe<Scalars['BigInt']['input']>;
  amountIn_not?: InputMaybe<Scalars['BigInt']['input']>;
  amountIn_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  amountOut?: InputMaybe<Scalars['BigInt']['input']>;
  amountOut_gt?: InputMaybe<Scalars['BigInt']['input']>;
  amountOut_gte?: InputMaybe<Scalars['BigInt']['input']>;
  amountOut_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  amountOut_lt?: InputMaybe<Scalars['BigInt']['input']>;
  amountOut_lte?: InputMaybe<Scalars['BigInt']['input']>;
  amountOut_not?: InputMaybe<Scalars['BigInt']['input']>;
  amountOut_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  and?: InputMaybe<Array<InputMaybe<SwapReceivedLog_Filter>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  or?: InputMaybe<Array<InputMaybe<SwapReceivedLog_Filter>>>;
  swapper?: InputMaybe<Scalars['String']['input']>;
  swapper_contains?: InputMaybe<Scalars['String']['input']>;
  swapper_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  swapper_ends_with?: InputMaybe<Scalars['String']['input']>;
  swapper_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  swapper_gt?: InputMaybe<Scalars['String']['input']>;
  swapper_gte?: InputMaybe<Scalars['String']['input']>;
  swapper_in?: InputMaybe<Array<Scalars['String']['input']>>;
  swapper_lt?: InputMaybe<Scalars['String']['input']>;
  swapper_lte?: InputMaybe<Scalars['String']['input']>;
  swapper_not?: InputMaybe<Scalars['String']['input']>;
  swapper_not_contains?: InputMaybe<Scalars['String']['input']>;
  swapper_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  swapper_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  swapper_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  swapper_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  swapper_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  swapper_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  swapper_starts_with?: InputMaybe<Scalars['String']['input']>;
  swapper_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  timestamp?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_gt?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_gte?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  timestamp_lt?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_lte?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_not?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  tokenIn?: InputMaybe<Scalars['String']['input']>;
  tokenIn_contains?: InputMaybe<Scalars['String']['input']>;
  tokenIn_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  tokenIn_ends_with?: InputMaybe<Scalars['String']['input']>;
  tokenIn_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  tokenIn_gt?: InputMaybe<Scalars['String']['input']>;
  tokenIn_gte?: InputMaybe<Scalars['String']['input']>;
  tokenIn_in?: InputMaybe<Array<Scalars['String']['input']>>;
  tokenIn_lt?: InputMaybe<Scalars['String']['input']>;
  tokenIn_lte?: InputMaybe<Scalars['String']['input']>;
  tokenIn_not?: InputMaybe<Scalars['String']['input']>;
  tokenIn_not_contains?: InputMaybe<Scalars['String']['input']>;
  tokenIn_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  tokenIn_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  tokenIn_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  tokenIn_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  tokenIn_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  tokenIn_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  tokenIn_starts_with?: InputMaybe<Scalars['String']['input']>;
  tokenIn_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  tokenOut?: InputMaybe<Scalars['String']['input']>;
  tokenOut_contains?: InputMaybe<Scalars['String']['input']>;
  tokenOut_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  tokenOut_ends_with?: InputMaybe<Scalars['String']['input']>;
  tokenOut_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  tokenOut_gt?: InputMaybe<Scalars['String']['input']>;
  tokenOut_gte?: InputMaybe<Scalars['String']['input']>;
  tokenOut_in?: InputMaybe<Array<Scalars['String']['input']>>;
  tokenOut_lt?: InputMaybe<Scalars['String']['input']>;
  tokenOut_lte?: InputMaybe<Scalars['String']['input']>;
  tokenOut_not?: InputMaybe<Scalars['String']['input']>;
  tokenOut_not_contains?: InputMaybe<Scalars['String']['input']>;
  tokenOut_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  tokenOut_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  tokenOut_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  tokenOut_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  tokenOut_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  tokenOut_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  tokenOut_starts_with?: InputMaybe<Scalars['String']['input']>;
  tokenOut_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
};

export enum SwapReceivedLog_OrderBy {
  AmountIn = 'amountIn',
  AmountOut = 'amountOut',
  Id = 'id',
  Swapper = 'swapper',
  Timestamp = 'timestamp',
  TokenIn = 'tokenIn',
  TokenOut = 'tokenOut'
}

export type Token = {
  __typename?: 'Token';
  decimals: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  symbol: Scalars['String']['output'];
};

export type Token_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<Token_Filter>>>;
  decimals?: InputMaybe<Scalars['Int']['input']>;
  decimals_gt?: InputMaybe<Scalars['Int']['input']>;
  decimals_gte?: InputMaybe<Scalars['Int']['input']>;
  decimals_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  decimals_lt?: InputMaybe<Scalars['Int']['input']>;
  decimals_lte?: InputMaybe<Scalars['Int']['input']>;
  decimals_not?: InputMaybe<Scalars['Int']['input']>;
  decimals_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  or?: InputMaybe<Array<InputMaybe<Token_Filter>>>;
  symbol?: InputMaybe<Scalars['String']['input']>;
  symbol_contains?: InputMaybe<Scalars['String']['input']>;
  symbol_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  symbol_ends_with?: InputMaybe<Scalars['String']['input']>;
  symbol_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  symbol_gt?: InputMaybe<Scalars['String']['input']>;
  symbol_gte?: InputMaybe<Scalars['String']['input']>;
  symbol_in?: InputMaybe<Array<Scalars['String']['input']>>;
  symbol_lt?: InputMaybe<Scalars['String']['input']>;
  symbol_lte?: InputMaybe<Scalars['String']['input']>;
  symbol_not?: InputMaybe<Scalars['String']['input']>;
  symbol_not_contains?: InputMaybe<Scalars['String']['input']>;
  symbol_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  symbol_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  symbol_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  symbol_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  symbol_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  symbol_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  symbol_starts_with?: InputMaybe<Scalars['String']['input']>;
  symbol_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
};

export enum Token_OrderBy {
  Decimals = 'decimals',
  Id = 'id',
  Symbol = 'symbol'
}

export type _Block_ = {
  __typename?: '_Block_';
  /** The hash of the block */
  hash?: Maybe<Scalars['Bytes']['output']>;
  /** The block number */
  number: Scalars['Int']['output'];
  /** The hash of the parent block */
  parentHash?: Maybe<Scalars['Bytes']['output']>;
  /** Integer representation of the timestamp stored in blocks for the chain */
  timestamp?: Maybe<Scalars['Int']['output']>;
};

/** The type for the top-level _meta field */
export type _Meta_ = {
  __typename?: '_Meta_';
  /**
   * Information about a specific subgraph block. The hash of the block
   * will be null if the _meta field has a block constraint that asks for
   * a block number. It will be filled if the _meta field has no block constraint
   * and therefore asks for the latest  block
   *
   */
  block: _Block_;
  /** The deployment ID */
  deployment: Scalars['String']['output'];
  /** If `true`, the subgraph encountered indexing errors at some past block */
  hasIndexingErrors: Scalars['Boolean']['output'];
};

export enum _SubgraphErrorPolicy_ {
  /** Data will be returned even if the subgraph has indexing errors */
  Allow = 'allow',
  /** If the subgraph has indexing errors, data will be omitted. The default. */
  Deny = 'deny'
}

export type GetDopexStrikeListQueryVariables = Exact<{
  tokenIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type GetDopexStrikeListQuery = { __typename?: 'Query', strikes: Array<{ __typename?: 'Strike', id: string, handler: string, pool: string, hook: string, tickLower: number, tickUpper: number, token0: { __typename?: 'Token', id: string, symbol: string, decimals: number }, token1: { __typename?: 'Token', id: string, symbol: string, decimals: number } }> };

export type GetDopexLpPositionsListQueryVariables = Exact<{
  userIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type GetDopexLpPositionsListQuery = { __typename?: 'Query', lppositions: Array<{ __typename?: 'LPPosition', id: string, pool: string, hook: string, shares: string, initialLiquidity: string, user: string, handler: string, strike: { __typename?: 'Strike', id: string, pool: string, tickLower: number, tickUpper: number, totalLiquidity: string, usedLiquidity: string, totalShares: string } }> };

export type GetStrykeReservedLiquiditiesQueryVariables = Exact<{
  user: Scalars['String']['input'];
  handler: Scalars['String']['input'];
  pool: Scalars['String']['input'];
  hook: Scalars['String']['input'];
}>;


export type GetStrykeReservedLiquiditiesQuery = { __typename?: 'Query', lppositions: Array<{ __typename?: 'LPPosition', id: string, pool: string, hook: string, shares: string, reservedLiquidity: string, lastReserve: string, user: string, handler: string, strike: { __typename?: 'Strike', id: string, pool: string, tickLower: number, tickUpper: number } }> };

export type GetDopexDailyStrikeEarningsListQueryVariables = Exact<{
  tokenIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  tokenIdsCount: Scalars['Int']['input'];
  startTime: Scalars['BigInt']['input'];
}>;


export type GetDopexDailyStrikeEarningsListQuery = { __typename?: 'Query', dailyDonations: Array<{ __typename?: 'DailyDonation', id: string, donation: string, sqrtPriceX96: string, start: string, strike: { __typename?: 'Strike', id: string } }>, dailyFeeCompounds: Array<{ __typename?: 'DailyFeeCompound', id: string, compound: string, sqrtPriceX96: string, start: string, strike: { __typename?: 'Strike', id: string } }> };

export type GetStrykeLiquidityListQueryVariables = Exact<{
  tokenIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetStrykeLiquidityListQuery = { __typename?: 'Query', strikes: Array<{ __typename?: 'Strike', id: string, handler: string, pool: string, hook: string, reservedLiquidity: string, usedLiquidity: string, totalLiquidity: string, tickLower: number, tickUpper: number, token0: { __typename?: 'Token', id: string, symbol: string, decimals: number }, token1: { __typename?: 'Token', id: string, symbol: string, decimals: number } }> };


export const GetDopexStrikeListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getDopexStrikeList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tokenIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"strikes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tokenIds"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"tickLower"}},{"kind":"Argument","name":{"kind":"Name","value":"orderDirection"},"value":{"kind":"EnumValue","value":"desc"}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"1000"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"handler"}},{"kind":"Field","name":{"kind":"Name","value":"pool"}},{"kind":"Field","name":{"kind":"Name","value":"hook"}},{"kind":"Field","name":{"kind":"Name","value":"tickLower"}},{"kind":"Field","name":{"kind":"Name","value":"tickUpper"}},{"kind":"Field","name":{"kind":"Name","value":"token0"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}},{"kind":"Field","name":{"kind":"Name","value":"decimals"}}]}},{"kind":"Field","name":{"kind":"Name","value":"token1"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}},{"kind":"Field","name":{"kind":"Name","value":"decimals"}}]}}]}}]}}]} as unknown as DocumentNode<GetDopexStrikeListQuery, GetDopexStrikeListQueryVariables>;
export const GetDopexLpPositionsListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getDopexLpPositionsList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lppositions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userIds"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"shares_gt"},"value":{"kind":"StringValue","value":"1","block":false}}]}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"1000"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"pool"}},{"kind":"Field","name":{"kind":"Name","value":"hook"}},{"kind":"Field","name":{"kind":"Name","value":"shares"}},{"kind":"Field","name":{"kind":"Name","value":"initialLiquidity"}},{"kind":"Field","name":{"kind":"Name","value":"user"}},{"kind":"Field","name":{"kind":"Name","value":"handler"}},{"kind":"Field","name":{"kind":"Name","value":"strike"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"pool"}},{"kind":"Field","name":{"kind":"Name","value":"tickLower"}},{"kind":"Field","name":{"kind":"Name","value":"tickUpper"}},{"kind":"Field","name":{"kind":"Name","value":"totalLiquidity"}},{"kind":"Field","name":{"kind":"Name","value":"usedLiquidity"}},{"kind":"Field","name":{"kind":"Name","value":"totalShares"}}]}}]}}]}}]} as unknown as DocumentNode<GetDopexLpPositionsListQuery, GetDopexLpPositionsListQueryVariables>;
export const GetStrykeReservedLiquiditiesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getStrykeReservedLiquidities"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"user"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"handler"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pool"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"hook"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lppositions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user"},"value":{"kind":"Variable","name":{"kind":"Name","value":"user"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"handler"},"value":{"kind":"Variable","name":{"kind":"Name","value":"handler"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"pool"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pool"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"hook"},"value":{"kind":"Variable","name":{"kind":"Name","value":"hook"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"reservedLiquidity_gt"},"value":{"kind":"IntValue","value":"0"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"1000"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"pool"}},{"kind":"Field","name":{"kind":"Name","value":"hook"}},{"kind":"Field","name":{"kind":"Name","value":"shares"}},{"kind":"Field","name":{"kind":"Name","value":"reservedLiquidity"}},{"kind":"Field","name":{"kind":"Name","value":"lastReserve"}},{"kind":"Field","name":{"kind":"Name","value":"user"}},{"kind":"Field","name":{"kind":"Name","value":"handler"}},{"kind":"Field","name":{"kind":"Name","value":"strike"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"pool"}},{"kind":"Field","name":{"kind":"Name","value":"tickLower"}},{"kind":"Field","name":{"kind":"Name","value":"tickUpper"}}]}}]}}]}}]} as unknown as DocumentNode<GetStrykeReservedLiquiditiesQuery, GetStrykeReservedLiquiditiesQueryVariables>;
export const GetDopexDailyStrikeEarningsListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getDopexDailyStrikeEarningsList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tokenIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tokenIdsCount"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"startTime"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BigInt"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dailyDonations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"strike_"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tokenIds"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"donation_gt"},"value":{"kind":"StringValue","value":"0","block":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"start_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startTime"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"start"}},{"kind":"Argument","name":{"kind":"Name","value":"orderDirection"},"value":{"kind":"EnumValue","value":"desc"}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tokenIdsCount"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"donation"}},{"kind":"Field","name":{"kind":"Name","value":"sqrtPriceX96"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"strike"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"dailyFeeCompounds"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"strike_"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tokenIds"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"compound_gt"},"value":{"kind":"StringValue","value":"0","block":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"start_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startTime"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"start"}},{"kind":"Argument","name":{"kind":"Name","value":"orderDirection"},"value":{"kind":"EnumValue","value":"desc"}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tokenIdsCount"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"compound"}},{"kind":"Field","name":{"kind":"Name","value":"sqrtPriceX96"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"strike"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<GetDopexDailyStrikeEarningsListQuery, GetDopexDailyStrikeEarningsListQueryVariables>;
export const GetStrykeLiquidityListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getStrykeLiquidityList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tokenIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"strikes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tokenIds"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"tickLower"}},{"kind":"Argument","name":{"kind":"Name","value":"orderDirection"},"value":{"kind":"EnumValue","value":"desc"}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"1000"}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"handler"}},{"kind":"Field","name":{"kind":"Name","value":"pool"}},{"kind":"Field","name":{"kind":"Name","value":"hook"}},{"kind":"Field","name":{"kind":"Name","value":"reservedLiquidity"}},{"kind":"Field","name":{"kind":"Name","value":"usedLiquidity"}},{"kind":"Field","name":{"kind":"Name","value":"totalLiquidity"}},{"kind":"Field","name":{"kind":"Name","value":"tickLower"}},{"kind":"Field","name":{"kind":"Name","value":"tickUpper"}},{"kind":"Field","name":{"kind":"Name","value":"token0"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}},{"kind":"Field","name":{"kind":"Name","value":"decimals"}}]}},{"kind":"Field","name":{"kind":"Name","value":"token1"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}},{"kind":"Field","name":{"kind":"Name","value":"decimals"}}]}}]}}]}}]} as unknown as DocumentNode<GetStrykeLiquidityListQuery, GetStrykeLiquidityListQueryVariables>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  BigDecimal: { input: string; output: string; }
  BigInt: { input: string; output: string; }
  Bytes: { input: any; output: any; }
  /**
   * 8 bytes signed integer
   *
   */
  Int8: { input: any; output: any; }
  /**
   * A string representation of microseconds UNIX timestamp (16 digits)
   *
   */
  Timestamp: { input: any; output: any; }
};

export enum Aggregation_Interval {
  Day = 'day',
  Hour = 'hour'
}

export type BlockChangedFilter = {
  number_gte: Scalars['Int']['input'];
};

export type Block_Height = {
  hash?: InputMaybe<Scalars['Bytes']['input']>;
  number?: InputMaybe<Scalars['Int']['input']>;
  number_gte?: InputMaybe<Scalars['Int']['input']>;
};

export type DailyDonation = {
  __typename?: 'DailyDonation';
  donation: Scalars['BigInt']['output'];
  id: Scalars['ID']['output'];
  sqrtPriceX96: Scalars['BigInt']['output'];
  start: Scalars['BigInt']['output'];
  strike: Strike;
};

export type DailyDonation_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<DailyDonation_Filter>>>;
  donation?: InputMaybe<Scalars['BigInt']['input']>;
  donation_gt?: InputMaybe<Scalars['BigInt']['input']>;
  donation_gte?: InputMaybe<Scalars['BigInt']['input']>;
  donation_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  donation_lt?: InputMaybe<Scalars['BigInt']['input']>;
  donation_lte?: InputMaybe<Scalars['BigInt']['input']>;
  donation_not?: InputMaybe<Scalars['BigInt']['input']>;
  donation_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  or?: InputMaybe<Array<InputMaybe<DailyDonation_Filter>>>;
  sqrtPriceX96?: InputMaybe<Scalars['BigInt']['input']>;
  sqrtPriceX96_gt?: InputMaybe<Scalars['BigInt']['input']>;
  sqrtPriceX96_gte?: InputMaybe<Scalars['BigInt']['input']>;
  sqrtPriceX96_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  sqrtPriceX96_lt?: InputMaybe<Scalars['BigInt']['input']>;
  sqrtPriceX96_lte?: InputMaybe<Scalars['BigInt']['input']>;
  sqrtPriceX96_not?: InputMaybe<Scalars['BigInt']['input']>;
  sqrtPriceX96_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  start?: InputMaybe<Scalars['BigInt']['input']>;
  start_gt?: InputMaybe<Scalars['BigInt']['input']>;
  start_gte?: InputMaybe<Scalars['BigInt']['input']>;
  start_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  start_lt?: InputMaybe<Scalars['BigInt']['input']>;
  start_lte?: InputMaybe<Scalars['BigInt']['input']>;
  start_not?: InputMaybe<Scalars['BigInt']['input']>;
  start_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  strike?: InputMaybe<Scalars['String']['input']>;
  strike_?: InputMaybe<Strike_Filter>;
  strike_contains?: InputMaybe<Scalars['String']['input']>;
  strike_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  strike_ends_with?: InputMaybe<Scalars['String']['input']>;
  strike_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  strike_gt?: InputMaybe<Scalars['String']['input']>;
  strike_gte?: InputMaybe<Scalars['String']['input']>;
  strike_in?: InputMaybe<Array<Scalars['String']['input']>>;
  strike_lt?: InputMaybe<Scalars['String']['input']>;
  strike_lte?: InputMaybe<Scalars['String']['input']>;
  strike_not?: InputMaybe<Scalars['String']['input']>;
  strike_not_contains?: InputMaybe<Scalars['String']['input']>;
  strike_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  strike_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  strike_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  strike_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  strike_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  strike_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  strike_starts_with?: InputMaybe<Scalars['String']['input']>;
  strike_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
};

export enum DailyDonation_OrderBy {
  Donation = 'donation',
  Id = 'id',
  SqrtPriceX96 = 'sqrtPriceX96',
  Start = 'start',
  Strike = 'strike',
  StrikeFeeGrowthInside0LastX128 = 'strike__feeGrowthInside0LastX128',
  StrikeFeeGrowthInside1LastX128 = 'strike__feeGrowthInside1LastX128',
  StrikeHandler = 'strike__handler',
  StrikeHook = 'strike__hook',
  StrikeId = 'strike__id',
  StrikePool = 'strike__pool',
  StrikeReservedLiquidity = 'strike__reservedLiquidity',
  StrikeTickLower = 'strike__tickLower',
  StrikeTickUpper = 'strike__tickUpper',
  StrikeTotalLiquidity = 'strike__totalLiquidity',
  StrikeTotalShares = 'strike__totalShares',
  StrikeUsedLiquidity = 'strike__usedLiquidity'
}

export type DailyFeeCompound = {
  __typename?: 'DailyFeeCompound';
  compound: Scalars['BigInt']['output'];
  id: Scalars['ID']['output'];
  sqrtPriceX96: Scalars['BigInt']['output'];
  start: Scalars['BigInt']['output'];
  strike: Strike;
};

export type DailyFeeCompound_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<DailyFeeCompound_Filter>>>;
  compound?: InputMaybe<Scalars['BigInt']['input']>;
  compound_gt?: InputMaybe<Scalars['BigInt']['input']>;
  compound_gte?: InputMaybe<Scalars['BigInt']['input']>;
  compound_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  compound_lt?: InputMaybe<Scalars['BigInt']['input']>;
  compound_lte?: InputMaybe<Scalars['BigInt']['input']>;
  compound_not?: InputMaybe<Scalars['BigInt']['input']>;
  compound_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  or?: InputMaybe<Array<InputMaybe<DailyFeeCompound_Filter>>>;
  sqrtPriceX96?: InputMaybe<Scalars['BigInt']['input']>;
  sqrtPriceX96_gt?: InputMaybe<Scalars['BigInt']['input']>;
  sqrtPriceX96_gte?: InputMaybe<Scalars['BigInt']['input']>;
  sqrtPriceX96_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  sqrtPriceX96_lt?: InputMaybe<Scalars['BigInt']['input']>;
  sqrtPriceX96_lte?: InputMaybe<Scalars['BigInt']['input']>;
  sqrtPriceX96_not?: InputMaybe<Scalars['BigInt']['input']>;
  sqrtPriceX96_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  start?: InputMaybe<Scalars['BigInt']['input']>;
  start_gt?: InputMaybe<Scalars['BigInt']['input']>;
  start_gte?: InputMaybe<Scalars['BigInt']['input']>;
  start_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  start_lt?: InputMaybe<Scalars['BigInt']['input']>;
  start_lte?: InputMaybe<Scalars['BigInt']['input']>;
  start_not?: InputMaybe<Scalars['BigInt']['input']>;
  start_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  strike?: InputMaybe<Scalars['String']['input']>;
  strike_?: InputMaybe<Strike_Filter>;
  strike_contains?: InputMaybe<Scalars['String']['input']>;
  strike_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  strike_ends_with?: InputMaybe<Scalars['String']['input']>;
  strike_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  strike_gt?: InputMaybe<Scalars['String']['input']>;
  strike_gte?: InputMaybe<Scalars['String']['input']>;
  strike_in?: InputMaybe<Array<Scalars['String']['input']>>;
  strike_lt?: InputMaybe<Scalars['String']['input']>;
  strike_lte?: InputMaybe<Scalars['String']['input']>;
  strike_not?: InputMaybe<Scalars['String']['input']>;
  strike_not_contains?: InputMaybe<Scalars['String']['input']>;
  strike_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  strike_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  strike_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  strike_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  strike_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  strike_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  strike_starts_with?: InputMaybe<Scalars['String']['input']>;
  strike_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
};

export enum DailyFeeCompound_OrderBy {
  Compound = 'compound',
  Id = 'id',
  SqrtPriceX96 = 'sqrtPriceX96',
  Start = 'start',
  Strike = 'strike',
  StrikeFeeGrowthInside0LastX128 = 'strike__feeGrowthInside0LastX128',
  StrikeFeeGrowthInside1LastX128 = 'strike__feeGrowthInside1LastX128',
  StrikeHandler = 'strike__handler',
  StrikeHook = 'strike__hook',
  StrikeId = 'strike__id',
  StrikePool = 'strike__pool',
  StrikeReservedLiquidity = 'strike__reservedLiquidity',
  StrikeTickLower = 'strike__tickLower',
  StrikeTickUpper = 'strike__tickUpper',
  StrikeTotalLiquidity = 'strike__totalLiquidity',
  StrikeTotalShares = 'strike__totalShares',
  StrikeUsedLiquidity = 'strike__usedLiquidity'
}

export type Donation = {
  __typename?: 'Donation';
  activeLiquidity: Scalars['BigInt']['output'];
  id: Scalars['ID']['output'];
  liquidity: Scalars['BigInt']['output'];
  sqrtPriceX96: Scalars['BigInt']['output'];
  strike: Strike;
  timestamp: Scalars['BigInt']['output'];
  totalLiquidity: Scalars['BigInt']['output'];
};

export type Donation_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  activeLiquidity?: InputMaybe<Scalars['BigInt']['input']>;
  activeLiquidity_gt?: InputMaybe<Scalars['BigInt']['input']>;
  activeLiquidity_gte?: InputMaybe<Scalars['BigInt']['input']>;
  activeLiquidity_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  activeLiquidity_lt?: InputMaybe<Scalars['BigInt']['input']>;
  activeLiquidity_lte?: InputMaybe<Scalars['BigInt']['input']>;
  activeLiquidity_not?: InputMaybe<Scalars['BigInt']['input']>;
  activeLiquidity_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  and?: InputMaybe<Array<InputMaybe<Donation_Filter>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  liquidity?: InputMaybe<Scalars['BigInt']['input']>;
  liquidity_gt?: InputMaybe<Scalars['BigInt']['input']>;
  liquidity_gte?: InputMaybe<Scalars['BigInt']['input']>;
  liquidity_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  liquidity_lt?: InputMaybe<Scalars['BigInt']['input']>;
  liquidity_lte?: InputMaybe<Scalars['BigInt']['input']>;
  liquidity_not?: InputMaybe<Scalars['BigInt']['input']>;
  liquidity_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  or?: InputMaybe<Array<InputMaybe<Donation_Filter>>>;
  sqrtPriceX96?: InputMaybe<Scalars['BigInt']['input']>;
  sqrtPriceX96_gt?: InputMaybe<Scalars['BigInt']['input']>;
  sqrtPriceX96_gte?: InputMaybe<Scalars['BigInt']['input']>;
  sqrtPriceX96_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  sqrtPriceX96_lt?: InputMaybe<Scalars['BigInt']['input']>;
  sqrtPriceX96_lte?: InputMaybe<Scalars['BigInt']['input']>;
  sqrtPriceX96_not?: InputMaybe<Scalars['BigInt']['input']>;
  sqrtPriceX96_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  strike?: InputMaybe<Scalars['String']['input']>;
  strike_?: InputMaybe<Strike_Filter>;
  strike_contains?: InputMaybe<Scalars['String']['input']>;
  strike_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  strike_ends_with?: InputMaybe<Scalars['String']['input']>;
  strike_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  strike_gt?: InputMaybe<Scalars['String']['input']>;
  strike_gte?: InputMaybe<Scalars['String']['input']>;
  strike_in?: InputMaybe<Array<Scalars['String']['input']>>;
  strike_lt?: InputMaybe<Scalars['String']['input']>;
  strike_lte?: InputMaybe<Scalars['String']['input']>;
  strike_not?: InputMaybe<Scalars['String']['input']>;
  strike_not_contains?: InputMaybe<Scalars['String']['input']>;
  strike_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  strike_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  strike_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  strike_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  strike_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  strike_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  strike_starts_with?: InputMaybe<Scalars['String']['input']>;
  strike_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  timestamp?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_gt?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_gte?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  timestamp_lt?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_lte?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_not?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  totalLiquidity?: InputMaybe<Scalars['BigInt']['input']>;
  totalLiquidity_gt?: InputMaybe<Scalars['BigInt']['input']>;
  totalLiquidity_gte?: InputMaybe<Scalars['BigInt']['input']>;
  totalLiquidity_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  totalLiquidity_lt?: InputMaybe<Scalars['BigInt']['input']>;
  totalLiquidity_lte?: InputMaybe<Scalars['BigInt']['input']>;
  totalLiquidity_not?: InputMaybe<Scalars['BigInt']['input']>;
  totalLiquidity_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
};

export enum Donation_OrderBy {
  ActiveLiquidity = 'activeLiquidity',
  Id = 'id',
  Liquidity = 'liquidity',
  SqrtPriceX96 = 'sqrtPriceX96',
  Strike = 'strike',
  StrikeFeeGrowthInside0LastX128 = 'strike__feeGrowthInside0LastX128',
  StrikeFeeGrowthInside1LastX128 = 'strike__feeGrowthInside1LastX128',
  StrikeHandler = 'strike__handler',
  StrikeHook = 'strike__hook',
  StrikeId = 'strike__id',
  StrikePool = 'strike__pool',
  StrikeReservedLiquidity = 'strike__reservedLiquidity',
  StrikeTickLower = 'strike__tickLower',
  StrikeTickUpper = 'strike__tickUpper',
  StrikeTotalLiquidity = 'strike__totalLiquidity',
  StrikeTotalShares = 'strike__totalShares',
  StrikeUsedLiquidity = 'strike__usedLiquidity',
  Timestamp = 'timestamp',
  TotalLiquidity = 'totalLiquidity'
}

export type FeeCompound = {
  __typename?: 'FeeCompound';
  activeLiquidity: Scalars['BigInt']['output'];
  id: Scalars['ID']['output'];
  liquidity: Scalars['BigInt']['output'];
  sqrtPriceX96: Scalars['BigInt']['output'];
  strike: Strike;
  timestamp: Scalars['BigInt']['output'];
  totalLiquidity: Scalars['BigInt']['output'];
};

export type FeeCompound_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  activeLiquidity?: InputMaybe<Scalars['BigInt']['input']>;
  activeLiquidity_gt?: InputMaybe<Scalars['BigInt']['input']>;
  activeLiquidity_gte?: InputMaybe<Scalars['BigInt']['input']>;
  activeLiquidity_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  activeLiquidity_lt?: InputMaybe<Scalars['BigInt']['input']>;
  activeLiquidity_lte?: InputMaybe<Scalars['BigInt']['input']>;
  activeLiquidity_not?: InputMaybe<Scalars['BigInt']['input']>;
  activeLiquidity_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  and?: InputMaybe<Array<InputMaybe<FeeCompound_Filter>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  liquidity?: InputMaybe<Scalars['BigInt']['input']>;
  liquidity_gt?: InputMaybe<Scalars['BigInt']['input']>;
  liquidity_gte?: InputMaybe<Scalars['BigInt']['input']>;
  liquidity_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  liquidity_lt?: InputMaybe<Scalars['BigInt']['input']>;
  liquidity_lte?: InputMaybe<Scalars['BigInt']['input']>;
  liquidity_not?: InputMaybe<Scalars['BigInt']['input']>;
  liquidity_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  or?: InputMaybe<Array<InputMaybe<FeeCompound_Filter>>>;
  sqrtPriceX96?: InputMaybe<Scalars['BigInt']['input']>;
  sqrtPriceX96_gt?: InputMaybe<Scalars['BigInt']['input']>;
  sqrtPriceX96_gte?: InputMaybe<Scalars['BigInt']['input']>;
  sqrtPriceX96_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  sqrtPriceX96_lt?: InputMaybe<Scalars['BigInt']['input']>;
  sqrtPriceX96_lte?: InputMaybe<Scalars['BigInt']['input']>;
  sqrtPriceX96_not?: InputMaybe<Scalars['BigInt']['input']>;
  sqrtPriceX96_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  strike?: InputMaybe<Scalars['String']['input']>;
  strike_?: InputMaybe<Strike_Filter>;
  strike_contains?: InputMaybe<Scalars['String']['input']>;
  strike_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  strike_ends_with?: InputMaybe<Scalars['String']['input']>;
  strike_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  strike_gt?: InputMaybe<Scalars['String']['input']>;
  strike_gte?: InputMaybe<Scalars['String']['input']>;
  strike_in?: InputMaybe<Array<Scalars['String']['input']>>;
  strike_lt?: InputMaybe<Scalars['String']['input']>;
  strike_lte?: InputMaybe<Scalars['String']['input']>;
  strike_not?: InputMaybe<Scalars['String']['input']>;
  strike_not_contains?: InputMaybe<Scalars['String']['input']>;
  strike_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  strike_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  strike_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  strike_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  strike_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  strike_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  strike_starts_with?: InputMaybe<Scalars['String']['input']>;
  strike_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  timestamp?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_gt?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_gte?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  timestamp_lt?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_lte?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_not?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  totalLiquidity?: InputMaybe<Scalars['BigInt']['input']>;
  totalLiquidity_gt?: InputMaybe<Scalars['BigInt']['input']>;
  totalLiquidity_gte?: InputMaybe<Scalars['BigInt']['input']>;
  totalLiquidity_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  totalLiquidity_lt?: InputMaybe<Scalars['BigInt']['input']>;
  totalLiquidity_lte?: InputMaybe<Scalars['BigInt']['input']>;
  totalLiquidity_not?: InputMaybe<Scalars['BigInt']['input']>;
  totalLiquidity_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
};

export enum FeeCompound_OrderBy {
  ActiveLiquidity = 'activeLiquidity',
  Id = 'id',
  Liquidity = 'liquidity',
  SqrtPriceX96 = 'sqrtPriceX96',
  Strike = 'strike',
  StrikeFeeGrowthInside0LastX128 = 'strike__feeGrowthInside0LastX128',
  StrikeFeeGrowthInside1LastX128 = 'strike__feeGrowthInside1LastX128',
  StrikeHandler = 'strike__handler',
  StrikeHook = 'strike__hook',
  StrikeId = 'strike__id',
  StrikePool = 'strike__pool',
  StrikeReservedLiquidity = 'strike__reservedLiquidity',
  StrikeTickLower = 'strike__tickLower',
  StrikeTickUpper = 'strike__tickUpper',
  StrikeTotalLiquidity = 'strike__totalLiquidity',
  StrikeTotalShares = 'strike__totalShares',
  StrikeUsedLiquidity = 'strike__usedLiquidity',
  Timestamp = 'timestamp',
  TotalLiquidity = 'totalLiquidity'
}

export type LpPosition = {
  __typename?: 'LPPosition';
  handler: Scalars['String']['output'];
  hook: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  initalSqrtPriceX96: Scalars['BigInt']['output'];
  initialLiquidity: Scalars['BigInt']['output'];
  lastReserve: Scalars['BigInt']['output'];
  lpPositionBurns: Array<LpPositionBurn>;
  lpPositionMints: Array<LpPositionMint>;
  mintPosition: Array<MintPosition>;
  pool: Scalars['String']['output'];
  reservedLiquidity: Scalars['BigInt']['output'];
  shares: Scalars['BigInt']['output'];
  strike: Strike;
  timestamp: Scalars['BigInt']['output'];
  user: Scalars['String']['output'];
};


export type LpPositionLpPositionBurnsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<LpPositionBurn_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<LpPositionBurn_Filter>;
};


export type LpPositionLpPositionMintsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<LpPositionMint_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<LpPositionMint_Filter>;
};


export type LpPositionMintPositionArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<MintPosition_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MintPosition_Filter>;
};

export type LpPositionBurn = {
  __typename?: 'LPPositionBurn';
  handler: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  liquidity: Scalars['BigInt']['output'];
  lpPosition: LpPosition;
  pool: Scalars['String']['output'];
  sqrtPriceX96: Scalars['BigInt']['output'];
  strike: Strike;
  timestamp: Scalars['BigInt']['output'];
  user: Scalars['String']['output'];
};

export type LpPositionBurn_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<LpPositionBurn_Filter>>>;
  handler?: InputMaybe<Scalars['String']['input']>;
  handler_contains?: InputMaybe<Scalars['String']['input']>;
  handler_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  handler_ends_with?: InputMaybe<Scalars['String']['input']>;
  handler_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  handler_gt?: InputMaybe<Scalars['String']['input']>;
  handler_gte?: InputMaybe<Scalars['String']['input']>;
  handler_in?: InputMaybe<Array<Scalars['String']['input']>>;
  handler_lt?: InputMaybe<Scalars['String']['input']>;
  handler_lte?: InputMaybe<Scalars['String']['input']>;
  handler_not?: InputMaybe<Scalars['String']['input']>;
  handler_not_contains?: InputMaybe<Scalars['String']['input']>;
  handler_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  handler_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  handler_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  handler_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  handler_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  handler_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  handler_starts_with?: InputMaybe<Scalars['String']['input']>;
  handler_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  liquidity?: InputMaybe<Scalars['BigInt']['input']>;
  liquidity_gt?: InputMaybe<Scalars['BigInt']['input']>;
  liquidity_gte?: InputMaybe<Scalars['BigInt']['input']>;
  liquidity_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  liquidity_lt?: InputMaybe<Scalars['BigInt']['input']>;
  liquidity_lte?: InputMaybe<Scalars['BigInt']['input']>;
  liquidity_not?: InputMaybe<Scalars['BigInt']['input']>;
  liquidity_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  lpPosition?: InputMaybe<Scalars['String']['input']>;
  lpPosition_?: InputMaybe<LpPosition_Filter>;
  lpPosition_contains?: InputMaybe<Scalars['String']['input']>;
  lpPosition_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  lpPosition_ends_with?: InputMaybe<Scalars['String']['input']>;
  lpPosition_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  lpPosition_gt?: InputMaybe<Scalars['String']['input']>;
  lpPosition_gte?: InputMaybe<Scalars['String']['input']>;
  lpPosition_in?: InputMaybe<Array<Scalars['String']['input']>>;
  lpPosition_lt?: InputMaybe<Scalars['String']['input']>;
  lpPosition_lte?: InputMaybe<Scalars['String']['input']>;
  lpPosition_not?: InputMaybe<Scalars['String']['input']>;
  lpPosition_not_contains?: InputMaybe<Scalars['String']['input']>;
  lpPosition_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  lpPosition_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  lpPosition_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  lpPosition_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  lpPosition_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  lpPosition_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  lpPosition_starts_with?: InputMaybe<Scalars['String']['input']>;
  lpPosition_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  or?: InputMaybe<Array<InputMaybe<LpPositionBurn_Filter>>>;
  pool?: InputMaybe<Scalars['String']['input']>;
  pool_contains?: InputMaybe<Scalars['String']['input']>;
  pool_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  pool_ends_with?: InputMaybe<Scalars['String']['input']>;
  pool_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  pool_gt?: InputMaybe<Scalars['String']['input']>;
  pool_gte?: InputMaybe<Scalars['String']['input']>;
  pool_in?: InputMaybe<Array<Scalars['String']['input']>>;
  pool_lt?: InputMaybe<Scalars['String']['input']>;
  pool_lte?: InputMaybe<Scalars['String']['input']>;
  pool_not?: InputMaybe<Scalars['String']['input']>;
  pool_not_contains?: InputMaybe<Scalars['String']['input']>;
  pool_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  pool_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  pool_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  pool_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  pool_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  pool_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  pool_starts_with?: InputMaybe<Scalars['String']['input']>;
  pool_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  sqrtPriceX96?: InputMaybe<Scalars['BigInt']['input']>;
  sqrtPriceX96_gt?: InputMaybe<Scalars['BigInt']['input']>;
  sqrtPriceX96_gte?: InputMaybe<Scalars['BigInt']['input']>;
  sqrtPriceX96_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  sqrtPriceX96_lt?: InputMaybe<Scalars['BigInt']['input']>;
  sqrtPriceX96_lte?: InputMaybe<Scalars['BigInt']['input']>;
  sqrtPriceX96_not?: InputMaybe<Scalars['BigInt']['input']>;
  sqrtPriceX96_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  strike?: InputMaybe<Scalars['String']['input']>;
  strike_?: InputMaybe<Strike_Filter>;
  strike_contains?: InputMaybe<Scalars['String']['input']>;
  strike_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  strike_ends_with?: InputMaybe<Scalars['String']['input']>;
  strike_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  strike_gt?: InputMaybe<Scalars['String']['input']>;
  strike_gte?: InputMaybe<Scalars['String']['input']>;
  strike_in?: InputMaybe<Array<Scalars['String']['input']>>;
  strike_lt?: InputMaybe<Scalars['String']['input']>;
  strike_lte?: InputMaybe<Scalars['String']['input']>;
  strike_not?: InputMaybe<Scalars['String']['input']>;
  strike_not_contains?: InputMaybe<Scalars['String']['input']>;
  strike_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  strike_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  strike_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  strike_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  strike_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  strike_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  strike_starts_with?: InputMaybe<Scalars['String']['input']>;
  strike_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  timestamp?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_gt?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_gte?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  timestamp_lt?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_lte?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_not?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  user?: InputMaybe<Scalars['String']['input']>;
  user_contains?: InputMaybe<Scalars['String']['input']>;
  user_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  user_ends_with?: InputMaybe<Scalars['String']['input']>;
  user_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  user_gt?: InputMaybe<Scalars['String']['input']>;
  user_gte?: InputMaybe<Scalars['String']['input']>;
  user_in?: InputMaybe<Array<Scalars['String']['input']>>;
  user_lt?: InputMaybe<Scalars['String']['input']>;
  user_lte?: InputMaybe<Scalars['String']['input']>;
  user_not?: InputMaybe<Scalars['String']['input']>;
  user_not_contains?: InputMaybe<Scalars['String']['input']>;
  user_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  user_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  user_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  user_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  user_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  user_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  user_starts_with?: InputMaybe<Scalars['String']['input']>;
  user_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
};

export enum LpPositionBurn_OrderBy {
  Handler = 'handler',
  Id = 'id',
  Liquidity = 'liquidity',
  LpPosition = 'lpPosition',
  LpPositionHandler = 'lpPosition__handler',
  LpPositionHook = 'lpPosition__hook',
  LpPositionId = 'lpPosition__id',
  LpPositionInitalSqrtPriceX96 = 'lpPosition__initalSqrtPriceX96',
  LpPositionInitialLiquidity = 'lpPosition__initialLiquidity',
  LpPositionLastReserve = 'lpPosition__lastReserve',
  LpPositionPool = 'lpPosition__pool',
  LpPositionReservedLiquidity = 'lpPosition__reservedLiquidity',
  LpPositionShares = 'lpPosition__shares',
  LpPositionTimestamp = 'lpPosition__timestamp',
  LpPositionUser = 'lpPosition__user',
  Pool = 'pool',
  SqrtPriceX96 = 'sqrtPriceX96',
  Strike = 'strike',
  StrikeFeeGrowthInside0LastX128 = 'strike__feeGrowthInside0LastX128',
  StrikeFeeGrowthInside1LastX128 = 'strike__feeGrowthInside1LastX128',
  StrikeHandler = 'strike__handler',
  StrikeHook = 'strike__hook',
  StrikeId = 'strike__id',
  StrikePool = 'strike__pool',
  StrikeReservedLiquidity = 'strike__reservedLiquidity',
  StrikeTickLower = 'strike__tickLower',
  StrikeTickUpper = 'strike__tickUpper',
  StrikeTotalLiquidity = 'strike__totalLiquidity',
  StrikeTotalShares = 'strike__totalShares',
  StrikeUsedLiquidity = 'strike__usedLiquidity',
  Timestamp = 'timestamp',
  User = 'user'
}

export type LpPositionMint = {
  __typename?: 'LPPositionMint';
  handler: Scalars['String']['output'];
  hook: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  liquidity: Scalars['BigInt']['output'];
  lpPosition: LpPosition;
  pool: Scalars['String']['output'];
  sqrtPriceX96: Scalars['BigInt']['output'];
  strike: Strike;
  timestamp: Scalars['BigInt']['output'];
  user: Scalars['String']['output'];
};

export type LpPositionMint_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<LpPositionMint_Filter>>>;
  handler?: InputMaybe<Scalars['String']['input']>;
  handler_contains?: InputMaybe<Scalars['String']['input']>;
  handler_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  handler_ends_with?: InputMaybe<Scalars['String']['input']>;
  handler_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  handler_gt?: InputMaybe<Scalars['String']['input']>;
  handler_gte?: InputMaybe<Scalars['String']['input']>;
  handler_in?: InputMaybe<Array<Scalars['String']['input']>>;
  handler_lt?: InputMaybe<Scalars['String']['input']>;
  handler_lte?: InputMaybe<Scalars['String']['input']>;
  handler_not?: InputMaybe<Scalars['String']['input']>;
  handler_not_contains?: InputMaybe<Scalars['String']['input']>;
  handler_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  handler_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  handler_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  handler_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  handler_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  handler_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  handler_starts_with?: InputMaybe<Scalars['String']['input']>;
  handler_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  hook?: InputMaybe<Scalars['String']['input']>;
  hook_contains?: InputMaybe<Scalars['String']['input']>;
  hook_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  hook_ends_with?: InputMaybe<Scalars['String']['input']>;
  hook_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  hook_gt?: InputMaybe<Scalars['String']['input']>;
  hook_gte?: InputMaybe<Scalars['String']['input']>;
  hook_in?: InputMaybe<Array<Scalars['String']['input']>>;
  hook_lt?: InputMaybe<Scalars['String']['input']>;
  hook_lte?: InputMaybe<Scalars['String']['input']>;
  hook_not?: InputMaybe<Scalars['String']['input']>;
  hook_not_contains?: InputMaybe<Scalars['String']['input']>;
  hook_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  hook_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  hook_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  hook_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  hook_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  hook_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  hook_starts_with?: InputMaybe<Scalars['String']['input']>;
  hook_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  liquidity?: InputMaybe<Scalars['BigInt']['input']>;
  liquidity_gt?: InputMaybe<Scalars['BigInt']['input']>;
  liquidity_gte?: InputMaybe<Scalars['BigInt']['input']>;
  liquidity_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  liquidity_lt?: InputMaybe<Scalars['BigInt']['input']>;
  liquidity_lte?: InputMaybe<Scalars['BigInt']['input']>;
  liquidity_not?: InputMaybe<Scalars['BigInt']['input']>;
  liquidity_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  lpPosition?: InputMaybe<Scalars['String']['input']>;
  lpPosition_?: InputMaybe<LpPosition_Filter>;
  lpPosition_contains?: InputMaybe<Scalars['String']['input']>;
  lpPosition_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  lpPosition_ends_with?: InputMaybe<Scalars['String']['input']>;
  lpPosition_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  lpPosition_gt?: InputMaybe<Scalars['String']['input']>;
  lpPosition_gte?: InputMaybe<Scalars['String']['input']>;
  lpPosition_in?: InputMaybe<Array<Scalars['String']['input']>>;
  lpPosition_lt?: InputMaybe<Scalars['String']['input']>;
  lpPosition_lte?: InputMaybe<Scalars['String']['input']>;
  lpPosition_not?: InputMaybe<Scalars['String']['input']>;
  lpPosition_not_contains?: InputMaybe<Scalars['String']['input']>;
  lpPosition_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  lpPosition_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  lpPosition_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  lpPosition_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  lpPosition_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  lpPosition_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  lpPosition_starts_with?: InputMaybe<Scalars['String']['input']>;
  lpPosition_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  or?: InputMaybe<Array<InputMaybe<LpPositionMint_Filter>>>;
  pool?: InputMaybe<Scalars['String']['input']>;
  pool_contains?: InputMaybe<Scalars['String']['input']>;
  pool_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  pool_ends_with?: InputMaybe<Scalars['String']['input']>;
  pool_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  pool_gt?: InputMaybe<Scalars['String']['input']>;
  pool_gte?: InputMaybe<Scalars['String']['input']>;
  pool_in?: InputMaybe<Array<Scalars['String']['input']>>;
  pool_lt?: InputMaybe<Scalars['String']['input']>;
  pool_lte?: InputMaybe<Scalars['String']['input']>;
  pool_not?: InputMaybe<Scalars['String']['input']>;
  pool_not_contains?: InputMaybe<Scalars['String']['input']>;
  pool_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  pool_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  pool_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  pool_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  pool_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  pool_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  pool_starts_with?: InputMaybe<Scalars['String']['input']>;
  pool_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  sqrtPriceX96?: InputMaybe<Scalars['BigInt']['input']>;
  sqrtPriceX96_gt?: InputMaybe<Scalars['BigInt']['input']>;
  sqrtPriceX96_gte?: InputMaybe<Scalars['BigInt']['input']>;
  sqrtPriceX96_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  sqrtPriceX96_lt?: InputMaybe<Scalars['BigInt']['input']>;
  sqrtPriceX96_lte?: InputMaybe<Scalars['BigInt']['input']>;
  sqrtPriceX96_not?: InputMaybe<Scalars['BigInt']['input']>;
  sqrtPriceX96_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  strike?: InputMaybe<Scalars['String']['input']>;
  strike_?: InputMaybe<Strike_Filter>;
  strike_contains?: InputMaybe<Scalars['String']['input']>;
  strike_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  strike_ends_with?: InputMaybe<Scalars['String']['input']>;
  strike_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  strike_gt?: InputMaybe<Scalars['String']['input']>;
  strike_gte?: InputMaybe<Scalars['String']['input']>;
  strike_in?: InputMaybe<Array<Scalars['String']['input']>>;
  strike_lt?: InputMaybe<Scalars['String']['input']>;
  strike_lte?: InputMaybe<Scalars['String']['input']>;
  strike_not?: InputMaybe<Scalars['String']['input']>;
  strike_not_contains?: InputMaybe<Scalars['String']['input']>;
  strike_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  strike_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  strike_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  strike_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  strike_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  strike_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  strike_starts_with?: InputMaybe<Scalars['String']['input']>;
  strike_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  timestamp?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_gt?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_gte?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  timestamp_lt?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_lte?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_not?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  user?: InputMaybe<Scalars['String']['input']>;
  user_contains?: InputMaybe<Scalars['String']['input']>;
  user_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  user_ends_with?: InputMaybe<Scalars['String']['input']>;
  user_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  user_gt?: InputMaybe<Scalars['String']['input']>;
  user_gte?: InputMaybe<Scalars['String']['input']>;
  user_in?: InputMaybe<Array<Scalars['String']['input']>>;
  user_lt?: InputMaybe<Scalars['String']['input']>;
  user_lte?: InputMaybe<Scalars['String']['input']>;
  user_not?: InputMaybe<Scalars['String']['input']>;
  user_not_contains?: InputMaybe<Scalars['String']['input']>;
  user_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  user_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  user_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  user_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  user_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  user_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  user_starts_with?: InputMaybe<Scalars['String']['input']>;
  user_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
};

export enum LpPositionMint_OrderBy {
  Handler = 'handler',
  Hook = 'hook',
  Id = 'id',
  Liquidity = 'liquidity',
  LpPosition = 'lpPosition',
  LpPositionHandler = 'lpPosition__handler',
  LpPositionHook = 'lpPosition__hook',
  LpPositionId = 'lpPosition__id',
  LpPositionInitalSqrtPriceX96 = 'lpPosition__initalSqrtPriceX96',
  LpPositionInitialLiquidity = 'lpPosition__initialLiquidity',
  LpPositionLastReserve = 'lpPosition__lastReserve',
  LpPositionPool = 'lpPosition__pool',
  LpPositionReservedLiquidity = 'lpPosition__reservedLiquidity',
  LpPositionShares = 'lpPosition__shares',
  LpPositionTimestamp = 'lpPosition__timestamp',
  LpPositionUser = 'lpPosition__user',
  Pool = 'pool',
  SqrtPriceX96 = 'sqrtPriceX96',
  Strike = 'strike',
  StrikeFeeGrowthInside0LastX128 = 'strike__feeGrowthInside0LastX128',
  StrikeFeeGrowthInside1LastX128 = 'strike__feeGrowthInside1LastX128',
  StrikeHandler = 'strike__handler',
  StrikeHook = 'strike__hook',
  StrikeId = 'strike__id',
  StrikePool = 'strike__pool',
  StrikeReservedLiquidity = 'strike__reservedLiquidity',
  StrikeTickLower = 'strike__tickLower',
  StrikeTickUpper = 'strike__tickUpper',
  StrikeTotalLiquidity = 'strike__totalLiquidity',
  StrikeTotalShares = 'strike__totalShares',
  StrikeUsedLiquidity = 'strike__usedLiquidity',
  Timestamp = 'timestamp',
  User = 'user'
}

export type LpPositionTransfer = {
  __typename?: 'LPPositionTransfer';
  from: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  liquidity: Scalars['BigInt']['output'];
  shares: Scalars['BigInt']['output'];
  sqrtPriceX96: Scalars['BigInt']['output'];
  strike: Strike;
  timestamp: Scalars['BigInt']['output'];
  to: Scalars['String']['output'];
};

export type LpPositionTransfer_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<LpPositionTransfer_Filter>>>;
  from?: InputMaybe<Scalars['String']['input']>;
  from_contains?: InputMaybe<Scalars['String']['input']>;
  from_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  from_ends_with?: InputMaybe<Scalars['String']['input']>;
  from_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  from_gt?: InputMaybe<Scalars['String']['input']>;
  from_gte?: InputMaybe<Scalars['String']['input']>;
  from_in?: InputMaybe<Array<Scalars['String']['input']>>;
  from_lt?: InputMaybe<Scalars['String']['input']>;
  from_lte?: InputMaybe<Scalars['String']['input']>;
  from_not?: InputMaybe<Scalars['String']['input']>;
  from_not_contains?: InputMaybe<Scalars['String']['input']>;
  from_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  from_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  from_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  from_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  from_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  from_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  from_starts_with?: InputMaybe<Scalars['String']['input']>;
  from_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  liquidity?: InputMaybe<Scalars['BigInt']['input']>;
  liquidity_gt?: InputMaybe<Scalars['BigInt']['input']>;
  liquidity_gte?: InputMaybe<Scalars['BigInt']['input']>;
  liquidity_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  liquidity_lt?: InputMaybe<Scalars['BigInt']['input']>;
  liquidity_lte?: InputMaybe<Scalars['BigInt']['input']>;
  liquidity_not?: InputMaybe<Scalars['BigInt']['input']>;
  liquidity_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  or?: InputMaybe<Array<InputMaybe<LpPositionTransfer_Filter>>>;
  shares?: InputMaybe<Scalars['BigInt']['input']>;
  shares_gt?: InputMaybe<Scalars['BigInt']['input']>;
  shares_gte?: InputMaybe<Scalars['BigInt']['input']>;
  shares_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  shares_lt?: InputMaybe<Scalars['BigInt']['input']>;
  shares_lte?: InputMaybe<Scalars['BigInt']['input']>;
  shares_not?: InputMaybe<Scalars['BigInt']['input']>;
  shares_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  sqrtPriceX96?: InputMaybe<Scalars['BigInt']['input']>;
  sqrtPriceX96_gt?: InputMaybe<Scalars['BigInt']['input']>;
  sqrtPriceX96_gte?: InputMaybe<Scalars['BigInt']['input']>;
  sqrtPriceX96_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  sqrtPriceX96_lt?: InputMaybe<Scalars['BigInt']['input']>;
  sqrtPriceX96_lte?: InputMaybe<Scalars['BigInt']['input']>;
  sqrtPriceX96_not?: InputMaybe<Scalars['BigInt']['input']>;
  sqrtPriceX96_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  strike?: InputMaybe<Scalars['String']['input']>;
  strike_?: InputMaybe<Strike_Filter>;
  strike_contains?: InputMaybe<Scalars['String']['input']>;
  strike_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  strike_ends_with?: InputMaybe<Scalars['String']['input']>;
  strike_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  strike_gt?: InputMaybe<Scalars['String']['input']>;
  strike_gte?: InputMaybe<Scalars['String']['input']>;
  strike_in?: InputMaybe<Array<Scalars['String']['input']>>;
  strike_lt?: InputMaybe<Scalars['String']['input']>;
  strike_lte?: InputMaybe<Scalars['String']['input']>;
  strike_not?: InputMaybe<Scalars['String']['input']>;
  strike_not_contains?: InputMaybe<Scalars['String']['input']>;
  strike_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  strike_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  strike_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  strike_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  strike_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  strike_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  strike_starts_with?: InputMaybe<Scalars['String']['input']>;
  strike_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  timestamp?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_gt?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_gte?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  timestamp_lt?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_lte?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_not?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  to?: InputMaybe<Scalars['String']['input']>;
  to_contains?: InputMaybe<Scalars['String']['input']>;
  to_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  to_ends_with?: InputMaybe<Scalars['String']['input']>;
  to_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  to_gt?: InputMaybe<Scalars['String']['input']>;
  to_gte?: InputMaybe<Scalars['String']['input']>;
  to_in?: InputMaybe<Array<Scalars['String']['input']>>;
  to_lt?: InputMaybe<Scalars['String']['input']>;
  to_lte?: InputMaybe<Scalars['String']['input']>;
  to_not?: InputMaybe<Scalars['String']['input']>;
  to_not_contains?: InputMaybe<Scalars['String']['input']>;
  to_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  to_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  to_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  to_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  to_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  to_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  to_starts_with?: InputMaybe<Scalars['String']['input']>;
  to_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
};

export enum LpPositionTransfer_OrderBy {
  From = 'from',
  Id = 'id',
  Liquidity = 'liquidity',
  Shares = 'shares',
  SqrtPriceX96 = 'sqrtPriceX96',
  Strike = 'strike',
  StrikeFeeGrowthInside0LastX128 = 'strike__feeGrowthInside0LastX128',
  StrikeFeeGrowthInside1LastX128 = 'strike__feeGrowthInside1LastX128',
  StrikeHandler = 'strike__handler',
  StrikeHook = 'strike__hook',
  StrikeId = 'strike__id',
  StrikePool = 'strike__pool',
  StrikeReservedLiquidity = 'strike__reservedLiquidity',
  StrikeTickLower = 'strike__tickLower',
  StrikeTickUpper = 'strike__tickUpper',
  StrikeTotalLiquidity = 'strike__totalLiquidity',
  StrikeTotalShares = 'strike__totalShares',
  StrikeUsedLiquidity = 'strike__usedLiquidity',
  Timestamp = 'timestamp',
  To = 'to'
}

export type LpPosition_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<LpPosition_Filter>>>;
  handler?: InputMaybe<Scalars['String']['input']>;
  handler_contains?: InputMaybe<Scalars['String']['input']>;
  handler_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  handler_ends_with?: InputMaybe<Scalars['String']['input']>;
  handler_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  handler_gt?: InputMaybe<Scalars['String']['input']>;
  handler_gte?: InputMaybe<Scalars['String']['input']>;
  handler_in?: InputMaybe<Array<Scalars['String']['input']>>;
  handler_lt?: InputMaybe<Scalars['String']['input']>;
  handler_lte?: InputMaybe<Scalars['String']['input']>;
  handler_not?: InputMaybe<Scalars['String']['input']>;
  handler_not_contains?: InputMaybe<Scalars['String']['input']>;
  handler_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  handler_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  handler_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  handler_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  handler_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  handler_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  handler_starts_with?: InputMaybe<Scalars['String']['input']>;
  handler_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  hook?: InputMaybe<Scalars['String']['input']>;
  hook_contains?: InputMaybe<Scalars['String']['input']>;
  hook_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  hook_ends_with?: InputMaybe<Scalars['String']['input']>;
  hook_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  hook_gt?: InputMaybe<Scalars['String']['input']>;
  hook_gte?: InputMaybe<Scalars['String']['input']>;
  hook_in?: InputMaybe<Array<Scalars['String']['input']>>;
  hook_lt?: InputMaybe<Scalars['String']['input']>;
  hook_lte?: InputMaybe<Scalars['String']['input']>;
  hook_not?: InputMaybe<Scalars['String']['input']>;
  hook_not_contains?: InputMaybe<Scalars['String']['input']>;
  hook_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  hook_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  hook_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  hook_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  hook_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  hook_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  hook_starts_with?: InputMaybe<Scalars['String']['input']>;
  hook_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  initalSqrtPriceX96?: InputMaybe<Scalars['BigInt']['input']>;
  initalSqrtPriceX96_gt?: InputMaybe<Scalars['BigInt']['input']>;
  initalSqrtPriceX96_gte?: InputMaybe<Scalars['BigInt']['input']>;
  initalSqrtPriceX96_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  initalSqrtPriceX96_lt?: InputMaybe<Scalars['BigInt']['input']>;
  initalSqrtPriceX96_lte?: InputMaybe<Scalars['BigInt']['input']>;
  initalSqrtPriceX96_not?: InputMaybe<Scalars['BigInt']['input']>;
  initalSqrtPriceX96_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  initialLiquidity?: InputMaybe<Scalars['BigInt']['input']>;
  initialLiquidity_gt?: InputMaybe<Scalars['BigInt']['input']>;
  initialLiquidity_gte?: InputMaybe<Scalars['BigInt']['input']>;
  initialLiquidity_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  initialLiquidity_lt?: InputMaybe<Scalars['BigInt']['input']>;
  initialLiquidity_lte?: InputMaybe<Scalars['BigInt']['input']>;
  initialLiquidity_not?: InputMaybe<Scalars['BigInt']['input']>;
  initialLiquidity_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  lastReserve?: InputMaybe<Scalars['BigInt']['input']>;
  lastReserve_gt?: InputMaybe<Scalars['BigInt']['input']>;
  lastReserve_gte?: InputMaybe<Scalars['BigInt']['input']>;
  lastReserve_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  lastReserve_lt?: InputMaybe<Scalars['BigInt']['input']>;
  lastReserve_lte?: InputMaybe<Scalars['BigInt']['input']>;
  lastReserve_not?: InputMaybe<Scalars['BigInt']['input']>;
  lastReserve_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  lpPositionBurns_?: InputMaybe<LpPositionBurn_Filter>;
  lpPositionMints_?: InputMaybe<LpPositionMint_Filter>;
  mintPosition_?: InputMaybe<MintPosition_Filter>;
  or?: InputMaybe<Array<InputMaybe<LpPosition_Filter>>>;
  pool?: InputMaybe<Scalars['String']['input']>;
  pool_contains?: InputMaybe<Scalars['String']['input']>;
  pool_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  pool_ends_with?: InputMaybe<Scalars['String']['input']>;
  pool_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  pool_gt?: InputMaybe<Scalars['String']['input']>;
  pool_gte?: InputMaybe<Scalars['String']['input']>;
  pool_in?: InputMaybe<Array<Scalars['String']['input']>>;
  pool_lt?: InputMaybe<Scalars['String']['input']>;
  pool_lte?: InputMaybe<Scalars['String']['input']>;
  pool_not?: InputMaybe<Scalars['String']['input']>;
  pool_not_contains?: InputMaybe<Scalars['String']['input']>;
  pool_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  pool_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  pool_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  pool_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  pool_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  pool_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  pool_starts_with?: InputMaybe<Scalars['String']['input']>;
  pool_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  reservedLiquidity?: InputMaybe<Scalars['BigInt']['input']>;
  reservedLiquidity_gt?: InputMaybe<Scalars['BigInt']['input']>;
  reservedLiquidity_gte?: InputMaybe<Scalars['BigInt']['input']>;
  reservedLiquidity_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  reservedLiquidity_lt?: InputMaybe<Scalars['BigInt']['input']>;
  reservedLiquidity_lte?: InputMaybe<Scalars['BigInt']['input']>;
  reservedLiquidity_not?: InputMaybe<Scalars['BigInt']['input']>;
  reservedLiquidity_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  shares?: InputMaybe<Scalars['BigInt']['input']>;
  shares_gt?: InputMaybe<Scalars['BigInt']['input']>;
  shares_gte?: InputMaybe<Scalars['BigInt']['input']>;
  shares_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  shares_lt?: InputMaybe<Scalars['BigInt']['input']>;
  shares_lte?: InputMaybe<Scalars['BigInt']['input']>;
  shares_not?: InputMaybe<Scalars['BigInt']['input']>;
  shares_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  strike?: InputMaybe<Scalars['String']['input']>;
  strike_?: InputMaybe<Strike_Filter>;
  strike_contains?: InputMaybe<Scalars['String']['input']>;
  strike_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  strike_ends_with?: InputMaybe<Scalars['String']['input']>;
  strike_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  strike_gt?: InputMaybe<Scalars['String']['input']>;
  strike_gte?: InputMaybe<Scalars['String']['input']>;
  strike_in?: InputMaybe<Array<Scalars['String']['input']>>;
  strike_lt?: InputMaybe<Scalars['String']['input']>;
  strike_lte?: InputMaybe<Scalars['String']['input']>;
  strike_not?: InputMaybe<Scalars['String']['input']>;
  strike_not_contains?: InputMaybe<Scalars['String']['input']>;
  strike_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  strike_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  strike_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  strike_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  strike_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  strike_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  strike_starts_with?: InputMaybe<Scalars['String']['input']>;
  strike_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  timestamp?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_gt?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_gte?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  timestamp_lt?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_lte?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_not?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  user?: InputMaybe<Scalars['String']['input']>;
  user_contains?: InputMaybe<Scalars['String']['input']>;
  user_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  user_ends_with?: InputMaybe<Scalars['String']['input']>;
  user_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  user_gt?: InputMaybe<Scalars['String']['input']>;
  user_gte?: InputMaybe<Scalars['String']['input']>;
  user_in?: InputMaybe<Array<Scalars['String']['input']>>;
  user_lt?: InputMaybe<Scalars['String']['input']>;
  user_lte?: InputMaybe<Scalars['String']['input']>;
  user_not?: InputMaybe<Scalars['String']['input']>;
  user_not_contains?: InputMaybe<Scalars['String']['input']>;
  user_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  user_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  user_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  user_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  user_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  user_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  user_starts_with?: InputMaybe<Scalars['String']['input']>;
  user_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
};

export enum LpPosition_OrderBy {
  Handler = 'handler',
  Hook = 'hook',
  Id = 'id',
  InitalSqrtPriceX96 = 'initalSqrtPriceX96',
  InitialLiquidity = 'initialLiquidity',
  LastReserve = 'lastReserve',
  LpPositionBurns = 'lpPositionBurns',
  LpPositionMints = 'lpPositionMints',
  MintPosition = 'mintPosition',
  Pool = 'pool',
  ReservedLiquidity = 'reservedLiquidity',
  Shares = 'shares',
  Strike = 'strike',
  StrikeFeeGrowthInside0LastX128 = 'strike__feeGrowthInside0LastX128',
  StrikeFeeGrowthInside1LastX128 = 'strike__feeGrowthInside1LastX128',
  StrikeHandler = 'strike__handler',
  StrikeHook = 'strike__hook',
  StrikeId = 'strike__id',
  StrikePool = 'strike__pool',
  StrikeReservedLiquidity = 'strike__reservedLiquidity',
  StrikeTickLower = 'strike__tickLower',
  StrikeTickUpper = 'strike__tickUpper',
  StrikeTotalLiquidity = 'strike__totalLiquidity',
  StrikeTotalShares = 'strike__totalShares',
  StrikeUsedLiquidity = 'strike__usedLiquidity',
  Timestamp = 'timestamp',
  User = 'user'
}

export type MintOption = {
  __typename?: 'MintOption';
  frontendId: Scalars['Bytes']['output'];
  id: Scalars['ID']['output'];
  option: Option;
  optionMarket: OptionMarket;
  priceAtAction: Scalars['BigInt']['output'];
  receiver: Scalars['String']['output'];
  referralId: Scalars['Bytes']['output'];
  size: Scalars['BigInt']['output'];
  timestamp: Scalars['BigInt']['output'];
  user: Scalars['String']['output'];
};

export type MintOption_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<MintOption_Filter>>>;
  frontendId?: InputMaybe<Scalars['Bytes']['input']>;
  frontendId_contains?: InputMaybe<Scalars['Bytes']['input']>;
  frontendId_gt?: InputMaybe<Scalars['Bytes']['input']>;
  frontendId_gte?: InputMaybe<Scalars['Bytes']['input']>;
  frontendId_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  frontendId_lt?: InputMaybe<Scalars['Bytes']['input']>;
  frontendId_lte?: InputMaybe<Scalars['Bytes']['input']>;
  frontendId_not?: InputMaybe<Scalars['Bytes']['input']>;
  frontendId_not_contains?: InputMaybe<Scalars['Bytes']['input']>;
  frontendId_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  option?: InputMaybe<Scalars['String']['input']>;
  optionMarket?: InputMaybe<Scalars['String']['input']>;
  optionMarket_?: InputMaybe<OptionMarket_Filter>;
  optionMarket_contains?: InputMaybe<Scalars['String']['input']>;
  optionMarket_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  optionMarket_ends_with?: InputMaybe<Scalars['String']['input']>;
  optionMarket_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  optionMarket_gt?: InputMaybe<Scalars['String']['input']>;
  optionMarket_gte?: InputMaybe<Scalars['String']['input']>;
  optionMarket_in?: InputMaybe<Array<Scalars['String']['input']>>;
  optionMarket_lt?: InputMaybe<Scalars['String']['input']>;
  optionMarket_lte?: InputMaybe<Scalars['String']['input']>;
  optionMarket_not?: InputMaybe<Scalars['String']['input']>;
  optionMarket_not_contains?: InputMaybe<Scalars['String']['input']>;
  optionMarket_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  optionMarket_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  optionMarket_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  optionMarket_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  optionMarket_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  optionMarket_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  optionMarket_starts_with?: InputMaybe<Scalars['String']['input']>;
  optionMarket_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  option_?: InputMaybe<Option_Filter>;
  option_contains?: InputMaybe<Scalars['String']['input']>;
  option_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  option_ends_with?: InputMaybe<Scalars['String']['input']>;
  option_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  option_gt?: InputMaybe<Scalars['String']['input']>;
  option_gte?: InputMaybe<Scalars['String']['input']>;
  option_in?: InputMaybe<Array<Scalars['String']['input']>>;
  option_lt?: InputMaybe<Scalars['String']['input']>;
  option_lte?: InputMaybe<Scalars['String']['input']>;
  option_not?: InputMaybe<Scalars['String']['input']>;
  option_not_contains?: InputMaybe<Scalars['String']['input']>;
  option_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  option_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  option_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  option_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  option_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  option_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  option_starts_with?: InputMaybe<Scalars['String']['input']>;
  option_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  or?: InputMaybe<Array<InputMaybe<MintOption_Filter>>>;
  priceAtAction?: InputMaybe<Scalars['BigInt']['input']>;
  priceAtAction_gt?: InputMaybe<Scalars['BigInt']['input']>;
  priceAtAction_gte?: InputMaybe<Scalars['BigInt']['input']>;
  priceAtAction_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  priceAtAction_lt?: InputMaybe<Scalars['BigInt']['input']>;
  priceAtAction_lte?: InputMaybe<Scalars['BigInt']['input']>;
  priceAtAction_not?: InputMaybe<Scalars['BigInt']['input']>;
  priceAtAction_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  receiver?: InputMaybe<Scalars['String']['input']>;
  receiver_contains?: InputMaybe<Scalars['String']['input']>;
  receiver_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  receiver_ends_with?: InputMaybe<Scalars['String']['input']>;
  receiver_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  receiver_gt?: InputMaybe<Scalars['String']['input']>;
  receiver_gte?: InputMaybe<Scalars['String']['input']>;
  receiver_in?: InputMaybe<Array<Scalars['String']['input']>>;
  receiver_lt?: InputMaybe<Scalars['String']['input']>;
  receiver_lte?: InputMaybe<Scalars['String']['input']>;
  receiver_not?: InputMaybe<Scalars['String']['input']>;
  receiver_not_contains?: InputMaybe<Scalars['String']['input']>;
  receiver_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  receiver_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  receiver_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  receiver_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  receiver_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  receiver_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  receiver_starts_with?: InputMaybe<Scalars['String']['input']>;
  receiver_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  referralId?: InputMaybe<Scalars['Bytes']['input']>;
  referralId_contains?: InputMaybe<Scalars['Bytes']['input']>;
  referralId_gt?: InputMaybe<Scalars['Bytes']['input']>;
  referralId_gte?: InputMaybe<Scalars['Bytes']['input']>;
  referralId_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  referralId_lt?: InputMaybe<Scalars['Bytes']['input']>;
  referralId_lte?: InputMaybe<Scalars['Bytes']['input']>;
  referralId_not?: InputMaybe<Scalars['Bytes']['input']>;
  referralId_not_contains?: InputMaybe<Scalars['Bytes']['input']>;
  referralId_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  size?: InputMaybe<Scalars['BigInt']['input']>;
  size_gt?: InputMaybe<Scalars['BigInt']['input']>;
  size_gte?: InputMaybe<Scalars['BigInt']['input']>;
  size_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  size_lt?: InputMaybe<Scalars['BigInt']['input']>;
  size_lte?: InputMaybe<Scalars['BigInt']['input']>;
  size_not?: InputMaybe<Scalars['BigInt']['input']>;
  size_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  timestamp?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_gt?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_gte?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  timestamp_lt?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_lte?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_not?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  user?: InputMaybe<Scalars['String']['input']>;
  user_contains?: InputMaybe<Scalars['String']['input']>;
  user_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  user_ends_with?: InputMaybe<Scalars['String']['input']>;
  user_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  user_gt?: InputMaybe<Scalars['String']['input']>;
  user_gte?: InputMaybe<Scalars['String']['input']>;
  user_in?: InputMaybe<Array<Scalars['String']['input']>>;
  user_lt?: InputMaybe<Scalars['String']['input']>;
  user_lte?: InputMaybe<Scalars['String']['input']>;
  user_not?: InputMaybe<Scalars['String']['input']>;
  user_not_contains?: InputMaybe<Scalars['String']['input']>;
  user_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  user_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  user_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  user_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  user_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  user_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  user_starts_with?: InputMaybe<Scalars['String']['input']>;
  user_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
};

export enum MintOption_OrderBy {
  FrontendId = 'frontendId',
  Id = 'id',
  Option = 'option',
  OptionMarket = 'optionMarket',
  OptionMarketDpFee = 'optionMarket__dpFee',
  OptionMarketId = 'optionMarket__id',
  OptionMarketOptionsPricing = 'optionMarket__optionsPricing',
  OptionMarketPrimePool = 'optionMarket__primePool',
  OptionMarketTokenUriFetcher = 'optionMarket__tokenURIFetcher',
  OptionMarketTotalFees = 'optionMarket__totalFees',
  OptionMarketTotalPremium = 'optionMarket__totalPremium',
  OptionMarketTotalVolume = 'optionMarket__totalVolume',
  OptionExpiry = 'option__expiry',
  OptionId = 'option__id',
  OptionInitialSize = 'option__initialSize',
  OptionIsCall = 'option__isCall',
  OptionPremium = 'option__premium',
  OptionPurchasePrice = 'option__purchasePrice',
  OptionSize = 'option__size',
  OptionTickLower = 'option__tickLower',
  OptionTickUpper = 'option__tickUpper',
  OptionTimestamp = 'option__timestamp',
  OptionTokenId = 'option__tokenId',
  OptionUser = 'option__user',
  PriceAtAction = 'priceAtAction',
  Receiver = 'receiver',
  ReferralId = 'referralId',
  Size = 'size',
  Timestamp = 'timestamp',
  User = 'user'
}

export type MintPosition = {
  __typename?: 'MintPosition';
  frontendId: Scalars['Bytes']['output'];
  handler: Scalars['String']['output'];
  hook: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  liquidity: Scalars['BigInt']['output'];
  lpPosition: LpPosition;
  pool: Scalars['String']['output'];
  receiver: Scalars['String']['output'];
  referralId: Scalars['Bytes']['output'];
  sharesMinted: Scalars['BigInt']['output'];
  sqrtPriceX96: Scalars['BigInt']['output'];
  strike: Strike;
  timestamp: Scalars['BigInt']['output'];
  tokenId: Scalars['BigInt']['output'];
  user: Scalars['String']['output'];
};

export type MintPosition_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<MintPosition_Filter>>>;
  frontendId?: InputMaybe<Scalars['Bytes']['input']>;
  frontendId_contains?: InputMaybe<Scalars['Bytes']['input']>;
  frontendId_gt?: InputMaybe<Scalars['Bytes']['input']>;
  frontendId_gte?: InputMaybe<Scalars['Bytes']['input']>;
  frontendId_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  frontendId_lt?: InputMaybe<Scalars['Bytes']['input']>;
  frontendId_lte?: InputMaybe<Scalars['Bytes']['input']>;
  frontendId_not?: InputMaybe<Scalars['Bytes']['input']>;
  frontendId_not_contains?: InputMaybe<Scalars['Bytes']['input']>;
  frontendId_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  handler?: InputMaybe<Scalars['String']['input']>;
  handler_contains?: InputMaybe<Scalars['String']['input']>;
  handler_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  handler_ends_with?: InputMaybe<Scalars['String']['input']>;
  handler_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  handler_gt?: InputMaybe<Scalars['String']['input']>;
  handler_gte?: InputMaybe<Scalars['String']['input']>;
  handler_in?: InputMaybe<Array<Scalars['String']['input']>>;
  handler_lt?: InputMaybe<Scalars['String']['input']>;
  handler_lte?: InputMaybe<Scalars['String']['input']>;
  handler_not?: InputMaybe<Scalars['String']['input']>;
  handler_not_contains?: InputMaybe<Scalars['String']['input']>;
  handler_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  handler_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  handler_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  handler_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  handler_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  handler_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  handler_starts_with?: InputMaybe<Scalars['String']['input']>;
  handler_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  hook?: InputMaybe<Scalars['String']['input']>;
  hook_contains?: InputMaybe<Scalars['String']['input']>;
  hook_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  hook_ends_with?: InputMaybe<Scalars['String']['input']>;
  hook_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  hook_gt?: InputMaybe<Scalars['String']['input']>;
  hook_gte?: InputMaybe<Scalars['String']['input']>;
  hook_in?: InputMaybe<Array<Scalars['String']['input']>>;
  hook_lt?: InputMaybe<Scalars['String']['input']>;
  hook_lte?: InputMaybe<Scalars['String']['input']>;
  hook_not?: InputMaybe<Scalars['String']['input']>;
  hook_not_contains?: InputMaybe<Scalars['String']['input']>;
  hook_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  hook_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  hook_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  hook_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  hook_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  hook_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  hook_starts_with?: InputMaybe<Scalars['String']['input']>;
  hook_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  liquidity?: InputMaybe<Scalars['BigInt']['input']>;
  liquidity_gt?: InputMaybe<Scalars['BigInt']['input']>;
  liquidity_gte?: InputMaybe<Scalars['BigInt']['input']>;
  liquidity_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  liquidity_lt?: InputMaybe<Scalars['BigInt']['input']>;
  liquidity_lte?: InputMaybe<Scalars['BigInt']['input']>;
  liquidity_not?: InputMaybe<Scalars['BigInt']['input']>;
  liquidity_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  lpPosition?: InputMaybe<Scalars['String']['input']>;
  lpPosition_?: InputMaybe<LpPosition_Filter>;
  lpPosition_contains?: InputMaybe<Scalars['String']['input']>;
  lpPosition_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  lpPosition_ends_with?: InputMaybe<Scalars['String']['input']>;
  lpPosition_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  lpPosition_gt?: InputMaybe<Scalars['String']['input']>;
  lpPosition_gte?: InputMaybe<Scalars['String']['input']>;
  lpPosition_in?: InputMaybe<Array<Scalars['String']['input']>>;
  lpPosition_lt?: InputMaybe<Scalars['String']['input']>;
  lpPosition_lte?: InputMaybe<Scalars['String']['input']>;
  lpPosition_not?: InputMaybe<Scalars['String']['input']>;
  lpPosition_not_contains?: InputMaybe<Scalars['String']['input']>;
  lpPosition_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  lpPosition_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  lpPosition_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  lpPosition_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  lpPosition_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  lpPosition_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  lpPosition_starts_with?: InputMaybe<Scalars['String']['input']>;
  lpPosition_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  or?: InputMaybe<Array<InputMaybe<MintPosition_Filter>>>;
  pool?: InputMaybe<Scalars['String']['input']>;
  pool_contains?: InputMaybe<Scalars['String']['input']>;
  pool_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  pool_ends_with?: InputMaybe<Scalars['String']['input']>;
  pool_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  pool_gt?: InputMaybe<Scalars['String']['input']>;
  pool_gte?: InputMaybe<Scalars['String']['input']>;
  pool_in?: InputMaybe<Array<Scalars['String']['input']>>;
  pool_lt?: InputMaybe<Scalars['String']['input']>;
  pool_lte?: InputMaybe<Scalars['String']['input']>;
  pool_not?: InputMaybe<Scalars['String']['input']>;
  pool_not_contains?: InputMaybe<Scalars['String']['input']>;
  pool_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  pool_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  pool_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  pool_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  pool_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  pool_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  pool_starts_with?: InputMaybe<Scalars['String']['input']>;
  pool_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  receiver?: InputMaybe<Scalars['String']['input']>;
  receiver_contains?: InputMaybe<Scalars['String']['input']>;
  receiver_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  receiver_ends_with?: InputMaybe<Scalars['String']['input']>;
  receiver_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  receiver_gt?: InputMaybe<Scalars['String']['input']>;
  receiver_gte?: InputMaybe<Scalars['String']['input']>;
  receiver_in?: InputMaybe<Array<Scalars['String']['input']>>;
  receiver_lt?: InputMaybe<Scalars['String']['input']>;
  receiver_lte?: InputMaybe<Scalars['String']['input']>;
  receiver_not?: InputMaybe<Scalars['String']['input']>;
  receiver_not_contains?: InputMaybe<Scalars['String']['input']>;
  receiver_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  receiver_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  receiver_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  receiver_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  receiver_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  receiver_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  receiver_starts_with?: InputMaybe<Scalars['String']['input']>;
  receiver_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  referralId?: InputMaybe<Scalars['Bytes']['input']>;
  referralId_contains?: InputMaybe<Scalars['Bytes']['input']>;
  referralId_gt?: InputMaybe<Scalars['Bytes']['input']>;
  referralId_gte?: InputMaybe<Scalars['Bytes']['input']>;
  referralId_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  referralId_lt?: InputMaybe<Scalars['Bytes']['input']>;
  referralId_lte?: InputMaybe<Scalars['Bytes']['input']>;
  referralId_not?: InputMaybe<Scalars['Bytes']['input']>;
  referralId_not_contains?: InputMaybe<Scalars['Bytes']['input']>;
  referralId_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  sharesMinted?: InputMaybe<Scalars['BigInt']['input']>;
  sharesMinted_gt?: InputMaybe<Scalars['BigInt']['input']>;
  sharesMinted_gte?: InputMaybe<Scalars['BigInt']['input']>;
  sharesMinted_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  sharesMinted_lt?: InputMaybe<Scalars['BigInt']['input']>;
  sharesMinted_lte?: InputMaybe<Scalars['BigInt']['input']>;
  sharesMinted_not?: InputMaybe<Scalars['BigInt']['input']>;
  sharesMinted_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  sqrtPriceX96?: InputMaybe<Scalars['BigInt']['input']>;
  sqrtPriceX96_gt?: InputMaybe<Scalars['BigInt']['input']>;
  sqrtPriceX96_gte?: InputMaybe<Scalars['BigInt']['input']>;
  sqrtPriceX96_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  sqrtPriceX96_lt?: InputMaybe<Scalars['BigInt']['input']>;
  sqrtPriceX96_lte?: InputMaybe<Scalars['BigInt']['input']>;
  sqrtPriceX96_not?: InputMaybe<Scalars['BigInt']['input']>;
  sqrtPriceX96_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  strike?: InputMaybe<Scalars['String']['input']>;
  strike_?: InputMaybe<Strike_Filter>;
  strike_contains?: InputMaybe<Scalars['String']['input']>;
  strike_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  strike_ends_with?: InputMaybe<Scalars['String']['input']>;
  strike_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  strike_gt?: InputMaybe<Scalars['String']['input']>;
  strike_gte?: InputMaybe<Scalars['String']['input']>;
  strike_in?: InputMaybe<Array<Scalars['String']['input']>>;
  strike_lt?: InputMaybe<Scalars['String']['input']>;
  strike_lte?: InputMaybe<Scalars['String']['input']>;
  strike_not?: InputMaybe<Scalars['String']['input']>;
  strike_not_contains?: InputMaybe<Scalars['String']['input']>;
  strike_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  strike_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  strike_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  strike_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  strike_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  strike_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  strike_starts_with?: InputMaybe<Scalars['String']['input']>;
  strike_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  timestamp?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_gt?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_gte?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  timestamp_lt?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_lte?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_not?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  tokenId?: InputMaybe<Scalars['BigInt']['input']>;
  tokenId_gt?: InputMaybe<Scalars['BigInt']['input']>;
  tokenId_gte?: InputMaybe<Scalars['BigInt']['input']>;
  tokenId_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  tokenId_lt?: InputMaybe<Scalars['BigInt']['input']>;
  tokenId_lte?: InputMaybe<Scalars['BigInt']['input']>;
  tokenId_not?: InputMaybe<Scalars['BigInt']['input']>;
  tokenId_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  user?: InputMaybe<Scalars['String']['input']>;
  user_contains?: InputMaybe<Scalars['String']['input']>;
  user_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  user_ends_with?: InputMaybe<Scalars['String']['input']>;
  user_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  user_gt?: InputMaybe<Scalars['String']['input']>;
  user_gte?: InputMaybe<Scalars['String']['input']>;
  user_in?: InputMaybe<Array<Scalars['String']['input']>>;
  user_lt?: InputMaybe<Scalars['String']['input']>;
  user_lte?: InputMaybe<Scalars['String']['input']>;
  user_not?: InputMaybe<Scalars['String']['input']>;
  user_not_contains?: InputMaybe<Scalars['String']['input']>;
  user_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  user_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  user_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  user_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  user_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  user_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  user_starts_with?: InputMaybe<Scalars['String']['input']>;
  user_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
};

export enum MintPosition_OrderBy {
  FrontendId = 'frontendId',
  Handler = 'handler',
  Hook = 'hook',
  Id = 'id',
  Liquidity = 'liquidity',
  LpPosition = 'lpPosition',
  LpPositionHandler = 'lpPosition__handler',
  LpPositionHook = 'lpPosition__hook',
  LpPositionId = 'lpPosition__id',
  LpPositionInitalSqrtPriceX96 = 'lpPosition__initalSqrtPriceX96',
  LpPositionInitialLiquidity = 'lpPosition__initialLiquidity',
  LpPositionLastReserve = 'lpPosition__lastReserve',
  LpPositionPool = 'lpPosition__pool',
  LpPositionReservedLiquidity = 'lpPosition__reservedLiquidity',
  LpPositionShares = 'lpPosition__shares',
  LpPositionTimestamp = 'lpPosition__timestamp',
  LpPositionUser = 'lpPosition__user',
  Pool = 'pool',
  Receiver = 'receiver',
  ReferralId = 'referralId',
  SharesMinted = 'sharesMinted',
  SqrtPriceX96 = 'sqrtPriceX96',
  Strike = 'strike',
  StrikeFeeGrowthInside0LastX128 = 'strike__feeGrowthInside0LastX128',
  StrikeFeeGrowthInside1LastX128 = 'strike__feeGrowthInside1LastX128',
  StrikeHandler = 'strike__handler',
  StrikeHook = 'strike__hook',
  StrikeId = 'strike__id',
  StrikePool = 'strike__pool',
  StrikeReservedLiquidity = 'strike__reservedLiquidity',
  StrikeTickLower = 'strike__tickLower',
  StrikeTickUpper = 'strike__tickUpper',
  StrikeTotalLiquidity = 'strike__totalLiquidity',
  StrikeTotalShares = 'strike__totalShares',
  StrikeUsedLiquidity = 'strike__usedLiquidity',
  Timestamp = 'timestamp',
  TokenId = 'tokenId',
  User = 'user'
}

export type Option = {
  __typename?: 'Option';
  expiry: Scalars['BigInt']['output'];
  handlers?: Maybe<Array<Scalars['String']['output']>>;
  hooks?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['ID']['output'];
  initialSize: Scalars['BigInt']['output'];
  isCall: Scalars['Boolean']['output'];
  liquidities?: Maybe<Array<Scalars['BigInt']['output']>>;
  mintOption: Array<MintOption>;
  optionMarket: OptionMarket;
  pools?: Maybe<Array<Scalars['String']['output']>>;
  premium: Scalars['BigInt']['output'];
  purchasePrice: Scalars['BigInt']['output'];
  size: Scalars['BigInt']['output'];
  tickLower: Scalars['Int']['output'];
  tickUpper: Scalars['Int']['output'];
  timestamp: Scalars['BigInt']['output'];
  tokenId: Scalars['BigInt']['output'];
  user: Scalars['String']['output'];
};


export type OptionMintOptionArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<MintOption_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MintOption_Filter>;
};

export type OptionMarket = {
  __typename?: 'OptionMarket';
  callToken: Token;
  dpFee: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  optionsPricing: Scalars['String']['output'];
  primePool: Scalars['String']['output'];
  putToken: Token;
  tokenURIFetcher?: Maybe<Scalars['String']['output']>;
  totalFees: Scalars['BigDecimal']['output'];
  totalPremium: Scalars['BigDecimal']['output'];
  totalVolume: Scalars['BigDecimal']['output'];
};

export type OptionMarketDailyStat = {
  __typename?: 'OptionMarketDailyStat';
  fees: Scalars['BigDecimal']['output'];
  id: Scalars['ID']['output'];
  optionMarket: OptionMarket;
  premium: Scalars['BigDecimal']['output'];
  startTimestamp: Scalars['BigInt']['output'];
  volume: Scalars['BigDecimal']['output'];
};

export type OptionMarketDailyStat_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<OptionMarketDailyStat_Filter>>>;
  fees?: InputMaybe<Scalars['BigDecimal']['input']>;
  fees_gt?: InputMaybe<Scalars['BigDecimal']['input']>;
  fees_gte?: InputMaybe<Scalars['BigDecimal']['input']>;
  fees_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  fees_lt?: InputMaybe<Scalars['BigDecimal']['input']>;
  fees_lte?: InputMaybe<Scalars['BigDecimal']['input']>;
  fees_not?: InputMaybe<Scalars['BigDecimal']['input']>;
  fees_not_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  optionMarket?: InputMaybe<Scalars['String']['input']>;
  optionMarket_?: InputMaybe<OptionMarket_Filter>;
  optionMarket_contains?: InputMaybe<Scalars['String']['input']>;
  optionMarket_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  optionMarket_ends_with?: InputMaybe<Scalars['String']['input']>;
  optionMarket_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  optionMarket_gt?: InputMaybe<Scalars['String']['input']>;
  optionMarket_gte?: InputMaybe<Scalars['String']['input']>;
  optionMarket_in?: InputMaybe<Array<Scalars['String']['input']>>;
  optionMarket_lt?: InputMaybe<Scalars['String']['input']>;
  optionMarket_lte?: InputMaybe<Scalars['String']['input']>;
  optionMarket_not?: InputMaybe<Scalars['String']['input']>;
  optionMarket_not_contains?: InputMaybe<Scalars['String']['input']>;
  optionMarket_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  optionMarket_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  optionMarket_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  optionMarket_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  optionMarket_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  optionMarket_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  optionMarket_starts_with?: InputMaybe<Scalars['String']['input']>;
  optionMarket_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  or?: InputMaybe<Array<InputMaybe<OptionMarketDailyStat_Filter>>>;
  premium?: InputMaybe<Scalars['BigDecimal']['input']>;
  premium_gt?: InputMaybe<Scalars['BigDecimal']['input']>;
  premium_gte?: InputMaybe<Scalars['BigDecimal']['input']>;
  premium_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  premium_lt?: InputMaybe<Scalars['BigDecimal']['input']>;
  premium_lte?: InputMaybe<Scalars['BigDecimal']['input']>;
  premium_not?: InputMaybe<Scalars['BigDecimal']['input']>;
  premium_not_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  startTimestamp?: InputMaybe<Scalars['BigInt']['input']>;
  startTimestamp_gt?: InputMaybe<Scalars['BigInt']['input']>;
  startTimestamp_gte?: InputMaybe<Scalars['BigInt']['input']>;
  startTimestamp_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  startTimestamp_lt?: InputMaybe<Scalars['BigInt']['input']>;
  startTimestamp_lte?: InputMaybe<Scalars['BigInt']['input']>;
  startTimestamp_not?: InputMaybe<Scalars['BigInt']['input']>;
  startTimestamp_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  volume?: InputMaybe<Scalars['BigDecimal']['input']>;
  volume_gt?: InputMaybe<Scalars['BigDecimal']['input']>;
  volume_gte?: InputMaybe<Scalars['BigDecimal']['input']>;
  volume_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  volume_lt?: InputMaybe<Scalars['BigDecimal']['input']>;
  volume_lte?: InputMaybe<Scalars['BigDecimal']['input']>;
  volume_not?: InputMaybe<Scalars['BigDecimal']['input']>;
  volume_not_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
};

export enum OptionMarketDailyStat_OrderBy {
  Fees = 'fees',
  Id = 'id',
  OptionMarket = 'optionMarket',
  OptionMarketDpFee = 'optionMarket__dpFee',
  OptionMarketId = 'optionMarket__id',
  OptionMarketOptionsPricing = 'optionMarket__optionsPricing',
  OptionMarketPrimePool = 'optionMarket__primePool',
  OptionMarketTokenUriFetcher = 'optionMarket__tokenURIFetcher',
  OptionMarketTotalFees = 'optionMarket__totalFees',
  OptionMarketTotalPremium = 'optionMarket__totalPremium',
  OptionMarketTotalVolume = 'optionMarket__totalVolume',
  Premium = 'premium',
  StartTimestamp = 'startTimestamp',
  Volume = 'volume'
}

export type OptionMarket_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<OptionMarket_Filter>>>;
  callToken?: InputMaybe<Scalars['String']['input']>;
  callToken_?: InputMaybe<Token_Filter>;
  callToken_contains?: InputMaybe<Scalars['String']['input']>;
  callToken_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  callToken_ends_with?: InputMaybe<Scalars['String']['input']>;
  callToken_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  callToken_gt?: InputMaybe<Scalars['String']['input']>;
  callToken_gte?: InputMaybe<Scalars['String']['input']>;
  callToken_in?: InputMaybe<Array<Scalars['String']['input']>>;
  callToken_lt?: InputMaybe<Scalars['String']['input']>;
  callToken_lte?: InputMaybe<Scalars['String']['input']>;
  callToken_not?: InputMaybe<Scalars['String']['input']>;
  callToken_not_contains?: InputMaybe<Scalars['String']['input']>;
  callToken_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  callToken_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  callToken_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  callToken_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  callToken_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  callToken_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  callToken_starts_with?: InputMaybe<Scalars['String']['input']>;
  callToken_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  dpFee?: InputMaybe<Scalars['String']['input']>;
  dpFee_contains?: InputMaybe<Scalars['String']['input']>;
  dpFee_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  dpFee_ends_with?: InputMaybe<Scalars['String']['input']>;
  dpFee_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  dpFee_gt?: InputMaybe<Scalars['String']['input']>;
  dpFee_gte?: InputMaybe<Scalars['String']['input']>;
  dpFee_in?: InputMaybe<Array<Scalars['String']['input']>>;
  dpFee_lt?: InputMaybe<Scalars['String']['input']>;
  dpFee_lte?: InputMaybe<Scalars['String']['input']>;
  dpFee_not?: InputMaybe<Scalars['String']['input']>;
  dpFee_not_contains?: InputMaybe<Scalars['String']['input']>;
  dpFee_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  dpFee_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  dpFee_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  dpFee_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  dpFee_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  dpFee_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  dpFee_starts_with?: InputMaybe<Scalars['String']['input']>;
  dpFee_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  optionsPricing?: InputMaybe<Scalars['String']['input']>;
  optionsPricing_contains?: InputMaybe<Scalars['String']['input']>;
  optionsPricing_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  optionsPricing_ends_with?: InputMaybe<Scalars['String']['input']>;
  optionsPricing_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  optionsPricing_gt?: InputMaybe<Scalars['String']['input']>;
  optionsPricing_gte?: InputMaybe<Scalars['String']['input']>;
  optionsPricing_in?: InputMaybe<Array<Scalars['String']['input']>>;
  optionsPricing_lt?: InputMaybe<Scalars['String']['input']>;
  optionsPricing_lte?: InputMaybe<Scalars['String']['input']>;
  optionsPricing_not?: InputMaybe<Scalars['String']['input']>;
  optionsPricing_not_contains?: InputMaybe<Scalars['String']['input']>;
  optionsPricing_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  optionsPricing_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  optionsPricing_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  optionsPricing_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  optionsPricing_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  optionsPricing_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  optionsPricing_starts_with?: InputMaybe<Scalars['String']['input']>;
  optionsPricing_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  or?: InputMaybe<Array<InputMaybe<OptionMarket_Filter>>>;
  primePool?: InputMaybe<Scalars['String']['input']>;
  primePool_contains?: InputMaybe<Scalars['String']['input']>;
  primePool_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  primePool_ends_with?: InputMaybe<Scalars['String']['input']>;
  primePool_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  primePool_gt?: InputMaybe<Scalars['String']['input']>;
  primePool_gte?: InputMaybe<Scalars['String']['input']>;
  primePool_in?: InputMaybe<Array<Scalars['String']['input']>>;
  primePool_lt?: InputMaybe<Scalars['String']['input']>;
  primePool_lte?: InputMaybe<Scalars['String']['input']>;
  primePool_not?: InputMaybe<Scalars['String']['input']>;
  primePool_not_contains?: InputMaybe<Scalars['String']['input']>;
  primePool_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  primePool_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  primePool_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  primePool_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  primePool_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  primePool_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  primePool_starts_with?: InputMaybe<Scalars['String']['input']>;
  primePool_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  putToken?: InputMaybe<Scalars['String']['input']>;
  putToken_?: InputMaybe<Token_Filter>;
  putToken_contains?: InputMaybe<Scalars['String']['input']>;
  putToken_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  putToken_ends_with?: InputMaybe<Scalars['String']['input']>;
  putToken_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  putToken_gt?: InputMaybe<Scalars['String']['input']>;
  putToken_gte?: InputMaybe<Scalars['String']['input']>;
  putToken_in?: InputMaybe<Array<Scalars['String']['input']>>;
  putToken_lt?: InputMaybe<Scalars['String']['input']>;
  putToken_lte?: InputMaybe<Scalars['String']['input']>;
  putToken_not?: InputMaybe<Scalars['String']['input']>;
  putToken_not_contains?: InputMaybe<Scalars['String']['input']>;
  putToken_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  putToken_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  putToken_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  putToken_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  putToken_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  putToken_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  putToken_starts_with?: InputMaybe<Scalars['String']['input']>;
  putToken_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  tokenURIFetcher?: InputMaybe<Scalars['String']['input']>;
  tokenURIFetcher_contains?: InputMaybe<Scalars['String']['input']>;
  tokenURIFetcher_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  tokenURIFetcher_ends_with?: InputMaybe<Scalars['String']['input']>;
  tokenURIFetcher_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  tokenURIFetcher_gt?: InputMaybe<Scalars['String']['input']>;
  tokenURIFetcher_gte?: InputMaybe<Scalars['String']['input']>;
  tokenURIFetcher_in?: InputMaybe<Array<Scalars['String']['input']>>;
  tokenURIFetcher_lt?: InputMaybe<Scalars['String']['input']>;
  tokenURIFetcher_lte?: InputMaybe<Scalars['String']['input']>;
  tokenURIFetcher_not?: InputMaybe<Scalars['String']['input']>;
  tokenURIFetcher_not_contains?: InputMaybe<Scalars['String']['input']>;
  tokenURIFetcher_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  tokenURIFetcher_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  tokenURIFetcher_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  tokenURIFetcher_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  tokenURIFetcher_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  tokenURIFetcher_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  tokenURIFetcher_starts_with?: InputMaybe<Scalars['String']['input']>;
  tokenURIFetcher_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  totalFees?: InputMaybe<Scalars['BigDecimal']['input']>;
  totalFees_gt?: InputMaybe<Scalars['BigDecimal']['input']>;
  totalFees_gte?: InputMaybe<Scalars['BigDecimal']['input']>;
  totalFees_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  totalFees_lt?: InputMaybe<Scalars['BigDecimal']['input']>;
  totalFees_lte?: InputMaybe<Scalars['BigDecimal']['input']>;
  totalFees_not?: InputMaybe<Scalars['BigDecimal']['input']>;
  totalFees_not_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  totalPremium?: InputMaybe<Scalars['BigDecimal']['input']>;
  totalPremium_gt?: InputMaybe<Scalars['BigDecimal']['input']>;
  totalPremium_gte?: InputMaybe<Scalars['BigDecimal']['input']>;
  totalPremium_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  totalPremium_lt?: InputMaybe<Scalars['BigDecimal']['input']>;
  totalPremium_lte?: InputMaybe<Scalars['BigDecimal']['input']>;
  totalPremium_not?: InputMaybe<Scalars['BigDecimal']['input']>;
  totalPremium_not_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  totalVolume?: InputMaybe<Scalars['BigDecimal']['input']>;
  totalVolume_gt?: InputMaybe<Scalars['BigDecimal']['input']>;
  totalVolume_gte?: InputMaybe<Scalars['BigDecimal']['input']>;
  totalVolume_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  totalVolume_lt?: InputMaybe<Scalars['BigDecimal']['input']>;
  totalVolume_lte?: InputMaybe<Scalars['BigDecimal']['input']>;
  totalVolume_not?: InputMaybe<Scalars['BigDecimal']['input']>;
  totalVolume_not_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
};

export enum OptionMarket_OrderBy {
  CallToken = 'callToken',
  CallTokenDecimals = 'callToken__decimals',
  CallTokenId = 'callToken__id',
  CallTokenSymbol = 'callToken__symbol',
  DpFee = 'dpFee',
  Id = 'id',
  OptionsPricing = 'optionsPricing',
  PrimePool = 'primePool',
  PutToken = 'putToken',
  PutTokenDecimals = 'putToken__decimals',
  PutTokenId = 'putToken__id',
  PutTokenSymbol = 'putToken__symbol',
  TokenUriFetcher = 'tokenURIFetcher',
  TotalFees = 'totalFees',
  TotalPremium = 'totalPremium',
  TotalVolume = 'totalVolume'
}

export type Option_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<Option_Filter>>>;
  expiry?: InputMaybe<Scalars['BigInt']['input']>;
  expiry_gt?: InputMaybe<Scalars['BigInt']['input']>;
  expiry_gte?: InputMaybe<Scalars['BigInt']['input']>;
  expiry_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  expiry_lt?: InputMaybe<Scalars['BigInt']['input']>;
  expiry_lte?: InputMaybe<Scalars['BigInt']['input']>;
  expiry_not?: InputMaybe<Scalars['BigInt']['input']>;
  expiry_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  handlers?: InputMaybe<Array<Scalars['String']['input']>>;
  handlers_contains?: InputMaybe<Array<Scalars['String']['input']>>;
  handlers_contains_nocase?: InputMaybe<Array<Scalars['String']['input']>>;
  handlers_not?: InputMaybe<Array<Scalars['String']['input']>>;
  handlers_not_contains?: InputMaybe<Array<Scalars['String']['input']>>;
  handlers_not_contains_nocase?: InputMaybe<Array<Scalars['String']['input']>>;
  hooks?: InputMaybe<Array<Scalars['String']['input']>>;
  hooks_contains?: InputMaybe<Array<Scalars['String']['input']>>;
  hooks_contains_nocase?: InputMaybe<Array<Scalars['String']['input']>>;
  hooks_not?: InputMaybe<Array<Scalars['String']['input']>>;
  hooks_not_contains?: InputMaybe<Array<Scalars['String']['input']>>;
  hooks_not_contains_nocase?: InputMaybe<Array<Scalars['String']['input']>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  initialSize?: InputMaybe<Scalars['BigInt']['input']>;
  initialSize_gt?: InputMaybe<Scalars['BigInt']['input']>;
  initialSize_gte?: InputMaybe<Scalars['BigInt']['input']>;
  initialSize_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  initialSize_lt?: InputMaybe<Scalars['BigInt']['input']>;
  initialSize_lte?: InputMaybe<Scalars['BigInt']['input']>;
  initialSize_not?: InputMaybe<Scalars['BigInt']['input']>;
  initialSize_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  isCall?: InputMaybe<Scalars['Boolean']['input']>;
  isCall_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isCall_not?: InputMaybe<Scalars['Boolean']['input']>;
  isCall_not_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  liquidities?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  liquidities_contains?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  liquidities_contains_nocase?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  liquidities_not?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  liquidities_not_contains?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  liquidities_not_contains_nocase?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  mintOption_?: InputMaybe<MintOption_Filter>;
  optionMarket?: InputMaybe<Scalars['String']['input']>;
  optionMarket_?: InputMaybe<OptionMarket_Filter>;
  optionMarket_contains?: InputMaybe<Scalars['String']['input']>;
  optionMarket_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  optionMarket_ends_with?: InputMaybe<Scalars['String']['input']>;
  optionMarket_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  optionMarket_gt?: InputMaybe<Scalars['String']['input']>;
  optionMarket_gte?: InputMaybe<Scalars['String']['input']>;
  optionMarket_in?: InputMaybe<Array<Scalars['String']['input']>>;
  optionMarket_lt?: InputMaybe<Scalars['String']['input']>;
  optionMarket_lte?: InputMaybe<Scalars['String']['input']>;
  optionMarket_not?: InputMaybe<Scalars['String']['input']>;
  optionMarket_not_contains?: InputMaybe<Scalars['String']['input']>;
  optionMarket_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  optionMarket_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  optionMarket_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  optionMarket_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  optionMarket_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  optionMarket_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  optionMarket_starts_with?: InputMaybe<Scalars['String']['input']>;
  optionMarket_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  or?: InputMaybe<Array<InputMaybe<Option_Filter>>>;
  pools?: InputMaybe<Array<Scalars['String']['input']>>;
  pools_contains?: InputMaybe<Array<Scalars['String']['input']>>;
  pools_contains_nocase?: InputMaybe<Array<Scalars['String']['input']>>;
  pools_not?: InputMaybe<Array<Scalars['String']['input']>>;
  pools_not_contains?: InputMaybe<Array<Scalars['String']['input']>>;
  pools_not_contains_nocase?: InputMaybe<Array<Scalars['String']['input']>>;
  premium?: InputMaybe<Scalars['BigInt']['input']>;
  premium_gt?: InputMaybe<Scalars['BigInt']['input']>;
  premium_gte?: InputMaybe<Scalars['BigInt']['input']>;
  premium_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  premium_lt?: InputMaybe<Scalars['BigInt']['input']>;
  premium_lte?: InputMaybe<Scalars['BigInt']['input']>;
  premium_not?: InputMaybe<Scalars['BigInt']['input']>;
  premium_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  purchasePrice?: InputMaybe<Scalars['BigInt']['input']>;
  purchasePrice_gt?: InputMaybe<Scalars['BigInt']['input']>;
  purchasePrice_gte?: InputMaybe<Scalars['BigInt']['input']>;
  purchasePrice_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  purchasePrice_lt?: InputMaybe<Scalars['BigInt']['input']>;
  purchasePrice_lte?: InputMaybe<Scalars['BigInt']['input']>;
  purchasePrice_not?: InputMaybe<Scalars['BigInt']['input']>;
  purchasePrice_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  size?: InputMaybe<Scalars['BigInt']['input']>;
  size_gt?: InputMaybe<Scalars['BigInt']['input']>;
  size_gte?: InputMaybe<Scalars['BigInt']['input']>;
  size_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  size_lt?: InputMaybe<Scalars['BigInt']['input']>;
  size_lte?: InputMaybe<Scalars['BigInt']['input']>;
  size_not?: InputMaybe<Scalars['BigInt']['input']>;
  size_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  tickLower?: InputMaybe<Scalars['Int']['input']>;
  tickLower_gt?: InputMaybe<Scalars['Int']['input']>;
  tickLower_gte?: InputMaybe<Scalars['Int']['input']>;
  tickLower_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  tickLower_lt?: InputMaybe<Scalars['Int']['input']>;
  tickLower_lte?: InputMaybe<Scalars['Int']['input']>;
  tickLower_not?: InputMaybe<Scalars['Int']['input']>;
  tickLower_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  tickUpper?: InputMaybe<Scalars['Int']['input']>;
  tickUpper_gt?: InputMaybe<Scalars['Int']['input']>;
  tickUpper_gte?: InputMaybe<Scalars['Int']['input']>;
  tickUpper_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  tickUpper_lt?: InputMaybe<Scalars['Int']['input']>;
  tickUpper_lte?: InputMaybe<Scalars['Int']['input']>;
  tickUpper_not?: InputMaybe<Scalars['Int']['input']>;
  tickUpper_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  timestamp?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_gt?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_gte?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  timestamp_lt?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_lte?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_not?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  tokenId?: InputMaybe<Scalars['BigInt']['input']>;
  tokenId_gt?: InputMaybe<Scalars['BigInt']['input']>;
  tokenId_gte?: InputMaybe<Scalars['BigInt']['input']>;
  tokenId_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  tokenId_lt?: InputMaybe<Scalars['BigInt']['input']>;
  tokenId_lte?: InputMaybe<Scalars['BigInt']['input']>;
  tokenId_not?: InputMaybe<Scalars['BigInt']['input']>;
  tokenId_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  user?: InputMaybe<Scalars['String']['input']>;
  user_contains?: InputMaybe<Scalars['String']['input']>;
  user_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  user_ends_with?: InputMaybe<Scalars['String']['input']>;
  user_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  user_gt?: InputMaybe<Scalars['String']['input']>;
  user_gte?: InputMaybe<Scalars['String']['input']>;
  user_in?: InputMaybe<Array<Scalars['String']['input']>>;
  user_lt?: InputMaybe<Scalars['String']['input']>;
  user_lte?: InputMaybe<Scalars['String']['input']>;
  user_not?: InputMaybe<Scalars['String']['input']>;
  user_not_contains?: InputMaybe<Scalars['String']['input']>;
  user_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  user_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  user_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  user_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  user_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  user_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  user_starts_with?: InputMaybe<Scalars['String']['input']>;
  user_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
};

export enum Option_OrderBy {
  Expiry = 'expiry',
  Handlers = 'handlers',
  Hooks = 'hooks',
  Id = 'id',
  InitialSize = 'initialSize',
  IsCall = 'isCall',
  Liquidities = 'liquidities',
  MintOption = 'mintOption',
  OptionMarket = 'optionMarket',
  OptionMarketDpFee = 'optionMarket__dpFee',
  OptionMarketId = 'optionMarket__id',
  OptionMarketOptionsPricing = 'optionMarket__optionsPricing',
  OptionMarketPrimePool = 'optionMarket__primePool',
  OptionMarketTokenUriFetcher = 'optionMarket__tokenURIFetcher',
  OptionMarketTotalFees = 'optionMarket__totalFees',
  OptionMarketTotalPremium = 'optionMarket__totalPremium',
  OptionMarketTotalVolume = 'optionMarket__totalVolume',
  Pools = 'pools',
  Premium = 'premium',
  PurchasePrice = 'purchasePrice',
  Size = 'size',
  TickLower = 'tickLower',
  TickUpper = 'tickUpper',
  Timestamp = 'timestamp',
  TokenId = 'tokenId',
  User = 'user'
}

export type OptionsExercise = {
  __typename?: 'OptionsExercise';
  id: Scalars['ID']['output'];
  option: Option;
  optionMarket: OptionMarket;
  priceAtAction: Scalars['BigInt']['output'];
  profit: Scalars['BigInt']['output'];
  size: Scalars['BigInt']['output'];
  timestamp: Scalars['BigInt']['output'];
  user: Scalars['String']['output'];
};

export type OptionsExercise_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<OptionsExercise_Filter>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  option?: InputMaybe<Scalars['String']['input']>;
  optionMarket?: InputMaybe<Scalars['String']['input']>;
  optionMarket_?: InputMaybe<OptionMarket_Filter>;
  optionMarket_contains?: InputMaybe<Scalars['String']['input']>;
  optionMarket_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  optionMarket_ends_with?: InputMaybe<Scalars['String']['input']>;
  optionMarket_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  optionMarket_gt?: InputMaybe<Scalars['String']['input']>;
  optionMarket_gte?: InputMaybe<Scalars['String']['input']>;
  optionMarket_in?: InputMaybe<Array<Scalars['String']['input']>>;
  optionMarket_lt?: InputMaybe<Scalars['String']['input']>;
  optionMarket_lte?: InputMaybe<Scalars['String']['input']>;
  optionMarket_not?: InputMaybe<Scalars['String']['input']>;
  optionMarket_not_contains?: InputMaybe<Scalars['String']['input']>;
  optionMarket_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  optionMarket_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  optionMarket_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  optionMarket_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  optionMarket_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  optionMarket_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  optionMarket_starts_with?: InputMaybe<Scalars['String']['input']>;
  optionMarket_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  option_?: InputMaybe<Option_Filter>;
  option_contains?: InputMaybe<Scalars['String']['input']>;
  option_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  option_ends_with?: InputMaybe<Scalars['String']['input']>;
  option_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  option_gt?: InputMaybe<Scalars['String']['input']>;
  option_gte?: InputMaybe<Scalars['String']['input']>;
  option_in?: InputMaybe<Array<Scalars['String']['input']>>;
  option_lt?: InputMaybe<Scalars['String']['input']>;
  option_lte?: InputMaybe<Scalars['String']['input']>;
  option_not?: InputMaybe<Scalars['String']['input']>;
  option_not_contains?: InputMaybe<Scalars['String']['input']>;
  option_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  option_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  option_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  option_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  option_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  option_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  option_starts_with?: InputMaybe<Scalars['String']['input']>;
  option_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  or?: InputMaybe<Array<InputMaybe<OptionsExercise_Filter>>>;
  priceAtAction?: InputMaybe<Scalars['BigInt']['input']>;
  priceAtAction_gt?: InputMaybe<Scalars['BigInt']['input']>;
  priceAtAction_gte?: InputMaybe<Scalars['BigInt']['input']>;
  priceAtAction_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  priceAtAction_lt?: InputMaybe<Scalars['BigInt']['input']>;
  priceAtAction_lte?: InputMaybe<Scalars['BigInt']['input']>;
  priceAtAction_not?: InputMaybe<Scalars['BigInt']['input']>;
  priceAtAction_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  profit?: InputMaybe<Scalars['BigInt']['input']>;
  profit_gt?: InputMaybe<Scalars['BigInt']['input']>;
  profit_gte?: InputMaybe<Scalars['BigInt']['input']>;
  profit_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  profit_lt?: InputMaybe<Scalars['BigInt']['input']>;
  profit_lte?: InputMaybe<Scalars['BigInt']['input']>;
  profit_not?: InputMaybe<Scalars['BigInt']['input']>;
  profit_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  size?: InputMaybe<Scalars['BigInt']['input']>;
  size_gt?: InputMaybe<Scalars['BigInt']['input']>;
  size_gte?: InputMaybe<Scalars['BigInt']['input']>;
  size_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  size_lt?: InputMaybe<Scalars['BigInt']['input']>;
  size_lte?: InputMaybe<Scalars['BigInt']['input']>;
  size_not?: InputMaybe<Scalars['BigInt']['input']>;
  size_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  timestamp?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_gt?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_gte?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  timestamp_lt?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_lte?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_not?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  user?: InputMaybe<Scalars['String']['input']>;
  user_contains?: InputMaybe<Scalars['String']['input']>;
  user_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  user_ends_with?: InputMaybe<Scalars['String']['input']>;
  user_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  user_gt?: InputMaybe<Scalars['String']['input']>;
  user_gte?: InputMaybe<Scalars['String']['input']>;
  user_in?: InputMaybe<Array<Scalars['String']['input']>>;
  user_lt?: InputMaybe<Scalars['String']['input']>;
  user_lte?: InputMaybe<Scalars['String']['input']>;
  user_not?: InputMaybe<Scalars['String']['input']>;
  user_not_contains?: InputMaybe<Scalars['String']['input']>;
  user_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  user_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  user_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  user_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  user_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  user_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  user_starts_with?: InputMaybe<Scalars['String']['input']>;
  user_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
};

export enum OptionsExercise_OrderBy {
  Id = 'id',
  Option = 'option',
  OptionMarket = 'optionMarket',
  OptionMarketDpFee = 'optionMarket__dpFee',
  OptionMarketId = 'optionMarket__id',
  OptionMarketOptionsPricing = 'optionMarket__optionsPricing',
  OptionMarketPrimePool = 'optionMarket__primePool',
  OptionMarketTokenUriFetcher = 'optionMarket__tokenURIFetcher',
  OptionMarketTotalFees = 'optionMarket__totalFees',
  OptionMarketTotalPremium = 'optionMarket__totalPremium',
  OptionMarketTotalVolume = 'optionMarket__totalVolume',
  OptionExpiry = 'option__expiry',
  OptionId = 'option__id',
  OptionInitialSize = 'option__initialSize',
  OptionIsCall = 'option__isCall',
  OptionPremium = 'option__premium',
  OptionPurchasePrice = 'option__purchasePrice',
  OptionSize = 'option__size',
  OptionTickLower = 'option__tickLower',
  OptionTickUpper = 'option__tickUpper',
  OptionTimestamp = 'option__timestamp',
  OptionTokenId = 'option__tokenId',
  OptionUser = 'option__user',
  PriceAtAction = 'priceAtAction',
  Profit = 'profit',
  Size = 'size',
  Timestamp = 'timestamp',
  User = 'user'
}

export type OptionsMint = {
  __typename?: 'OptionsMint';
  id: Scalars['ID']['output'];
  option: Option;
  optionMarket: OptionMarket;
  priceAtAction: Scalars['BigInt']['output'];
  size: Scalars['BigInt']['output'];
  timestamp: Scalars['BigInt']['output'];
  user: Scalars['String']['output'];
};

export type OptionsMint_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<OptionsMint_Filter>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  option?: InputMaybe<Scalars['String']['input']>;
  optionMarket?: InputMaybe<Scalars['String']['input']>;
  optionMarket_?: InputMaybe<OptionMarket_Filter>;
  optionMarket_contains?: InputMaybe<Scalars['String']['input']>;
  optionMarket_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  optionMarket_ends_with?: InputMaybe<Scalars['String']['input']>;
  optionMarket_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  optionMarket_gt?: InputMaybe<Scalars['String']['input']>;
  optionMarket_gte?: InputMaybe<Scalars['String']['input']>;
  optionMarket_in?: InputMaybe<Array<Scalars['String']['input']>>;
  optionMarket_lt?: InputMaybe<Scalars['String']['input']>;
  optionMarket_lte?: InputMaybe<Scalars['String']['input']>;
  optionMarket_not?: InputMaybe<Scalars['String']['input']>;
  optionMarket_not_contains?: InputMaybe<Scalars['String']['input']>;
  optionMarket_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  optionMarket_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  optionMarket_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  optionMarket_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  optionMarket_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  optionMarket_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  optionMarket_starts_with?: InputMaybe<Scalars['String']['input']>;
  optionMarket_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  option_?: InputMaybe<Option_Filter>;
  option_contains?: InputMaybe<Scalars['String']['input']>;
  option_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  option_ends_with?: InputMaybe<Scalars['String']['input']>;
  option_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  option_gt?: InputMaybe<Scalars['String']['input']>;
  option_gte?: InputMaybe<Scalars['String']['input']>;
  option_in?: InputMaybe<Array<Scalars['String']['input']>>;
  option_lt?: InputMaybe<Scalars['String']['input']>;
  option_lte?: InputMaybe<Scalars['String']['input']>;
  option_not?: InputMaybe<Scalars['String']['input']>;
  option_not_contains?: InputMaybe<Scalars['String']['input']>;
  option_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  option_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  option_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  option_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  option_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  option_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  option_starts_with?: InputMaybe<Scalars['String']['input']>;
  option_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  or?: InputMaybe<Array<InputMaybe<OptionsMint_Filter>>>;
  priceAtAction?: InputMaybe<Scalars['BigInt']['input']>;
  priceAtAction_gt?: InputMaybe<Scalars['BigInt']['input']>;
  priceAtAction_gte?: InputMaybe<Scalars['BigInt']['input']>;
  priceAtAction_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  priceAtAction_lt?: InputMaybe<Scalars['BigInt']['input']>;
  priceAtAction_lte?: InputMaybe<Scalars['BigInt']['input']>;
  priceAtAction_not?: InputMaybe<Scalars['BigInt']['input']>;
  priceAtAction_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  size?: InputMaybe<Scalars['BigInt']['input']>;
  size_gt?: InputMaybe<Scalars['BigInt']['input']>;
  size_gte?: InputMaybe<Scalars['BigInt']['input']>;
  size_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  size_lt?: InputMaybe<Scalars['BigInt']['input']>;
  size_lte?: InputMaybe<Scalars['BigInt']['input']>;
  size_not?: InputMaybe<Scalars['BigInt']['input']>;
  size_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  timestamp?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_gt?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_gte?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  timestamp_lt?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_lte?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_not?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  user?: InputMaybe<Scalars['String']['input']>;
  user_contains?: InputMaybe<Scalars['String']['input']>;
  user_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  user_ends_with?: InputMaybe<Scalars['String']['input']>;
  user_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  user_gt?: InputMaybe<Scalars['String']['input']>;
  user_gte?: InputMaybe<Scalars['String']['input']>;
  user_in?: InputMaybe<Array<Scalars['String']['input']>>;
  user_lt?: InputMaybe<Scalars['String']['input']>;
  user_lte?: InputMaybe<Scalars['String']['input']>;
  user_not?: InputMaybe<Scalars['String']['input']>;
  user_not_contains?: InputMaybe<Scalars['String']['input']>;
  user_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  user_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  user_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  user_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  user_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  user_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  user_starts_with?: InputMaybe<Scalars['String']['input']>;
  user_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
};

export enum OptionsMint_OrderBy {
  Id = 'id',
  Option = 'option',
  OptionMarket = 'optionMarket',
  OptionMarketDpFee = 'optionMarket__dpFee',
  OptionMarketId = 'optionMarket__id',
  OptionMarketOptionsPricing = 'optionMarket__optionsPricing',
  OptionMarketPrimePool = 'optionMarket__primePool',
  OptionMarketTokenUriFetcher = 'optionMarket__tokenURIFetcher',
  OptionMarketTotalFees = 'optionMarket__totalFees',
  OptionMarketTotalPremium = 'optionMarket__totalPremium',
  OptionMarketTotalVolume = 'optionMarket__totalVolume',
  OptionExpiry = 'option__expiry',
  OptionId = 'option__id',
  OptionInitialSize = 'option__initialSize',
  OptionIsCall = 'option__isCall',
  OptionPremium = 'option__premium',
  OptionPurchasePrice = 'option__purchasePrice',
  OptionSize = 'option__size',
  OptionTickLower = 'option__tickLower',
  OptionTickUpper = 'option__tickUpper',
  OptionTimestamp = 'option__timestamp',
  OptionTokenId = 'option__tokenId',
  OptionUser = 'option__user',
  PriceAtAction = 'priceAtAction',
  Size = 'size',
  Timestamp = 'timestamp',
  User = 'user'
}

export type OptionsSettle = {
  __typename?: 'OptionsSettle';
  id: Scalars['ID']['output'];
  option: Option;
  optionMarket: OptionMarket;
  priceAtAction: Scalars['BigInt']['output'];
  timestamp: Scalars['BigInt']['output'];
  user: Scalars['String']['output'];
};

export type OptionsSettle_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<OptionsSettle_Filter>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  option?: InputMaybe<Scalars['String']['input']>;
  optionMarket?: InputMaybe<Scalars['String']['input']>;
  optionMarket_?: InputMaybe<OptionMarket_Filter>;
  optionMarket_contains?: InputMaybe<Scalars['String']['input']>;
  optionMarket_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  optionMarket_ends_with?: InputMaybe<Scalars['String']['input']>;
  optionMarket_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  optionMarket_gt?: InputMaybe<Scalars['String']['input']>;
  optionMarket_gte?: InputMaybe<Scalars['String']['input']>;
  optionMarket_in?: InputMaybe<Array<Scalars['String']['input']>>;
  optionMarket_lt?: InputMaybe<Scalars['String']['input']>;
  optionMarket_lte?: InputMaybe<Scalars['String']['input']>;
  optionMarket_not?: InputMaybe<Scalars['String']['input']>;
  optionMarket_not_contains?: InputMaybe<Scalars['String']['input']>;
  optionMarket_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  optionMarket_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  optionMarket_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  optionMarket_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  optionMarket_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  optionMarket_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  optionMarket_starts_with?: InputMaybe<Scalars['String']['input']>;
  optionMarket_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  option_?: InputMaybe<Option_Filter>;
  option_contains?: InputMaybe<Scalars['String']['input']>;
  option_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  option_ends_with?: InputMaybe<Scalars['String']['input']>;
  option_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  option_gt?: InputMaybe<Scalars['String']['input']>;
  option_gte?: InputMaybe<Scalars['String']['input']>;
  option_in?: InputMaybe<Array<Scalars['String']['input']>>;
  option_lt?: InputMaybe<Scalars['String']['input']>;
  option_lte?: InputMaybe<Scalars['String']['input']>;
  option_not?: InputMaybe<Scalars['String']['input']>;
  option_not_contains?: InputMaybe<Scalars['String']['input']>;
  option_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  option_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  option_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  option_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  option_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  option_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  option_starts_with?: InputMaybe<Scalars['String']['input']>;
  option_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  or?: InputMaybe<Array<InputMaybe<OptionsSettle_Filter>>>;
  priceAtAction?: InputMaybe<Scalars['BigInt']['input']>;
  priceAtAction_gt?: InputMaybe<Scalars['BigInt']['input']>;
  priceAtAction_gte?: InputMaybe<Scalars['BigInt']['input']>;
  priceAtAction_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  priceAtAction_lt?: InputMaybe<Scalars['BigInt']['input']>;
  priceAtAction_lte?: InputMaybe<Scalars['BigInt']['input']>;
  priceAtAction_not?: InputMaybe<Scalars['BigInt']['input']>;
  priceAtAction_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  timestamp?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_gt?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_gte?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  timestamp_lt?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_lte?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_not?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  user?: InputMaybe<Scalars['String']['input']>;
  user_contains?: InputMaybe<Scalars['String']['input']>;
  user_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  user_ends_with?: InputMaybe<Scalars['String']['input']>;
  user_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  user_gt?: InputMaybe<Scalars['String']['input']>;
  user_gte?: InputMaybe<Scalars['String']['input']>;
  user_in?: InputMaybe<Array<Scalars['String']['input']>>;
  user_lt?: InputMaybe<Scalars['String']['input']>;
  user_lte?: InputMaybe<Scalars['String']['input']>;
  user_not?: InputMaybe<Scalars['String']['input']>;
  user_not_contains?: InputMaybe<Scalars['String']['input']>;
  user_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  user_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  user_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  user_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  user_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  user_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  user_starts_with?: InputMaybe<Scalars['String']['input']>;
  user_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
};

export enum OptionsSettle_OrderBy {
  Id = 'id',
  Option = 'option',
  OptionMarket = 'optionMarket',
  OptionMarketDpFee = 'optionMarket__dpFee',
  OptionMarketId = 'optionMarket__id',
  OptionMarketOptionsPricing = 'optionMarket__optionsPricing',
  OptionMarketPrimePool = 'optionMarket__primePool',
  OptionMarketTokenUriFetcher = 'optionMarket__tokenURIFetcher',
  OptionMarketTotalFees = 'optionMarket__totalFees',
  OptionMarketTotalPremium = 'optionMarket__totalPremium',
  OptionMarketTotalVolume = 'optionMarket__totalVolume',
  OptionExpiry = 'option__expiry',
  OptionId = 'option__id',
  OptionInitialSize = 'option__initialSize',
  OptionIsCall = 'option__isCall',
  OptionPremium = 'option__premium',
  OptionPurchasePrice = 'option__purchasePrice',
  OptionSize = 'option__size',
  OptionTickLower = 'option__tickLower',
  OptionTickUpper = 'option__tickUpper',
  OptionTimestamp = 'option__timestamp',
  OptionTokenId = 'option__tokenId',
  OptionUser = 'option__user',
  PriceAtAction = 'priceAtAction',
  Timestamp = 'timestamp',
  User = 'user'
}

export type OptionsTransfer = {
  __typename?: 'OptionsTransfer';
  from: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  option: Option;
  optionMarket: OptionMarket;
  size: Scalars['BigInt']['output'];
  timestamp: Scalars['BigInt']['output'];
  to: Scalars['String']['output'];
};

export type OptionsTransfer_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<OptionsTransfer_Filter>>>;
  from?: InputMaybe<Scalars['String']['input']>;
  from_contains?: InputMaybe<Scalars['String']['input']>;
  from_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  from_ends_with?: InputMaybe<Scalars['String']['input']>;
  from_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  from_gt?: InputMaybe<Scalars['String']['input']>;
  from_gte?: InputMaybe<Scalars['String']['input']>;
  from_in?: InputMaybe<Array<Scalars['String']['input']>>;
  from_lt?: InputMaybe<Scalars['String']['input']>;
  from_lte?: InputMaybe<Scalars['String']['input']>;
  from_not?: InputMaybe<Scalars['String']['input']>;
  from_not_contains?: InputMaybe<Scalars['String']['input']>;
  from_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  from_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  from_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  from_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  from_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  from_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  from_starts_with?: InputMaybe<Scalars['String']['input']>;
  from_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  option?: InputMaybe<Scalars['String']['input']>;
  optionMarket?: InputMaybe<Scalars['String']['input']>;
  optionMarket_?: InputMaybe<OptionMarket_Filter>;
  optionMarket_contains?: InputMaybe<Scalars['String']['input']>;
  optionMarket_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  optionMarket_ends_with?: InputMaybe<Scalars['String']['input']>;
  optionMarket_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  optionMarket_gt?: InputMaybe<Scalars['String']['input']>;
  optionMarket_gte?: InputMaybe<Scalars['String']['input']>;
  optionMarket_in?: InputMaybe<Array<Scalars['String']['input']>>;
  optionMarket_lt?: InputMaybe<Scalars['String']['input']>;
  optionMarket_lte?: InputMaybe<Scalars['String']['input']>;
  optionMarket_not?: InputMaybe<Scalars['String']['input']>;
  optionMarket_not_contains?: InputMaybe<Scalars['String']['input']>;
  optionMarket_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  optionMarket_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  optionMarket_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  optionMarket_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  optionMarket_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  optionMarket_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  optionMarket_starts_with?: InputMaybe<Scalars['String']['input']>;
  optionMarket_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  option_?: InputMaybe<Option_Filter>;
  option_contains?: InputMaybe<Scalars['String']['input']>;
  option_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  option_ends_with?: InputMaybe<Scalars['String']['input']>;
  option_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  option_gt?: InputMaybe<Scalars['String']['input']>;
  option_gte?: InputMaybe<Scalars['String']['input']>;
  option_in?: InputMaybe<Array<Scalars['String']['input']>>;
  option_lt?: InputMaybe<Scalars['String']['input']>;
  option_lte?: InputMaybe<Scalars['String']['input']>;
  option_not?: InputMaybe<Scalars['String']['input']>;
  option_not_contains?: InputMaybe<Scalars['String']['input']>;
  option_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  option_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  option_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  option_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  option_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  option_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  option_starts_with?: InputMaybe<Scalars['String']['input']>;
  option_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  or?: InputMaybe<Array<InputMaybe<OptionsTransfer_Filter>>>;
  size?: InputMaybe<Scalars['BigInt']['input']>;
  size_gt?: InputMaybe<Scalars['BigInt']['input']>;
  size_gte?: InputMaybe<Scalars['BigInt']['input']>;
  size_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  size_lt?: InputMaybe<Scalars['BigInt']['input']>;
  size_lte?: InputMaybe<Scalars['BigInt']['input']>;
  size_not?: InputMaybe<Scalars['BigInt']['input']>;
  size_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  timestamp?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_gt?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_gte?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  timestamp_lt?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_lte?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_not?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  to?: InputMaybe<Scalars['String']['input']>;
  to_contains?: InputMaybe<Scalars['String']['input']>;
  to_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  to_ends_with?: InputMaybe<Scalars['String']['input']>;
  to_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  to_gt?: InputMaybe<Scalars['String']['input']>;
  to_gte?: InputMaybe<Scalars['String']['input']>;
  to_in?: InputMaybe<Array<Scalars['String']['input']>>;
  to_lt?: InputMaybe<Scalars['String']['input']>;
  to_lte?: InputMaybe<Scalars['String']['input']>;
  to_not?: InputMaybe<Scalars['String']['input']>;
  to_not_contains?: InputMaybe<Scalars['String']['input']>;
  to_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  to_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  to_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  to_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  to_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  to_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  to_starts_with?: InputMaybe<Scalars['String']['input']>;
  to_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
};

export enum OptionsTransfer_OrderBy {
  From = 'from',
  Id = 'id',
  Option = 'option',
  OptionMarket = 'optionMarket',
  OptionMarketDpFee = 'optionMarket__dpFee',
  OptionMarketId = 'optionMarket__id',
  OptionMarketOptionsPricing = 'optionMarket__optionsPricing',
  OptionMarketPrimePool = 'optionMarket__primePool',
  OptionMarketTokenUriFetcher = 'optionMarket__tokenURIFetcher',
  OptionMarketTotalFees = 'optionMarket__totalFees',
  OptionMarketTotalPremium = 'optionMarket__totalPremium',
  OptionMarketTotalVolume = 'optionMarket__totalVolume',
  OptionExpiry = 'option__expiry',
  OptionId = 'option__id',
  OptionInitialSize = 'option__initialSize',
  OptionIsCall = 'option__isCall',
  OptionPremium = 'option__premium',
  OptionPurchasePrice = 'option__purchasePrice',
  OptionSize = 'option__size',
  OptionTickLower = 'option__tickLower',
  OptionTickUpper = 'option__tickUpper',
  OptionTimestamp = 'option__timestamp',
  OptionTokenId = 'option__tokenId',
  OptionUser = 'option__user',
  Size = 'size',
  Timestamp = 'timestamp',
  To = 'to'
}

/** Defines the order direction, either ascending or descending */
export enum OrderDirection {
  Asc = 'asc',
  Desc = 'desc'
}

export type Query = {
  __typename?: 'Query';
  /** Access to subgraph metadata */
  _meta?: Maybe<_Meta_>;
  dailyDonation?: Maybe<DailyDonation>;
  dailyDonations: Array<DailyDonation>;
  dailyFeeCompound?: Maybe<DailyFeeCompound>;
  dailyFeeCompounds: Array<DailyFeeCompound>;
  donation?: Maybe<Donation>;
  donations: Array<Donation>;
  feeCompound?: Maybe<FeeCompound>;
  feeCompounds: Array<FeeCompound>;
  lpposition?: Maybe<LpPosition>;
  lppositionBurn?: Maybe<LpPositionBurn>;
  lppositionBurns: Array<LpPositionBurn>;
  lppositionMint?: Maybe<LpPositionMint>;
  lppositionMints: Array<LpPositionMint>;
  lppositionTransfer?: Maybe<LpPositionTransfer>;
  lppositionTransfers: Array<LpPositionTransfer>;
  lppositions: Array<LpPosition>;
  mintOption?: Maybe<MintOption>;
  mintOptions: Array<MintOption>;
  mintPosition?: Maybe<MintPosition>;
  mintPositions: Array<MintPosition>;
  option?: Maybe<Option>;
  optionMarket?: Maybe<OptionMarket>;
  optionMarketDailyStat?: Maybe<OptionMarketDailyStat>;
  optionMarketDailyStats: Array<OptionMarketDailyStat>;
  optionMarkets: Array<OptionMarket>;
  options: Array<Option>;
  optionsExercise?: Maybe<OptionsExercise>;
  optionsExercises: Array<OptionsExercise>;
  optionsMint?: Maybe<OptionsMint>;
  optionsMints: Array<OptionsMint>;
  optionsSettle?: Maybe<OptionsSettle>;
  optionsSettles: Array<OptionsSettle>;
  optionsTransfer?: Maybe<OptionsTransfer>;
  optionsTransfers: Array<OptionsTransfer>;
  strike?: Maybe<Strike>;
  strikes: Array<Strike>;
  swapReceivedLog?: Maybe<SwapReceivedLog>;
  swapReceivedLogs: Array<SwapReceivedLog>;
  token?: Maybe<Token>;
  tokens: Array<Token>;
};


export type Query_MetaArgs = {
  block?: InputMaybe<Block_Height>;
};


export type QueryDailyDonationArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryDailyDonationsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<DailyDonation_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<DailyDonation_Filter>;
};


export type QueryDailyFeeCompoundArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryDailyFeeCompoundsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<DailyFeeCompound_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<DailyFeeCompound_Filter>;
};


export type QueryDonationArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryDonationsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Donation_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<Donation_Filter>;
};


export type QueryFeeCompoundArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryFeeCompoundsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<FeeCompound_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<FeeCompound_Filter>;
};


export type QueryLppositionArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryLppositionBurnArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryLppositionBurnsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<LpPositionBurn_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<LpPositionBurn_Filter>;
};


export type QueryLppositionMintArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryLppositionMintsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<LpPositionMint_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<LpPositionMint_Filter>;
};


export type QueryLppositionTransferArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryLppositionTransfersArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<LpPositionTransfer_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<LpPositionTransfer_Filter>;
};


export type QueryLppositionsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<LpPosition_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<LpPosition_Filter>;
};


export type QueryMintOptionArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryMintOptionsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<MintOption_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<MintOption_Filter>;
};


export type QueryMintPositionArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryMintPositionsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<MintPosition_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<MintPosition_Filter>;
};


export type QueryOptionArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryOptionMarketArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryOptionMarketDailyStatArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryOptionMarketDailyStatsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OptionMarketDailyStat_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<OptionMarketDailyStat_Filter>;
};


export type QueryOptionMarketsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OptionMarket_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<OptionMarket_Filter>;
};


export type QueryOptionsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Option_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<Option_Filter>;
};


export type QueryOptionsExerciseArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryOptionsExercisesArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OptionsExercise_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<OptionsExercise_Filter>;
};


export type QueryOptionsMintArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryOptionsMintsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OptionsMint_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<OptionsMint_Filter>;
};


export type QueryOptionsSettleArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryOptionsSettlesArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OptionsSettle_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<OptionsSettle_Filter>;
};


export type QueryOptionsTransferArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryOptionsTransfersArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OptionsTransfer_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<OptionsTransfer_Filter>;
};


export type QueryStrikeArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryStrikesArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Strike_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<Strike_Filter>;
};


export type QuerySwapReceivedLogArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QuerySwapReceivedLogsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SwapReceivedLog_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<SwapReceivedLog_Filter>;
};


export type QueryTokenArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryTokensArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Token_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<Token_Filter>;
};

export type Strike = {
  __typename?: 'Strike';
  currentDayDonation: DailyDonation;
  currentDayFeeCompound: DailyFeeCompound;
  feeGrowthInside0LastX128: Scalars['BigInt']['output'];
  feeGrowthInside1LastX128: Scalars['BigInt']['output'];
  handler: Scalars['String']['output'];
  hook: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  pool: Scalars['String']['output'];
  reservedLiquidity: Scalars['BigInt']['output'];
  tickLower: Scalars['Int']['output'];
  tickUpper: Scalars['Int']['output'];
  token0: Token;
  token1: Token;
  totalLiquidity: Scalars['BigInt']['output'];
  totalShares: Scalars['BigInt']['output'];
  usedLiquidity: Scalars['BigInt']['output'];
};

export type Strike_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<Strike_Filter>>>;
  currentDayDonation?: InputMaybe<Scalars['String']['input']>;
  currentDayDonation_?: InputMaybe<DailyDonation_Filter>;
  currentDayDonation_contains?: InputMaybe<Scalars['String']['input']>;
  currentDayDonation_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  currentDayDonation_ends_with?: InputMaybe<Scalars['String']['input']>;
  currentDayDonation_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  currentDayDonation_gt?: InputMaybe<Scalars['String']['input']>;
  currentDayDonation_gte?: InputMaybe<Scalars['String']['input']>;
  currentDayDonation_in?: InputMaybe<Array<Scalars['String']['input']>>;
  currentDayDonation_lt?: InputMaybe<Scalars['String']['input']>;
  currentDayDonation_lte?: InputMaybe<Scalars['String']['input']>;
  currentDayDonation_not?: InputMaybe<Scalars['String']['input']>;
  currentDayDonation_not_contains?: InputMaybe<Scalars['String']['input']>;
  currentDayDonation_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  currentDayDonation_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  currentDayDonation_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  currentDayDonation_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  currentDayDonation_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  currentDayDonation_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  currentDayDonation_starts_with?: InputMaybe<Scalars['String']['input']>;
  currentDayDonation_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  currentDayFeeCompound?: InputMaybe<Scalars['String']['input']>;
  currentDayFeeCompound_?: InputMaybe<DailyFeeCompound_Filter>;
  currentDayFeeCompound_contains?: InputMaybe<Scalars['String']['input']>;
  currentDayFeeCompound_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  currentDayFeeCompound_ends_with?: InputMaybe<Scalars['String']['input']>;
  currentDayFeeCompound_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  currentDayFeeCompound_gt?: InputMaybe<Scalars['String']['input']>;
  currentDayFeeCompound_gte?: InputMaybe<Scalars['String']['input']>;
  currentDayFeeCompound_in?: InputMaybe<Array<Scalars['String']['input']>>;
  currentDayFeeCompound_lt?: InputMaybe<Scalars['String']['input']>;
  currentDayFeeCompound_lte?: InputMaybe<Scalars['String']['input']>;
  currentDayFeeCompound_not?: InputMaybe<Scalars['String']['input']>;
  currentDayFeeCompound_not_contains?: InputMaybe<Scalars['String']['input']>;
  currentDayFeeCompound_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  currentDayFeeCompound_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  currentDayFeeCompound_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  currentDayFeeCompound_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  currentDayFeeCompound_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  currentDayFeeCompound_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  currentDayFeeCompound_starts_with?: InputMaybe<Scalars['String']['input']>;
  currentDayFeeCompound_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  feeGrowthInside0LastX128?: InputMaybe<Scalars['BigInt']['input']>;
  feeGrowthInside0LastX128_gt?: InputMaybe<Scalars['BigInt']['input']>;
  feeGrowthInside0LastX128_gte?: InputMaybe<Scalars['BigInt']['input']>;
  feeGrowthInside0LastX128_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  feeGrowthInside0LastX128_lt?: InputMaybe<Scalars['BigInt']['input']>;
  feeGrowthInside0LastX128_lte?: InputMaybe<Scalars['BigInt']['input']>;
  feeGrowthInside0LastX128_not?: InputMaybe<Scalars['BigInt']['input']>;
  feeGrowthInside0LastX128_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  feeGrowthInside1LastX128?: InputMaybe<Scalars['BigInt']['input']>;
  feeGrowthInside1LastX128_gt?: InputMaybe<Scalars['BigInt']['input']>;
  feeGrowthInside1LastX128_gte?: InputMaybe<Scalars['BigInt']['input']>;
  feeGrowthInside1LastX128_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  feeGrowthInside1LastX128_lt?: InputMaybe<Scalars['BigInt']['input']>;
  feeGrowthInside1LastX128_lte?: InputMaybe<Scalars['BigInt']['input']>;
  feeGrowthInside1LastX128_not?: InputMaybe<Scalars['BigInt']['input']>;
  feeGrowthInside1LastX128_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  handler?: InputMaybe<Scalars['String']['input']>;
  handler_contains?: InputMaybe<Scalars['String']['input']>;
  handler_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  handler_ends_with?: InputMaybe<Scalars['String']['input']>;
  handler_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  handler_gt?: InputMaybe<Scalars['String']['input']>;
  handler_gte?: InputMaybe<Scalars['String']['input']>;
  handler_in?: InputMaybe<Array<Scalars['String']['input']>>;
  handler_lt?: InputMaybe<Scalars['String']['input']>;
  handler_lte?: InputMaybe<Scalars['String']['input']>;
  handler_not?: InputMaybe<Scalars['String']['input']>;
  handler_not_contains?: InputMaybe<Scalars['String']['input']>;
  handler_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  handler_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  handler_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  handler_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  handler_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  handler_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  handler_starts_with?: InputMaybe<Scalars['String']['input']>;
  handler_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  hook?: InputMaybe<Scalars['String']['input']>;
  hook_contains?: InputMaybe<Scalars['String']['input']>;
  hook_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  hook_ends_with?: InputMaybe<Scalars['String']['input']>;
  hook_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  hook_gt?: InputMaybe<Scalars['String']['input']>;
  hook_gte?: InputMaybe<Scalars['String']['input']>;
  hook_in?: InputMaybe<Array<Scalars['String']['input']>>;
  hook_lt?: InputMaybe<Scalars['String']['input']>;
  hook_lte?: InputMaybe<Scalars['String']['input']>;
  hook_not?: InputMaybe<Scalars['String']['input']>;
  hook_not_contains?: InputMaybe<Scalars['String']['input']>;
  hook_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  hook_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  hook_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  hook_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  hook_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  hook_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  hook_starts_with?: InputMaybe<Scalars['String']['input']>;
  hook_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  or?: InputMaybe<Array<InputMaybe<Strike_Filter>>>;
  pool?: InputMaybe<Scalars['String']['input']>;
  pool_contains?: InputMaybe<Scalars['String']['input']>;
  pool_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  pool_ends_with?: InputMaybe<Scalars['String']['input']>;
  pool_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  pool_gt?: InputMaybe<Scalars['String']['input']>;
  pool_gte?: InputMaybe<Scalars['String']['input']>;
  pool_in?: InputMaybe<Array<Scalars['String']['input']>>;
  pool_lt?: InputMaybe<Scalars['String']['input']>;
  pool_lte?: InputMaybe<Scalars['String']['input']>;
  pool_not?: InputMaybe<Scalars['String']['input']>;
  pool_not_contains?: InputMaybe<Scalars['String']['input']>;
  pool_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  pool_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  pool_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  pool_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  pool_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  pool_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  pool_starts_with?: InputMaybe<Scalars['String']['input']>;
  pool_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  reservedLiquidity?: InputMaybe<Scalars['BigInt']['input']>;
  reservedLiquidity_gt?: InputMaybe<Scalars['BigInt']['input']>;
  reservedLiquidity_gte?: InputMaybe<Scalars['BigInt']['input']>;
  reservedLiquidity_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  reservedLiquidity_lt?: InputMaybe<Scalars['BigInt']['input']>;
  reservedLiquidity_lte?: InputMaybe<Scalars['BigInt']['input']>;
  reservedLiquidity_not?: InputMaybe<Scalars['BigInt']['input']>;
  reservedLiquidity_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  tickLower?: InputMaybe<Scalars['Int']['input']>;
  tickLower_gt?: InputMaybe<Scalars['Int']['input']>;
  tickLower_gte?: InputMaybe<Scalars['Int']['input']>;
  tickLower_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  tickLower_lt?: InputMaybe<Scalars['Int']['input']>;
  tickLower_lte?: InputMaybe<Scalars['Int']['input']>;
  tickLower_not?: InputMaybe<Scalars['Int']['input']>;
  tickLower_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  tickUpper?: InputMaybe<Scalars['Int']['input']>;
  tickUpper_gt?: InputMaybe<Scalars['Int']['input']>;
  tickUpper_gte?: InputMaybe<Scalars['Int']['input']>;
  tickUpper_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  tickUpper_lt?: InputMaybe<Scalars['Int']['input']>;
  tickUpper_lte?: InputMaybe<Scalars['Int']['input']>;
  tickUpper_not?: InputMaybe<Scalars['Int']['input']>;
  tickUpper_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  token0?: InputMaybe<Scalars['String']['input']>;
  token0_?: InputMaybe<Token_Filter>;
  token0_contains?: InputMaybe<Scalars['String']['input']>;
  token0_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  token0_ends_with?: InputMaybe<Scalars['String']['input']>;
  token0_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  token0_gt?: InputMaybe<Scalars['String']['input']>;
  token0_gte?: InputMaybe<Scalars['String']['input']>;
  token0_in?: InputMaybe<Array<Scalars['String']['input']>>;
  token0_lt?: InputMaybe<Scalars['String']['input']>;
  token0_lte?: InputMaybe<Scalars['String']['input']>;
  token0_not?: InputMaybe<Scalars['String']['input']>;
  token0_not_contains?: InputMaybe<Scalars['String']['input']>;
  token0_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  token0_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  token0_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  token0_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  token0_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  token0_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  token0_starts_with?: InputMaybe<Scalars['String']['input']>;
  token0_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  token1?: InputMaybe<Scalars['String']['input']>;
  token1_?: InputMaybe<Token_Filter>;
  token1_contains?: InputMaybe<Scalars['String']['input']>;
  token1_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  token1_ends_with?: InputMaybe<Scalars['String']['input']>;
  token1_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  token1_gt?: InputMaybe<Scalars['String']['input']>;
  token1_gte?: InputMaybe<Scalars['String']['input']>;
  token1_in?: InputMaybe<Array<Scalars['String']['input']>>;
  token1_lt?: InputMaybe<Scalars['String']['input']>;
  token1_lte?: InputMaybe<Scalars['String']['input']>;
  token1_not?: InputMaybe<Scalars['String']['input']>;
  token1_not_contains?: InputMaybe<Scalars['String']['input']>;
  token1_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  token1_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  token1_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  token1_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  token1_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  token1_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  token1_starts_with?: InputMaybe<Scalars['String']['input']>;
  token1_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  totalLiquidity?: InputMaybe<Scalars['BigInt']['input']>;
  totalLiquidity_gt?: InputMaybe<Scalars['BigInt']['input']>;
  totalLiquidity_gte?: InputMaybe<Scalars['BigInt']['input']>;
  totalLiquidity_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  totalLiquidity_lt?: InputMaybe<Scalars['BigInt']['input']>;
  totalLiquidity_lte?: InputMaybe<Scalars['BigInt']['input']>;
  totalLiquidity_not?: InputMaybe<Scalars['BigInt']['input']>;
  totalLiquidity_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  totalShares?: InputMaybe<Scalars['BigInt']['input']>;
  totalShares_gt?: InputMaybe<Scalars['BigInt']['input']>;
  totalShares_gte?: InputMaybe<Scalars['BigInt']['input']>;
  totalShares_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  totalShares_lt?: InputMaybe<Scalars['BigInt']['input']>;
  totalShares_lte?: InputMaybe<Scalars['BigInt']['input']>;
  totalShares_not?: InputMaybe<Scalars['BigInt']['input']>;
  totalShares_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  usedLiquidity?: InputMaybe<Scalars['BigInt']['input']>;
  usedLiquidity_gt?: InputMaybe<Scalars['BigInt']['input']>;
  usedLiquidity_gte?: InputMaybe<Scalars['BigInt']['input']>;
  usedLiquidity_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  usedLiquidity_lt?: InputMaybe<Scalars['BigInt']['input']>;
  usedLiquidity_lte?: InputMaybe<Scalars['BigInt']['input']>;
  usedLiquidity_not?: InputMaybe<Scalars['BigInt']['input']>;
  usedLiquidity_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
};

export enum Strike_OrderBy {
  CurrentDayDonation = 'currentDayDonation',
  CurrentDayDonationDonation = 'currentDayDonation__donation',
  CurrentDayDonationId = 'currentDayDonation__id',
  CurrentDayDonationSqrtPriceX96 = 'currentDayDonation__sqrtPriceX96',
  CurrentDayDonationStart = 'currentDayDonation__start',
  CurrentDayFeeCompound = 'currentDayFeeCompound',
  CurrentDayFeeCompoundCompound = 'currentDayFeeCompound__compound',
  CurrentDayFeeCompoundId = 'currentDayFeeCompound__id',
  CurrentDayFeeCompoundSqrtPriceX96 = 'currentDayFeeCompound__sqrtPriceX96',
  CurrentDayFeeCompoundStart = 'currentDayFeeCompound__start',
  FeeGrowthInside0LastX128 = 'feeGrowthInside0LastX128',
  FeeGrowthInside1LastX128 = 'feeGrowthInside1LastX128',
  Handler = 'handler',
  Hook = 'hook',
  Id = 'id',
  Pool = 'pool',
  ReservedLiquidity = 'reservedLiquidity',
  TickLower = 'tickLower',
  TickUpper = 'tickUpper',
  Token0 = 'token0',
  Token0Decimals = 'token0__decimals',
  Token0Id = 'token0__id',
  Token0Symbol = 'token0__symbol',
  Token1 = 'token1',
  Token1Decimals = 'token1__decimals',
  Token1Id = 'token1__id',
  Token1Symbol = 'token1__symbol',
  TotalLiquidity = 'totalLiquidity',
  TotalShares = 'totalShares',
  UsedLiquidity = 'usedLiquidity'
}

export type Subscription = {
  __typename?: 'Subscription';
  /** Access to subgraph metadata */
  _meta?: Maybe<_Meta_>;
  dailyDonation?: Maybe<DailyDonation>;
  dailyDonations: Array<DailyDonation>;
  dailyFeeCompound?: Maybe<DailyFeeCompound>;
  dailyFeeCompounds: Array<DailyFeeCompound>;
  donation?: Maybe<Donation>;
  donations: Array<Donation>;
  feeCompound?: Maybe<FeeCompound>;
  feeCompounds: Array<FeeCompound>;
  lpposition?: Maybe<LpPosition>;
  lppositionBurn?: Maybe<LpPositionBurn>;
  lppositionBurns: Array<LpPositionBurn>;
  lppositionMint?: Maybe<LpPositionMint>;
  lppositionMints: Array<LpPositionMint>;
  lppositionTransfer?: Maybe<LpPositionTransfer>;
  lppositionTransfers: Array<LpPositionTransfer>;
  lppositions: Array<LpPosition>;
  mintOption?: Maybe<MintOption>;
  mintOptions: Array<MintOption>;
  mintPosition?: Maybe<MintPosition>;
  mintPositions: Array<MintPosition>;
  option?: Maybe<Option>;
  optionMarket?: Maybe<OptionMarket>;
  optionMarketDailyStat?: Maybe<OptionMarketDailyStat>;
  optionMarketDailyStats: Array<OptionMarketDailyStat>;
  optionMarkets: Array<OptionMarket>;
  options: Array<Option>;
  optionsExercise?: Maybe<OptionsExercise>;
  optionsExercises: Array<OptionsExercise>;
  optionsMint?: Maybe<OptionsMint>;
  optionsMints: Array<OptionsMint>;
  optionsSettle?: Maybe<OptionsSettle>;
  optionsSettles: Array<OptionsSettle>;
  optionsTransfer?: Maybe<OptionsTransfer>;
  optionsTransfers: Array<OptionsTransfer>;
  strike?: Maybe<Strike>;
  strikes: Array<Strike>;
  swapReceivedLog?: Maybe<SwapReceivedLog>;
  swapReceivedLogs: Array<SwapReceivedLog>;
  token?: Maybe<Token>;
  tokens: Array<Token>;
};


export type Subscription_MetaArgs = {
  block?: InputMaybe<Block_Height>;
};


export type SubscriptionDailyDonationArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionDailyDonationsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<DailyDonation_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<DailyDonation_Filter>;
};


export type SubscriptionDailyFeeCompoundArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionDailyFeeCompoundsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<DailyFeeCompound_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<DailyFeeCompound_Filter>;
};


export type SubscriptionDonationArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionDonationsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Donation_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<Donation_Filter>;
};


export type SubscriptionFeeCompoundArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionFeeCompoundsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<FeeCompound_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<FeeCompound_Filter>;
};


export type SubscriptionLppositionArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionLppositionBurnArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionLppositionBurnsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<LpPositionBurn_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<LpPositionBurn_Filter>;
};


export type SubscriptionLppositionMintArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionLppositionMintsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<LpPositionMint_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<LpPositionMint_Filter>;
};


export type SubscriptionLppositionTransferArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionLppositionTransfersArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<LpPositionTransfer_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<LpPositionTransfer_Filter>;
};


export type SubscriptionLppositionsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<LpPosition_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<LpPosition_Filter>;
};


export type SubscriptionMintOptionArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionMintOptionsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<MintOption_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<MintOption_Filter>;
};


export type SubscriptionMintPositionArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionMintPositionsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<MintPosition_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<MintPosition_Filter>;
};


export type SubscriptionOptionArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionOptionMarketArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionOptionMarketDailyStatArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionOptionMarketDailyStatsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OptionMarketDailyStat_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<OptionMarketDailyStat_Filter>;
};


export type SubscriptionOptionMarketsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OptionMarket_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<OptionMarket_Filter>;
};


export type SubscriptionOptionsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Option_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<Option_Filter>;
};


export type SubscriptionOptionsExerciseArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionOptionsExercisesArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OptionsExercise_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<OptionsExercise_Filter>;
};


export type SubscriptionOptionsMintArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionOptionsMintsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OptionsMint_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<OptionsMint_Filter>;
};


export type SubscriptionOptionsSettleArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionOptionsSettlesArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OptionsSettle_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<OptionsSettle_Filter>;
};


export type SubscriptionOptionsTransferArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionOptionsTransfersArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OptionsTransfer_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<OptionsTransfer_Filter>;
};


export type SubscriptionStrikeArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionStrikesArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Strike_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<Strike_Filter>;
};


export type SubscriptionSwapReceivedLogArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionSwapReceivedLogsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SwapReceivedLog_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<SwapReceivedLog_Filter>;
};


export type SubscriptionTokenArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionTokensArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Token_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<Token_Filter>;
};

export type SwapReceivedLog = {
  __typename?: 'SwapReceivedLog';
  amountIn: Scalars['BigInt']['output'];
  amountOut: Scalars['BigInt']['output'];
  id: Scalars['ID']['output'];
  swapper: Scalars['String']['output'];
  timestamp: Scalars['BigInt']['output'];
  tokenIn: Scalars['String']['output'];
  tokenOut: Scalars['String']['output'];
};

export type SwapReceivedLog_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  amountIn?: InputMaybe<Scalars['BigInt']['input']>;
  amountIn_gt?: InputMaybe<Scalars['BigInt']['input']>;
  amountIn_gte?: InputMaybe<Scalars['BigInt']['input']>;
  amountIn_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  amountIn_lt?: InputMaybe<Scalars['BigInt']['input']>;
  amountIn_lte?: InputMaybe<Scalars['BigInt']['input']>;
  amountIn_not?: InputMaybe<Scalars['BigInt']['input']>;
  amountIn_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  amountOut?: InputMaybe<Scalars['BigInt']['input']>;
  amountOut_gt?: InputMaybe<Scalars['BigInt']['input']>;
  amountOut_gte?: InputMaybe<Scalars['BigInt']['input']>;
  amountOut_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  amountOut_lt?: InputMaybe<Scalars['BigInt']['input']>;
  amountOut_lte?: InputMaybe<Scalars['BigInt']['input']>;
  amountOut_not?: InputMaybe<Scalars['BigInt']['input']>;
  amountOut_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  and?: InputMaybe<Array<InputMaybe<SwapReceivedLog_Filter>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  or?: InputMaybe<Array<InputMaybe<SwapReceivedLog_Filter>>>;
  swapper?: InputMaybe<Scalars['String']['input']>;
  swapper_contains?: InputMaybe<Scalars['String']['input']>;
  swapper_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  swapper_ends_with?: InputMaybe<Scalars['String']['input']>;
  swapper_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  swapper_gt?: InputMaybe<Scalars['String']['input']>;
  swapper_gte?: InputMaybe<Scalars['String']['input']>;
  swapper_in?: InputMaybe<Array<Scalars['String']['input']>>;
  swapper_lt?: InputMaybe<Scalars['String']['input']>;
  swapper_lte?: InputMaybe<Scalars['String']['input']>;
  swapper_not?: InputMaybe<Scalars['String']['input']>;
  swapper_not_contains?: InputMaybe<Scalars['String']['input']>;
  swapper_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  swapper_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  swapper_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  swapper_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  swapper_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  swapper_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  swapper_starts_with?: InputMaybe<Scalars['String']['input']>;
  swapper_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  timestamp?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_gt?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_gte?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  timestamp_lt?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_lte?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_not?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  tokenIn?: InputMaybe<Scalars['String']['input']>;
  tokenIn_contains?: InputMaybe<Scalars['String']['input']>;
  tokenIn_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  tokenIn_ends_with?: InputMaybe<Scalars['String']['input']>;
  tokenIn_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  tokenIn_gt?: InputMaybe<Scalars['String']['input']>;
  tokenIn_gte?: InputMaybe<Scalars['String']['input']>;
  tokenIn_in?: InputMaybe<Array<Scalars['String']['input']>>;
  tokenIn_lt?: InputMaybe<Scalars['String']['input']>;
  tokenIn_lte?: InputMaybe<Scalars['String']['input']>;
  tokenIn_not?: InputMaybe<Scalars['String']['input']>;
  tokenIn_not_contains?: InputMaybe<Scalars['String']['input']>;
  tokenIn_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  tokenIn_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  tokenIn_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  tokenIn_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  tokenIn_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  tokenIn_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  tokenIn_starts_with?: InputMaybe<Scalars['String']['input']>;
  tokenIn_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  tokenOut?: InputMaybe<Scalars['String']['input']>;
  tokenOut_contains?: InputMaybe<Scalars['String']['input']>;
  tokenOut_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  tokenOut_ends_with?: InputMaybe<Scalars['String']['input']>;
  tokenOut_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  tokenOut_gt?: InputMaybe<Scalars['String']['input']>;
  tokenOut_gte?: InputMaybe<Scalars['String']['input']>;
  tokenOut_in?: InputMaybe<Array<Scalars['String']['input']>>;
  tokenOut_lt?: InputMaybe<Scalars['String']['input']>;
  tokenOut_lte?: InputMaybe<Scalars['String']['input']>;
  tokenOut_not?: InputMaybe<Scalars['String']['input']>;
  tokenOut_not_contains?: InputMaybe<Scalars['String']['input']>;
  tokenOut_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  tokenOut_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  tokenOut_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  tokenOut_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  tokenOut_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  tokenOut_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  tokenOut_starts_with?: InputMaybe<Scalars['String']['input']>;
  tokenOut_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
};

export enum SwapReceivedLog_OrderBy {
  AmountIn = 'amountIn',
  AmountOut = 'amountOut',
  Id = 'id',
  Swapper = 'swapper',
  Timestamp = 'timestamp',
  TokenIn = 'tokenIn',
  TokenOut = 'tokenOut'
}

export type Token = {
  __typename?: 'Token';
  decimals: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  symbol: Scalars['String']['output'];
};

export type Token_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<Token_Filter>>>;
  decimals?: InputMaybe<Scalars['Int']['input']>;
  decimals_gt?: InputMaybe<Scalars['Int']['input']>;
  decimals_gte?: InputMaybe<Scalars['Int']['input']>;
  decimals_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  decimals_lt?: InputMaybe<Scalars['Int']['input']>;
  decimals_lte?: InputMaybe<Scalars['Int']['input']>;
  decimals_not?: InputMaybe<Scalars['Int']['input']>;
  decimals_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  or?: InputMaybe<Array<InputMaybe<Token_Filter>>>;
  symbol?: InputMaybe<Scalars['String']['input']>;
  symbol_contains?: InputMaybe<Scalars['String']['input']>;
  symbol_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  symbol_ends_with?: InputMaybe<Scalars['String']['input']>;
  symbol_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  symbol_gt?: InputMaybe<Scalars['String']['input']>;
  symbol_gte?: InputMaybe<Scalars['String']['input']>;
  symbol_in?: InputMaybe<Array<Scalars['String']['input']>>;
  symbol_lt?: InputMaybe<Scalars['String']['input']>;
  symbol_lte?: InputMaybe<Scalars['String']['input']>;
  symbol_not?: InputMaybe<Scalars['String']['input']>;
  symbol_not_contains?: InputMaybe<Scalars['String']['input']>;
  symbol_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  symbol_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  symbol_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  symbol_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  symbol_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  symbol_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  symbol_starts_with?: InputMaybe<Scalars['String']['input']>;
  symbol_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
};

export enum Token_OrderBy {
  Decimals = 'decimals',
  Id = 'id',
  Symbol = 'symbol'
}

export type _Block_ = {
  __typename?: '_Block_';
  /** The hash of the block */
  hash?: Maybe<Scalars['Bytes']['output']>;
  /** The block number */
  number: Scalars['Int']['output'];
  /** The hash of the parent block */
  parentHash?: Maybe<Scalars['Bytes']['output']>;
  /** Integer representation of the timestamp stored in blocks for the chain */
  timestamp?: Maybe<Scalars['Int']['output']>;
};

/** The type for the top-level _meta field */
export type _Meta_ = {
  __typename?: '_Meta_';
  /**
   * Information about a specific subgraph block. The hash of the block
   * will be null if the _meta field has a block constraint that asks for
   * a block number. It will be filled if the _meta field has no block constraint
   * and therefore asks for the latest  block
   *
   */
  block: _Block_;
  /** The deployment ID */
  deployment: Scalars['String']['output'];
  /** If `true`, the subgraph encountered indexing errors at some past block */
  hasIndexingErrors: Scalars['Boolean']['output'];
};

export enum _SubgraphErrorPolicy_ {
  /** Data will be returned even if the subgraph has indexing errors */
  Allow = 'allow',
  /** If the subgraph has indexing errors, data will be omitted. The default. */
  Deny = 'deny'
}
